webpackJsonp([1],{

/***/ "/2c4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0YL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PlaceMarkInput',
    props: ['placeMarkData', 'showposition'],
    data: function data() {
        return {
            titleName: 'Input PlaceMark Information',
            msg: 'This is PlaceMark Input!',
            uploadUri: undefined,
            placeMarkInfo: {
                name: undefined,
                coordinate: {},
                type: "default",
                description: undefined,
                vedios: undefined
            },
            placeMarkType: []
            // placeMarkCoordinate: undefined,
            // selectedPlaceMarkType: "",
        };
    },

    mounted: function mounted() {
        var placeMarkTypeMap = pfAirViewer._dataSave._placeMarkImage;
        //var objectToStream = new Cesium.ObjectToStream();
        //vue test
        placeMarkTypeMap['default'] = "./static/images/placeMark/placemark.png";
        placeMarkTypeMap['bus'] = "./static/images/placeMark/placemarkbusT.png";
        placeMarkTypeMap['food'] = "./static/images/placeMark/placemarkfoodT.png";
        placeMarkTypeMap['hospital'] = "./static/images/placeMark/placemarkhospitalT.png";
        placeMarkTypeMap['railway'] = "./static/images/placeMark/placemarkrailwayT.png";
        placeMarkTypeMap['scenic'] = "./static/images/placeMark/placemarkscenicT.png";
        placeMarkTypeMap['station'] = "./static/images/placeMark/placemarkstationT.png";
        placeMarkTypeMap['supermarket'] = "./static/images/placeMark/placemarksupermarketT.png";

        this.uploadUri = pfAirViewer._dataSave._baseUri + "action/upload";
        //$('.selectpicker').selectpicker();
        // this.createDrawTool("draw_option");

        var that = this;
        $('.select > p').on('click', function (e) {
            $(this).parent('.select').toggleClass('open');
            e.stopPropagation();
        });
        $('.select > ul li').on('click', function (e) {
            var _this = $(this);
            $(this).parent().siblings('p').text(_this.attr('data-value'));
            that.placeMarkInfo.type = _this.attr('data-value');
            _this.addClass('selected').siblings().removeClass('selected');
            $('.select').removeClass('open');
            e.stopPropagation();
        });
        if (Cesium.defined(this.placeMarkData.position)) {
            this.placeMarkInfo.coordinate = Cesium.Cartographic.fromCartesian(this.placeMarkData.position);
        }

        /*$("#balloon_fileupload").change(function(){
            alert("Submitted");
            $("#myupload").submit(function(e){
                alert("good");
            });
        });*/
        $("#balloon_fileupload").change(function () {
            $("#myupload").ajaxSubmit({
                dataType: 'json',
                beforeSend: function beforeSend() {
                    $(".customProgress").show();
                    var percentVal = '0%';
                    $('.bar').width(percentVal);
                    $('.percent').html(percentVal);
                    $(".btn span").html("uploading...");
                },
                uploadProgress: function uploadProgress(event, position, total, percentComplete) {
                    var percentVal = percentComplete + '%';
                    $('.bar').width(percentVal);
                    $('.percent').html(percentVal);
                },
                success: function success(data) {
                    $(".files").html("<b>(" + data.size + "k)</b>");
                    //$("#balloon_mediaInfo").val(data.name);
                    that.placeMarkInfo.vedios = data.name;
                    // var img = "./files/"+data.pic;
                    $(".btn span").html("UpLoad");
                    $('.percent').html("100% OK");
                },
                error: function error(xhr) {
                    $(".btn span").html("UpLoad Fail");
                    $('.bar').width('0');
                    $(".files").html(xhr.responseText);
                    alert(xhr.responseText);
                }
            });
        });
        if (this.showposition) {
            this.initCoordinate(this.placeMarkData.position);
        }
    },
    methods: {
        close: function close() {
            this.$emit('closeDialog', '');
        },
        createPlaceMark: function createPlaceMark() {
            if (this.placeMarkInfo.description == undefined) {
                alert("description is empty!");
                return;
            }

            if (this.showposition) {
                var new_lon = Number(this.placeMarkInfo.coordinate.longitude);
                var new_lat = Number(this.placeMarkInfo.coordinate.latitude);
                var new_height = Number(this.placeMarkInfo.coordinate.height);
                if (new_lon < -180 || new_lon > 180) {
                    alert('longitude out of range');
                    return;
                }
                if (new_lat < -90 || new_lat > 90) {
                    alert('latitude out of range');
                    return;
                }
                var new_point = new Cesium.Cartesian3();
                Cesium.Cartesian3.fromDegrees(new_lon, new_lat, new_height, Cesium.Ellipsoid.WGS84, new_point);
                this.placeMarkInfo.coordinate = new_point;
            }
            //modify coordinate

            this.$emit('savePlaceMark', this.placeMarkInfo);
        },
        getLontitude: function getLontitude() {
            if (this.placeMarkInfo.coordinate) {
                var longitude = Cesium.Math.toDegrees(this.placeMarkInfo.coordinate.longitude);
                return longitude.toFixed(5);
            }
        },
        getLatitude: function getLatitude() {
            if (this.placeMarkInfo.coordinate) {
                var latitude = Cesium.Math.toDegrees(this.placeMarkInfo.coordinate.latitude);
                return latitude.toFixed(5);
            }
        },
        getHeight: function getHeight() {
            if (this.placeMarkInfo.coordinate) {
                return this.placeMarkInfo.coordinate.height.toFixed(5);
            }
        },
        initCoordinate: function initCoordinate(positionCartesian3) {
            var tempCart = Cesium.Cartographic.fromCartesian(this.placeMarkData.position);
            this.placeMarkInfo.coordinate.longitude = Cesium.Math.toDegrees(tempCart.longitude).toFixed(5);
            this.placeMarkInfo.coordinate.latitude = Cesium.Math.toDegrees(tempCart.latitude).toFixed(5);
            this.placeMarkInfo.coordinate.height = tempCart.height.toFixed(5);
        },
        getCoordinateString: function getCoordinateString() {
            if (this.placeMarkInfo.coordinate) {
                return this.placeMarkInfo.coordinate.longitude.toFixed(5) + " | " + this.placeMarkInfo.coordinate.latitude.toFixed(5) + " | " + this.placeMarkInfo.coordinate.height.toFixed(2);
            }
        }
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "3hyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataSave.vue
var DataSave = __webpack_require__("iIrE");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642964d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataSave.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DataSave"},[_c('div',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('span',{staticClass:"exit",on:{"click":function($event){_vm.close(false)}}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"DataInfo"},[_c('div',{staticClass:"gray_border round_s scollbarY"},[_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveData.name),expression:"saveData.name"}],staticClass:"fill_text box_size round_s",attrs:{"id":"newLayerName","type":"text","placeholder":"Input Name"},domProps:{"value":(_vm.saveData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.saveData, "name", $event.target.value)}}})]),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('div',{staticClass:"select box_size round_s select_box",staticStyle:{"width":"100%","margin-left":"auto","margin-right":"auto"},attrs:{"id":"newLayerType"}},[_c('p',[_vm._v(_vm._s(_vm.displaySelectedType))]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"r_d_btn btn_layer cf2"},[_c('span',{staticClass:"l w_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"SAVE"},on:{"click":function($event){_vm.saveDataToUser()}}})]),_vm._v(" "),_c('span',{staticClass:"r w_5"},[_c('input',{staticClass:"round_s fill_btn_r gray_btn_g",attrs:{"type":"button","value":"CANCEL"},on:{"click":function($event){_vm.close(false)}}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"selected",attrs:{"data-value":""}},[_vm._v("Select Layer Type")]),_vm._v(" "),_c('li',{attrs:{"data-value":"czml"}},[_vm._v("czml")]),_vm._v(" "),_c('li',{attrs:{"data-value":"fly"}},[_vm._v("Fly")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DataSave = (esExports);
// CONCATENATED MODULE: ./src/components/DataSave.vue
function injectStyle (ssrContext) {
  __webpack_require__("HCsZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-642964d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DataSave["a" /* default */],
  components_DataSave,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DataSave = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4h7O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6eoA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8+0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8eDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardBar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ var DashboardBar = ({
	name: 'DashboardBar',
	data: function data() {
		return {
			msg: 'This is Dashboard tool bar!',
			isActive: true,
			isDisplayCoordinate: true,
			isDisplayFrameRate: true,
			isDisplayTime: false,
			currentTime: "",
			cesiumClock: pfAirViewer.clock.currentTime,
			monitorData: {
				frameFps: "",
				mouseCoord: {
					longitude: 1,
					latitude: 1,
					height: 1
				}
			},
			coordinate: {
				lon: "-1.8402538",
				lat: "-0.4820130",
				h: "-4269.87"
			},
			fpsValue: "60"
		};
	},

	watch: {
		monitorData: {
			handler: function handler(val, oldval) {
				//this.currentTime = Cesium.JulianDate.toDate(val);
				//this.updateTime();
			},
			deep: true
		}
	},
	mounted: function mounted() {
		pfAirViewer.createMonitoring({
			feedbackData: this.monitorData
		});
		//this.cesiumClock = pfAirViewer.clock.currentTime;
		var that = this;
		// that.updateTime();
		this.currentTime = "Time waring!";
		setInterval(function () {
			that.updateTime();
		}, 1000);
		//setInterval('this.updateTime()', 3000);
	},
	methods: {
		updateTime: function updateTime() {
			//this.currentTime = Cesium.JulianDate.toDate(pfAirViewer.clock.currentTime).toString();
			this.currentTime = Cesium.JulianDate.toDate(pfAirViewer.clock.currentTime).toLocaleString();
		},
		updateCurrentTime: function updateCurrentTime() {
			pfAirViewer.clock.currentTime = Cesium.JulianDate.now();
			pfAirViewer.clock.clockRange = Cesium.ClockRange.UNBOUNDED;
		},
		switchTime: function switchTime() {
			pfAirViewer.clock.shouldAnimate = !pfAirViewer.clock.shouldAnimate;
		},
		radianToAngleStr: function radianToAngleStr(value) {
			return Cesium.Math.toDegrees(value);
		}
	},
	components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f25b98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"dashboardbar"},[(_vm.isDisplayCoordinate)?_c('div',{staticClass:"CoordinateDisplay"},[_c('div',{staticClass:"slot"},[_vm._v("Lon: "+_vm._s(_vm._f("fixedFloat")(_vm.radianToAngleStr(_vm.monitorData.mouseCoord.longitude),5)))]),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._v("Lat: "+_vm._s(_vm._f("fixedFloat")(_vm.radianToAngleStr(_vm.monitorData.mouseCoord.latitude),5)))]),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._v("H: "+_vm._s(_vm._f("fixedFloat")(_vm.monitorData.mouseCoord.height,2))+"m")])]):_vm._e(),_vm._v(" "),(_vm.isDisplayTime)?_c('div',{staticClass:"clockDisplay"},[_c('div',{staticClass:"slot timebotton",on:{"click":function($event){_vm.switchTime()}}},[_c('div',{staticClass:"time",attrs:{"title":"Switch"}},[_vm._v("Time")]),_vm._v(":\n\t\t\t")]),_vm._v("\n\t\t\t"+_vm._s(_vm.currentTime)+"\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.isDisplayFrameRate)?_c('div',{staticClass:"FrameRateDisplay"},[_vm._v("FPS:"+_vm._s(_vm.monitorData.frameFps))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DashboardBar = (esExports);
// CONCATENATED MODULE: ./src/components/DashboardBar.vue
function injectStyle (ssrContext) {
  __webpack_require__("/2c4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44f25b98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DashboardBar,
  components_DashboardBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DashboardBar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Xzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UserClub__ = __webpack_require__("gu9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login__ = __webpack_require__("xJsL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UserProfile",
  props: {
    userData: {
      default: ""
    }
  },
  data: function data() {
    return {
      msg: "This is Dashboard tool bar!",
      isShowUserSlave: false,
      isShowUserClub: false,
      isShowLoign: false
    };
  },

  mounted: function mounted() {
    this.$axios({
      // url: "http://172.18.0.169/fakeData/login.json"
      url: pfAirViewer._dataSave._baseUri + "getUser",
      method: "get",
      //headers: { 'Authorization': "Basic "},
      withCredentials: true
    }).then(this.updateUserInfo, this.errorHandle);
    /*$.get({
            url: 'http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/test.json',
            beforeSend: function(xhr){xhr.setRequestHeader("Authorization", "Basic " + btoa(1 + ":" + "airbus"))},
            },function(data){
        });
        this.$axios(
            {
                url: "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/56/zx3.czml",
                method: 'get',
                //headers: { 'Authorization': "Basic " + btoa("1" + ":" + "airbus")},
                withCredentials: true
            });*/
  },
  methods: {
    login: function login(event) {
      // this.isLogin = !this.isLogin;
      /*this.$axios.get(
              //"http://172.18.0.169/fakeData/login.json"
              pfAirViewer._dataSave._baseUri+"/data/httpAuth"
            ).then(this.updateUserInfo,this.errorHandle);*/
      this.$axios({
        // url: "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/test.json",
        url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
        method: 'get',
        //headers: { 'Authorization': "Basic " + btoa("1" + ":" + "airbus")},
        withCredentials: true
      }).then(this.updateUserInfo, this.errorHandle);
    },
    loginOut: function loginOut() {
      //this.sendAjax();
      pfAirViewer._personLayerManager.removeAll();
      $.ajax({
        type: "GET",
        url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
        dataType: "json",
        async: false,
        xhrFields: {
          withCredentials: true
        },
        // username:"11",
        // password:"aaaaa",
        // headers: { "Authorization": "Basic xxx" }
        username: "some_username_that_doesn't_exist",
        password: "any_stupid_password"
      }).done(function (info) {
        console.log(info);
      }).fail(function (info) {
        console.log(info);
      });
      this.$axios.get(pfAirViewer._dataSave._baseUri + "/logout").then(this.updateUserInfo, this.errorHandle);
    },
    sendAjax: function sendAjax() {
      /*var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "http://123:123@172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/httpAuth",
        true
      );
      //xhr.setRequestHeader('Authorization', "Basic "+btoa("123:123"));
      //Authorization: "Basic "+btoa("123:123")
      xhr.withCredentials = true;
      xhr.send();
      */
    },
    register: function register() {},
    updateUserInfo: function updateUserInfo(userInfo) {
      //debugger;
      pfAirViewer._personLayerManager.initializeData(userInfo.data.layerData);
      this.userData.userInfo = userInfo.data;
      this.isShowUserSlave = false;
      if (userInfo.data.isGuest === "yes") {
        this.login();
        return;
      }
    },
    errorHandle: function errorHandle(info) {
      console.log(info);
    },
    closeClub: function closeClub() {
      this.isShowUserClub = false;
    },
    closeLogin: function closeLogin() {
      this.isShowLoign = false;
    }
  },
  components: {
    UserClub: __WEBPACK_IMPORTED_MODULE_0__components_UserClub__["a" /* default */],
    Login: __WEBPACK_IMPORTED_MODULE_1__components_Login__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "9sTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RightNavigation.vue
var RightNavigation = __webpack_require__("eVkA");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71fcaa13","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightNavigation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RightNavigation"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayMode === 'PERSONDATA'),expression:"displayMode === 'PERSONDATA'"}],staticStyle:{"height":"100%"}},[_c('h4',{staticClass:"Navigation_head"},[_c('a',{staticClass:"Navigation_close",on:{"click":_vm.closeDisplay}}),_vm._v(" "),_c('span',{staticClass:"Navigation_arrow"}),_vm._v(" "),_c('p',[_vm._v("User Layer")])]),_vm._v(" "),_c('transition',{attrs:{"name":"list"}},[_c('div',{staticClass:"r_nav_group blue_link scroll_box_b scollbarY",staticStyle:{"height":"95%","overflow-y":"auto"},attrs:{"id":"personal_layer","tabindex":"1"}},[_c('dl',{staticClass:"UserLayer_group f_checkbox",class:{ click_show: _vm.isShowAirPackageList }},[_c('dt',{on:{"click":function($event){_vm.isShowAirPackageList = !_vm.isShowAirPackageList}}},[_vm._v("AirPackage")]),_vm._v(" "),_vm._l((_vm.userInfo.layerData),function(item,index){return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowAirPackageList),expression:"isShowAirPackageList"}],key:index},[(item.type === 'AirPackage')?_c('p',{class:{active: _vm.allPersonLayerStatus[item.name]&&_vm.allPersonLayerStatus[item.name].status=='show'},on:{"click":function($event){_vm.setPersonLayerStatus(item, '')}}},[_c('a',{staticClass:"round_layer"},[_c('span',{staticClass:"UserLayer e_3"}),_vm._v("\n                                  "+_vm._s(item.name)+"\n                              ")])]):_vm._e()])})],2),_vm._v(" "),_c('dl',{staticClass:"UserLayer_group f_checkbox",class:{ click_show: _vm.isShow3DtilesList }},[_c('dt',{on:{"click":function($event){_vm.isShow3DtilesList = !_vm.isShow3DtilesList}}},[_vm._v("3DTiles")]),_vm._v(" "),_vm._l((_vm.userInfo.layerData),function(item,index){return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow3DtilesList),expression:"isShow3DtilesList"}],key:index},[(item.type === '3dtile')?_c('p',{class:{active: _vm.allPersonLayerStatus[item.name]&&_vm.allPersonLayerStatus[item.name].status=='show'},on:{"click":function($event){_vm.setPersonLayerStatus(item, '')}}},[_c('a',{staticClass:"round_layer"},[_c('span',{staticClass:"UserLayer e_2"}),_vm._v("\n                                      "+_vm._s(item.name)+"\n                                  ")])]):_vm._e()])})],2),_vm._v(" "),_c('dl',{staticClass:"UserLayer_group f_checkbox",class:{ click_show: _vm.isShowCZMLList }},[_c('dt',{on:{"click":function($event){_vm.isShowCZMLList = !_vm.isShowCZMLList}}},[_vm._v("CZML")]),_vm._v(" "),_vm._l((_vm.userInfo.layerData),function(item,index){return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowCZMLList),expression:"isShowCZMLList"}],key:index},[(item.type === 'czml')?_c('p',{class:{active: _vm.allPersonLayerStatus[item.name]&&_vm.allPersonLayerStatus[item.name].status=='show'},on:{"click":function($event){_vm.setPersonLayerStatus(item, '')}}},[_c('a',{staticClass:"round_layer"},[_c('span',{staticClass:"UserLayer e_1"}),_vm._v("\n                                  "+_vm._s(item.name)+"\n                              ")])]):_vm._e()])})],2),_vm._v(" "),_c('dl',{staticClass:"UserLayer_group f_checkbox",class:{ click_show: _vm.isShowGeoJsonList }},[_c('dt',{on:{"click":function($event){_vm.isShowGeoJsonList = !_vm.isShowGeoJsonList}}},[_vm._v("GEO")]),_vm._v(" "),_vm._l((_vm.userInfo.layerData),function(item,index){return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowGeoJsonList),expression:"isShowGeoJsonList"}],key:index},[(item.type === 'AirGeoJson')?_c('p',{class:{active: _vm.allPersonLayerStatus[item.name]&&_vm.allPersonLayerStatus[item.name].status=='show'},on:{"click":function($event){_vm.setPersonLayerStatus(item, '')}}},[_c('a',{staticClass:"round_layer"},[_c('span',{staticClass:"UserLayer e_4"}),_vm._v("\n                                  "+_vm._s(item.name)+"\n                              ")])]):_vm._e()])})],2),_vm._v(" "),_c('dl',{staticClass:"UserLayer_group f_radio",class:{ click_show: _vm.isShowFlyList }},[_c('dt',{on:{"click":function($event){_vm.isShowFlyList = !_vm.isShowFlyList}}},[_vm._v("FLY")]),_vm._v(" "),_vm._l((_vm.userInfo.layerData),function(item,index){return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFlyList),expression:"isShowFlyList"}],key:index},[(item.type === 'fly')?_c('p',{class:{active: _vm.allPersonLayerStatus[item.name]&&_vm.allPersonLayerStatus[item.name].status=='show'},on:{"click":function($event){_vm.setPersonLayerStatus(item, '')}}},[_c('a',{staticClass:"round_layer"},[_c('span',{staticClass:"UserLayer e_5"}),_vm._v("\n                                  "+_vm._s(item.name)+"\n                              ")])]):_vm._e()])})],2)])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayMode === 'GLOBAlDATA'),expression:"displayMode === 'GLOBAlDATA'"}],staticStyle:{"height":"100%"}},[_c('h4',{staticClass:"Navigation_head"},[_c('a',{staticClass:"Navigation_close",on:{"click":_vm.closeDisplay}}),_vm._v(" "),_c('span',{staticClass:"Navigation_arrow Navigation_global_arrow"}),_vm._v(" "),_c('p',[_vm._v("Global Layer")]),_vm._v(" "),_vm._l((_vm.allGlobeLayers),function(item,index){return _c('div',{key:index,staticClass:"scroll_box_b scollbarY"},_vm._l((item.layers),function(item_1,index_1){return _c('ul',{key:index_1,staticClass:"r_map_group round_s_img click_li",attrs:{"id":"globeLayer"}},[_c('li',{class:{active: item_1.cesiumData.isShow != 'false'},attrs:{"data-drive":"WMTS_IMAGE"},on:{"click":function($event){_vm.setGlobeLayerStatus(index_1, index)}}},[_c('a',{staticClass:"round_s"},[_c('span',{staticClass:"f_w_text btn_r"},[_vm._v(_vm._s(item_1.name))]),_vm._v(" "),_c('img',{attrs:{"src":item_1.dataProfile,"alt":""}})])])])}))})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayMode === 'LEGEND'),expression:"displayMode === 'LEGEND'"}],staticStyle:{"height":"100%"}},[_c('h4',{staticClass:"Navigation_head"},[_c('a',{staticClass:"Navigation_close",on:{"click":_vm.closeDisplay}}),_vm._v(" "),_c('span',{staticClass:"Navigation_arrow Navigation_legend_arrow"}),_vm._v(" "),_c('p',[_vm._v("Modern Function")]),_vm._v(" "),_c('modera-function')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_RightNavigation = (esExports);
// CONCATENATED MODULE: ./src/components/RightNavigation.vue
function injectStyle (ssrContext) {
  __webpack_require__("hz3J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71fcaa13"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RightNavigation["a" /* default */],
  components_RightNavigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_RightNavigation = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AjEo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UserClub',
    props: ['userData'],
    data: function data() {
        return {
            msg: 'This is User club!',
            titleName: 'Layer Data Management',
            isShowCreateLayer: false,
            isShowCreateDemoPackage: false,
            selectedLayerType: "",
            layerTypeList: ["3DTiles"],
            allLayerStatus: {},
            layerInfoTemp: {
                name: undefined,
                type: undefined,
                data: undefined
            },
            demoPackageInfo: {
                name: undefined,
                dataList: []
            },
            wfcTest: ''
        };
    },

    mounted: function mounted() {
        var that = this;
        $('.select > p').on('click', function (e) {
            $(this).parent('.select').toggleClass('open');
            e.stopPropagation();
        });
        $('.select > ul li').on('click', function (e) {
            var _this = $(this);
            $(this).parent().siblings('p').text(_this.attr('data-value'));
            that.layerInfoTemp.type = _this.attr('data-value');
            _this.addClass('selected').siblings().removeClass('selected');
            $('.select').removeClass('open');
            e.stopPropagation();
        });
    },
    methods: {
        close: function close() {
            this.$emit('closeClub', '');
        },
        toggleLayerStatus: function toggleLayerStatus(layerName) {
            if (!this.allLayerStatus[layerName]) {
                this.$set(this.allLayerStatus, layerName, true);
            } else {
                this.allLayerStatus[layerName] = false;
            }
        },
        cleateNewLayer: function cleateNewLayer(layerName, layerType, layerData, controlObject) {
            var that = this;
            pfAirViewer._dataSave.saveData({
                name: layerName,
                type: layerType,
                data: layerData
            }).then(function (responseData) {
                if (responseData.status === "ok") //save ok
                    {
                        responseData.data.status = "no";
                        that.userData.userInfo.layerData.unshift(responseData.data);
                        pfAirViewer._personLayerManager.addLayerData(responseData.data.name, responseData.data);
                        controlObject.controlValue = false;
                        that.isShowCreateDemoPackage = false;
                    } else {
                    //Hints are abnormal
                }
            });
        },
        cleateDemoPackage: function cleateDemoPackage() {
            this.layerInfoTemp.name = this.demoPackageInfo.name;
            this.layerInfoTemp.type = "AirPackage";
            this.layerInfoTemp.data = {
                type: this.layerInfoTemp.type,
                childs: {
                    tiles: [],
                    czmls: [],
                    flys: [],
                    view: []
                }
            };
            for (var key in this.demoPackageInfo.dataList) {
                var tempType = pfAirViewer._personLayerManager._layerData[this.demoPackageInfo.dataList[key]].type;
                if (tempType == "3dtile") {
                    this.layerInfoTemp.data.childs.tiles.push(this.demoPackageInfo.dataList[key]);
                } else if (tempType == "czml") {
                    this.layerInfoTemp.data.childs.czmls.push(this.demoPackageInfo.dataList[key]);
                } else if (tempType == "fly") {
                    this.layerInfoTemp.data.childs.czmls.push(this.demoPackageInfo.flys[key]);
                }
            }
            this.cleateNewLayer(this.layerInfoTemp.name, this.layerInfoTemp.type, this.layerInfoTemp.data, { controlValue: this.isShowCreateDemoPackage });
        },
        switchCreateDemoPlane: function switchCreateDemoPlane() {
            this.isShowCreateDemoPackage = !this.isShowCreateDemoPackage;
            this.demoPackageInfo.dataList = [];
            for (var key in this.allLayerStatus) {
                if (this.allLayerStatus[key]) {
                    this.demoPackageInfo.dataList.push(key);
                }
            }
        },
        removeLayers: function removeLayers() {
            var that = this;
            var removeLayers = [];
            for (var key in this.allLayerStatus) {
                if (this.allLayerStatus[key]) {
                    removeLayers.push(key);
                }
            }
            /*this.$axios(
            {
                url : pfAirViewer._dataSave._baseUri+"/deleteLayer",
                method: 'post',
                withCredentials: true,
                data: {name: removeLayers}
            }).then(function(responseData){
                // pfAirViewer._personLayerManager.RemoveLayersData(responseData.data);
                for(var key in responseData.data.data){
                    for(var i in that.userData.userInfo.layerData)
                    {
                        if(that.userData.userInfo.layerData[i].name == responseData.data.data[key])
                        {
                            //that.userData.userInfo.layerData[i] = undefined;
                            that.userData.userInfo.layerData.splice(i, 1);
                            break;
                        }
                    }
                }
            },this.errorHandle);*/
            $.post({
                url: pfAirViewer._dataSave._baseUri + "/deleteLayer",
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    name: removeLayers
                },
                // success: this.updateUserInfo,
                dataType: "json"
            }).done(function (responseData) {
                for (var key in responseData.data) {
                    for (var i in that.userData.userInfo.layerData) {
                        if (that.userData.userInfo.layerData[i].name == responseData.data[key]) {
                            that.userData.userInfo.layerData.splice(i, 1);
                            break;
                        }
                    }
                }
                pfAirViewer._personLayerManager.removeLayersData(responseData.data);
                that.allLayerStatus = [];
            });
        },
        errorHandle: function errorHandle(info) {
            console.log(info);
        }
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "Bszb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("4kSj")))

/***/ }),

/***/ "CCCt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CW6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/components/DataSave.vue + 1 modules
var DataSave = __webpack_require__("3hyP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeftDisplayPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ var LeftDisplayPanel = ({
    name: 'LeftDisplayPanel',
    props: {
        userData: {
            default: ''
        }
    },
    data: function data() {
        return {
            msg: 'This is left display panel!',
            titleName: 'Save Data',
            isShowDataSaveUI: false,
            displayDataType: "drawModel",
            displayData: [
                /*{
                    name: "test name",
                    time: "test time"
                }*/
            ],
            saveData: undefined,
            currentSaveDataName: undefined,
            displayDataBackup: [],
            selectedDataName: "",
            area: 0.0
        };
    },

    watch: {
        displayData: {
            handler: function handler(val, oldval) {
                if (val.length === this.displayDataBackup.length) {
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].time !== this.displayDataBackup[i].time) {
                            this.updateDataTime(val[i]);
                        }
                    }
                    var tempStr = stringify_default()(val);
                    this.displayDataBackup = JSON.parse(tempStr);
                    //this.displayDataBackup = this.displayData;
                } else {
                    //[ ...this.displayDataBackup ] = this.displayData;
                    var tempStr = stringify_default()(val);
                    this.displayDataBackup = JSON.parse(tempStr);
                }
            },
            deep: true
        }
    },
    mounted: function mounted() {
        eventBus.$on('addModelPanel', function (data) {
            this.$set(this.displayData, this.displayData.length, data);
            this.$emit('switchBar', true);
        }.bind(this));
        eventBus.$on('addViewPanel', function (data) {
            this.$set(this.displayData, this.displayData.length, data);
            this.$emit('switchBar', true);
        }.bind(this));
        eventBus.$on('removePanel', function () {
            this.displayData = [];
        }.bind(this));
    },
    methods: {
        focusData: function focusData(dataName) {
            pfAirViewer._drawLayerManager.setLayerDataStatus(dataName, "focus");
        },
        processData: function processData(dataName, processType) {
            if (processType == "Calculation") {
                var polygonArea = pfAirViewer._drawLayerManager.getLayerData(dataName).cesiumData["air_CalculatedArea"]();
                for (var i in this.displayData) {
                    if (this.displayData[i].name == dataName) {
                        this.displayData[i].polygonArea = polygonArea;
                        break;
                    }
                }
            }
        },
        removeData: function removeData(dataName) {
            for (var i in this.displayData) {
                if (this.displayData[i].name == dataName) {
                    this.displayData.splice(i, 1);
                    break;
                }
            }
            pfAirViewer._drawLayerManager.removeLayersData([dataName]);

            pfAirViewer.clock.currentTime = Cesium.JulianDate.now();
            pfAirViewer.clock.clockRange = Cesium.ClockRange.UNBOUNDED;
            //pfAirViewer.clock.stopTime = resaultEntity.availability.stop;
            //pfAirViewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        },
        switchSelectedData: function switchSelectedData(dataName) {
            if (this.selectedDataName === dataName) {
                this.selectedDataName = "";
                pfAirViewer._modelManipulator.setCurrentModel({
                    model: undefined
                });
            } else {
                pfAirViewer._modelManipulator.setCurrentModel({
                    model: pfAirViewer._drawLayerManager._layerData[dataName].cesiumData
                });
                this.selectedDataName = dataName;
            }
        },
        updateDataTime: function updateDataTime(data) {
            var entity = pfAirViewer._drawLayerManager._layerData[data.name];
            //var entity = pfAirViewer._drawLayerManager._layerData[this.displayData[i].name];
            var tempDate = new Date(data.time);
            var startJulianData = Cesium.JulianDate.fromDate(tempDate);

            var stopJulianData = Cesium.JulianDate.clone(startJulianData);
            //make model always availability
            Cesium.JulianDate.addDays(stopJulianData, 365 * 100, stopJulianData);
            var timeInterval = new Cesium.TimeInterval({
                start: startJulianData,
                stop: stopJulianData
            });
            var timeIntervalCollection = new Cesium.TimeIntervalCollection();
            timeIntervalCollection.addInterval(timeInterval);
            entity.cesiumData.availability = timeIntervalCollection;
        },
        testFunction: function testFunction(dataName) {
            //console.log(pfAirViewer._drawLayerManager._layerData[dataName].cesiumData.availability);
            console.log("time change");
        },
        saveDataToUser: function saveDataToUser(dataName) {
            this.saveData = {
                type: 'fly',
                sourceId: dataName
            };
            this.currentSaveDataName = dataName;
            this.isShowDataSaveUI = true;
        },
        closeDataSave: function closeDataSave(info) {
            /*
            if(info)
            {
                //this.removeData(this.currentSaveDataName);
            }else{
             }*/
            this.isShowDataSaveUI = false;
        }
    },
    components: {
        DataSave: DataSave["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a449d5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftDisplayPanel.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LeftDisplayPanel"},[(_vm.isShowDataSaveUI)?_c('div',[_c('data-save',{attrs:{"userData":_vm.userData,"saveData":_vm.saveData},on:{"closeDataSave":_vm.closeDataSave}})],1):_vm._e(),_vm._v(" "),(_vm.displayDataType === 'drawModel')?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.displayData),function(item,index){return _c('div',{key:index},[(item.type==='Fly Point')?_c('div',{staticClass:"col-sm-12 form-horizontal"},[_c('div',{staticClass:"panel panel-primary",class:{ on: _vm.selectedDataName===item.name }},[_c('div',{staticClass:"panel-heading",on:{"click":function($event){_vm.switchSelectedData(item.name)}}},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                "+_vm._s(item.type)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Point Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Point Time:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.time),expression:"item.time"}],staticClass:"form-control",attrs:{"type":"text","onchange":"function(){testFunction(item.name)}"},domProps:{"value":(item.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "time", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.focusData(item.name)}}},[_vm._v("Focus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeData(item.name)}}},[_vm._v("Remove")])])])]):_vm._e(),_vm._v(" "),(item.type==='Fly')?_c('div',{staticClass:"col-sm-12 form-horizontal"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                "+_vm._s(item.type)+" : "+_vm._s(item.name)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Start Time:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.startTime),expression:"item.startTime"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.startTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "startTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Stop Time:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.stopTime),expression:"item.stopTime"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.stopTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "stopTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.focusData(item.name)}}},[_vm._v("Focus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.saveDataToUser(item.name)}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeData(item.name)}}},[_vm._v("Remove")])])])]):_vm._e(),_vm._v(" "),(item.type==='Draw_E_Data')?_c('div',{staticClass:"col-sm-12 form-horizontal"},[_c('div',{staticClass:"panel panel-primary",class:{ on: _vm.selectedDataName===item.name }},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                "+_vm._s(item.type)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Data Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.focusData(item.name)}}},[_vm._v("Focus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeData(item.name)}}},[_vm._v("Remove")])])])]):_vm._e(),_vm._v(" "),(item.type==='Draw_P_Data')?_c('div',{staticClass:"col-sm-12 form-horizontal"},[_c('div',{staticClass:"panel panel-primary",class:{ on: _vm.selectedDataName===item.name }},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                "+_vm._s(item.type)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Data Name:item.name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.polygonArea),expression:"item.polygonArea"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.polygonArea)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "polygonArea", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.processData(item.name,'Calculation')}}},[_vm._v("Cal")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeData(item.name)}}},[_vm._v("Remove")])])])]):_vm._e(),_vm._v(" "),(item.type==='View Point')?_c('div',{staticClass:"col-sm-12 form-horizontal"},[_c('div',{staticClass:"panel panel-primary",class:{ on: _vm.selectedDataName===item.name }},[_c('div',{staticClass:"panel-heading",on:{"click":function($event){_vm.switchSelectedData(item.name)}}},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                "+_vm._s(item.type)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',{},[_vm._v("Point Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.focusData(item.name)}}},[_vm._v("Focus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.removeData(item.name)}}},[_vm._v("Remove")])])])]):_vm._e()])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LeftDisplayPanel = (esExports);
// CONCATENATED MODULE: ./src/components/LeftDisplayPanel.vue
function injectStyle (ssrContext) {
  __webpack_require__("uNFy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a449d5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LeftDisplayPanel,
  components_LeftDisplayPanel,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LeftDisplayPanel = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+l2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery Form Plugin
 * version: 3.15 (09-SEP-2012)
 * @requires jQuery v1.3.2 or later
 *
 * Examples and documentation at: http://malsup.com/jquery/form/
 * Project repository: https://github.com/malsup/form
 * Dual licensed under the MIT and GPL licenses:
 *    http://malsup.github.com/mit-license.txt
 *    http://malsup.github.com/gpl-license-v2.txt
 */
/*global ActiveXObject alert */
;(function($) {
"use strict";

/*
    Usage Note:
    -----------
    Do not use both ajaxSubmit and ajaxForm on the same form.  These
    functions are mutually exclusive.  Use ajaxSubmit if you want
    to bind your own submit handler to the form.  For example,

    $(document).ready(function() {
        $('#myForm').on('submit', function(e) {
            e.preventDefault(); // <-- important
            $(this).ajaxSubmit({
                target: '#output'
            });
        });
    });

    Use ajaxForm when you want the plugin to manage all the event binding
    for you.  For example,

    $(document).ready(function() {
        $('#myForm').ajaxForm({
            target: '#output'
        });
    });
    
    You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
    form does not have to exist when you invoke ajaxForm:

    $('#myForm').ajaxForm({
        delegation: true,
        target: '#output'
    });
    
    When using ajaxForm, the ajaxSubmit function will be invoked for you
    at the appropriate time.
*/

/**
 * Feature detection
 */
var feature = {};
feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
feature.formdata = window.FormData !== undefined;

/**
 * ajaxSubmit() provides a mechanism for immediately submitting
 * an HTML form using AJAX.
 */
$.fn.ajaxSubmit = function(options) {
    /*jshint scripturl:true */

    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
    if (!this.length) {
        log('ajaxSubmit: skipping submit process - no element selected');
        return this;
    }
    
    var method, action, url, $form = this;

    if (typeof options == 'function') {
        options = { success: options };
    }

    method = this.attr('method');
    action = this.attr('action');
    url = (typeof action === 'string') ? $.trim(action) : '';
    url = url || window.location.href || '';
    if (url) {
        // clean url (don't include hash vaue)
        url = (url.match(/^([^#]+)/)||[])[1];
    }

    options = $.extend(true, {
        url:  url,
        success: $.ajaxSettings.success,
        type: method || 'GET',
        iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
    }, options);

    // hook for manipulating the form data before it is extracted;
    // convenient for use with rich editors like tinyMCE or FCKEditor
    var veto = {};
    this.trigger('form-pre-serialize', [this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
        return this;
    }

    // provide opportunity to alter form data before it is serialized
    if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSerialize callback');
        return this;
    }

    var traditional = options.traditional;
    if ( traditional === undefined ) {
        traditional = $.ajaxSettings.traditional;
    }
    
    var elements = [];
    var qx, a = this.formToArray(options.semantic, elements);
    if (options.data) {
        options.extraData = options.data;
        qx = $.param(options.data, traditional);
    }

    // give pre-submit callback an opportunity to abort the submit
    if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSubmit callback');
        return this;
    }

    // fire vetoable 'validate' event
    this.trigger('form-submit-validate', [a, this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
        return this;
    }

    var q = $.param(a, traditional);
    if (qx) {
        q = ( q ? (q + '&' + qx) : qx );
    }    
    if (options.type.toUpperCase() == 'GET') {
        options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
        options.data = null;  // data is null for 'get'
    }
    else {
        options.data = q; // data is the query string for 'post'
    }

    var callbacks = [];
    if (options.resetForm) {
        callbacks.push(function() { $form.resetForm(); });
    }
    if (options.clearForm) {
        callbacks.push(function() { $form.clearForm(options.includeHidden); });
    }

    // perform a load on the target only if dataType is not provided
    if (!options.dataType && options.target) {
        var oldSuccess = options.success || function(){};
        callbacks.push(function(data) {
            var fn = options.replaceTarget ? 'replaceWith' : 'html';
            $(options.target)[fn](data).each(oldSuccess, arguments);
        });
    }
    else if (options.success) {
        callbacks.push(options.success);
    }

    options.success = function(data, status, xhr) { // jQuery 1.4+ passes xhr as 3rd arg
        var context = options.context || this ;    // jQuery 1.4+ supports scope context 
        for (var i=0, max=callbacks.length; i < max; i++) {
            callbacks[i].apply(context, [data, status, xhr || $form, $form]);
        }
    };

    // are there files to upload?
    var fileInputs = $('input:file:enabled[value]', this); // [value] (issue #113)
    var hasFileInputs = fileInputs.length > 0;
    var mp = 'multipart/form-data';
    var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);

    var fileAPI = feature.fileapi && feature.formdata;
    log("fileAPI :" + fileAPI);
    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;

    // options.iframe allows user to force iframe mode
    // 06-NOV-09: now defaulting to iframe mode if file input is detected
    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
        // hack to fix Safari hang (thanks to Tim Molendijk for this)
        // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
        if (options.closeKeepAlive) {
            $.get(options.closeKeepAlive, function() {
                fileUploadIframe(a);
            });
        }
          else {
            fileUploadIframe(a);
          }
    }
    else if ((hasFileInputs || multipart) && fileAPI) {
        fileUploadXhr(a);
    }
    else {
        $.ajax(options);
    }

    // clear element array
    for (var k=0; k < elements.length; k++)
        elements[k] = null;

    // fire 'notify' event
    this.trigger('form-submit-notify', [this, options]);
    return this;

    // utility fn for deep serialization
    function deepSerialize(extraData){
        var serialized = $.param(extraData).split('&');
        var len = serialized.length;
        var result = {};
        var i, part;
        for (i=0; i < len; i++) {
            part = serialized[i].split('=');
            result[decodeURIComponent(part[0])] = decodeURIComponent(part[1]);
        }
        return result;
    }

     // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
    function fileUploadXhr(a) {
        var formdata = new FormData();

        for (var i=0; i < a.length; i++) {
            formdata.append(a[i].name, a[i].value);
        }

        if (options.extraData) {
            var serializedData = deepSerialize(options.extraData);
            for (var p in serializedData)
                if (serializedData.hasOwnProperty(p))
                    formdata.append(p, serializedData[p]);
        }

        options.data = null;

        var s = $.extend(true, {}, $.ajaxSettings, options, {
            contentType: false,
            processData: false,
            cache: false,
            type: 'POST'
        });
        
        if (options.uploadProgress) {
            // workaround because jqXHR does not expose upload property
            s.xhr = function() {
                var xhr = jQuery.ajaxSettings.xhr();
                if (xhr.upload) {
                    xhr.upload.onprogress = function(event) {
                        var percent = 0;
                        var position = event.loaded || event.position; /*event.position is deprecated*/
                        var total = event.total;
                        if (event.lengthComputable) {
                            percent = Math.ceil(position / total * 100);
                        }
                        options.uploadProgress(event, position, total, percent);
                    };
                }
                return xhr;
            };
        }

        s.data = null;
            var beforeSend = s.beforeSend;
            s.beforeSend = function(xhr, o) {
                o.data = formdata;
                if(beforeSend)
                    beforeSend.call(this, xhr, o);
        };
        $.ajax(s);
    }

    // private function for handling file uploads (hat tip to YAHOO!)
    function fileUploadIframe(a) {
        var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
        var useProp = !!$.fn.prop;

        if ($(':input[name=submit],:input[id=submit]', form).length) {
            // if there is an input with a name or id of 'submit' then we won't be
            // able to invoke the submit fn on the form (at least not x-browser)
            alert('Error: Form elements must not have name or id of "submit".');
            return;
        }
        
        if (a) {
            // ensure that every serialized input is still enabled
            for (i=0; i < elements.length; i++) {
                el = $(elements[i]);
                if ( useProp )
                    el.prop('disabled', false);
                else
                    el.removeAttr('disabled');
            }
        }

        s = $.extend(true, {}, $.ajaxSettings, options);
        s.context = s.context || s;
        id = 'jqFormIO' + (new Date().getTime());
        if (s.iframeTarget) {
            $io = $(s.iframeTarget);
            n = $io.attr('name');
            if (!n)
                 $io.attr('name', id);
            else
                id = n;
        }
        else {
            $io = $('<iframe name="' + id + '" src="'+ s.iframeSrc +'" />');
            $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
        }
        io = $io[0];


        xhr = { // mock object
            aborted: 0,
            responseText: null,
            responseXML: null,
            status: 0,
            statusText: 'n/a',
            getAllResponseHeaders: function() {},
            getResponseHeader: function() {},
            setRequestHeader: function() {},
            abort: function(status) {
                var e = (status === 'timeout' ? 'timeout' : 'aborted');
                log('aborting upload... ' + e);
                this.aborted = 1;
                // #214
                if (io.contentWindow.document.execCommand) {
                    try { // #214
                        io.contentWindow.document.execCommand('Stop');
                    } catch(ignore) {}
                }
                $io.attr('src', s.iframeSrc); // abort op in progress
                xhr.error = e;
                if (s.error)
                    s.error.call(s.context, xhr, e, status);
                if (g)
                    $.event.trigger("ajaxError", [xhr, s, e]);
                if (s.complete)
                    s.complete.call(s.context, xhr, e);
            }
        };

        g = s.global;
        // trigger ajax global events so that activity/block indicators work like normal
        if (g && 0 === $.active++) {
            $.event.trigger("ajaxStart");
        }
        if (g) {
            $.event.trigger("ajaxSend", [xhr, s]);
        }

        if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
            if (s.global) {
                $.active--;
            }
            return;
        }
        if (xhr.aborted) {
            return;
        }

        // add submitting element to data if we know it
        sub = form.clk;
        if (sub) {
            n = sub.name;
            if (n && !sub.disabled) {
                s.extraData = s.extraData || {};
                s.extraData[n] = sub.value;
                if (sub.type == "image") {
                    s.extraData[n+'.x'] = form.clk_x;
                    s.extraData[n+'.y'] = form.clk_y;
                }
            }
        }
        
        var CLIENT_TIMEOUT_ABORT = 1;
        var SERVER_ABORT = 2;

        function getDoc(frame) {
            var doc = frame.contentWindow ? frame.contentWindow.document : frame.contentDocument ? frame.contentDocument : frame.document;
            return doc;
        }
        
        // Rails CSRF hack (thanks to Yvan Barthelemy)
        var csrf_token = $('meta[name=csrf-token]').attr('content');
        var csrf_param = $('meta[name=csrf-param]').attr('content');
        if (csrf_param && csrf_token) {
            s.extraData = s.extraData || {};
            s.extraData[csrf_param] = csrf_token;
        }

        // take a breath so that pending repaints get some cpu time before the upload starts
        function doSubmit() {
            // make sure form attrs are set
            var t = $form.attr('target'), a = $form.attr('action');

            // update form attrs in IE friendly way
            form.setAttribute('target',id);
            if (!method) {
                form.setAttribute('method', 'POST');
            }
            if (a != s.url) {
                form.setAttribute('action', s.url);
            }

            // ie borks in some cases when setting encoding
            if (! s.skipEncodingOverride && (!method || /post/i.test(method))) {
                $form.attr({
                    encoding: 'multipart/form-data',
                    enctype:  'multipart/form-data'
                });
            }

            // support timout
            if (s.timeout) {
                timeoutHandle = setTimeout(function() { timedOut = true; cb(CLIENT_TIMEOUT_ABORT); }, s.timeout);
            }
            
            // look for server aborts
            function checkState() {
                try {
                    var state = getDoc(io).readyState;
                    log('state = ' + state);
                    if (state && state.toLowerCase() == 'uninitialized')
                        setTimeout(checkState,50);
                }
                catch(e) {
                    log('Server abort: ' , e, ' (', e.name, ')');
                    cb(SERVER_ABORT);
                    if (timeoutHandle)
                        clearTimeout(timeoutHandle);
                    timeoutHandle = undefined;
                }
            }

            // add "extra" data to form if provided in options
            var extraInputs = [];
            try {
                if (s.extraData) {
                    for (var n in s.extraData) {
                        if (s.extraData.hasOwnProperty(n)) {
                           // if using the $.param format that allows for multiple values with the same name
                           if($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
                               extraInputs.push(
                               $('<input type="hidden" name="'+s.extraData[n].name+'">').attr('value',s.extraData[n].value)
                                   .appendTo(form)[0]);
                           } else {
                               extraInputs.push(
                               $('<input type="hidden" name="'+n+'">').attr('value',s.extraData[n])
                                   .appendTo(form)[0]);
                           }
                        }
                    }
                }

                if (!s.iframeTarget) {
                    // add iframe to doc and submit the form
                    $io.appendTo('body');
                    if (io.attachEvent)
                        io.attachEvent('onload', cb);
                    else
                        io.addEventListener('load', cb, false);
                }
                setTimeout(checkState,15);
                form.submit();
            }
            finally {
                // reset attrs and remove "extra" input elements
                form.setAttribute('action',a);
                if(t) {
                    form.setAttribute('target', t);
                } else {
                    $form.removeAttr('target');
                }
                $(extraInputs).remove();
            }
        }

        if (s.forceSync) {
            doSubmit();
        }
        else {
            setTimeout(doSubmit, 10); // this lets dom updates render
        }

        var data, doc, domCheckCount = 50, callbackProcessed;

        function cb(e) {
            if (xhr.aborted || callbackProcessed) {
                return;
            }
            try {
                doc = getDoc(io);
            }
            catch(ex) {
                log('cannot access response document: ', ex);
                e = SERVER_ABORT;
            }
            if (e === CLIENT_TIMEOUT_ABORT && xhr) {
                xhr.abort('timeout');
                return;
            }
            else if (e == SERVER_ABORT && xhr) {
                xhr.abort('server abort');
                return;
            }

            if (!doc || doc.location.href == s.iframeSrc) {
                // response not received yet
                if (!timedOut)
                    return;
            }
            if (io.detachEvent)
                io.detachEvent('onload', cb);
            else    
                io.removeEventListener('load', cb, false);

            var status = 'success', errMsg;
            try {
                if (timedOut) {
                    throw 'timeout';
                }

                var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
                log('isXml='+isXml);
                if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
                    if (--domCheckCount) {
                        // in some browsers (Opera) the iframe DOM is not always traversable when
                        // the onload callback fires, so we loop a bit to accommodate
                        log('requeing onLoad callback, DOM not available');
                        setTimeout(cb, 250);
                        return;
                    }
                    // let this fall through because server response could be an empty document
                    //log('Could not access iframe DOM after mutiple tries.');
                    //throw 'DOMException: not available';
                }

                //log('response detected');
                var docRoot = doc.body ? doc.body : doc.documentElement;
                xhr.responseText = docRoot ? docRoot.innerHTML : null;
                xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
                if (isXml)
                    s.dataType = 'xml';
                xhr.getResponseHeader = function(header){
                    var headers = {'content-type': s.dataType};
                    return headers[header];
                };
                // support for XHR 'status' & 'statusText' emulation :
                if (docRoot) {
                    xhr.status = Number( docRoot.getAttribute('status') ) || xhr.status;
                    xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
                }

                var dt = (s.dataType || '').toLowerCase();
                var scr = /(json|script|text)/.test(dt);
                if (scr || s.textarea) {
                    // see if user embedded response in textarea
                    var ta = doc.getElementsByTagName('textarea')[0];
                    if (ta) {
                        xhr.responseText = ta.value;
                        // support for XHR 'status' & 'statusText' emulation :
                        xhr.status = Number( ta.getAttribute('status') ) || xhr.status;
                        xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
                    }
                    else if (scr) {
                        // account for browsers injecting pre around json response
                        var pre = doc.getElementsByTagName('pre')[0];
                        var b = doc.getElementsByTagName('body')[0];
                        if (pre) {
                            xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
                        }
                        else if (b) {
                            xhr.responseText = b.textContent ? b.textContent : b.innerText;
                        }
                    }
                }
                else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
                    xhr.responseXML = toXml(xhr.responseText);
                }

                try {
                    data = httpData(xhr, dt, s);
                }
                catch (e) {
                    status = 'parsererror';
                    xhr.error = errMsg = (e || status);
                }
            }
            catch (e) {
                log('error caught: ',e);
                status = 'error';
                xhr.error = errMsg = (e || status);
            }

            if (xhr.aborted) {
                log('upload aborted');
                status = null;
            }

            if (xhr.status) { // we've set xhr.status
                status = (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) ? 'success' : 'error';
            }

            // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
            if (status === 'success') {
                if (s.success)
                    s.success.call(s.context, data, 'success', xhr);
                if (g)
                    $.event.trigger("ajaxSuccess", [xhr, s]);
            }
            else if (status) {
                if (errMsg === undefined)
                    errMsg = xhr.statusText;
                if (s.error)
                    s.error.call(s.context, xhr, status, errMsg);
                if (g)
                    $.event.trigger("ajaxError", [xhr, s, errMsg]);
            }

            if (g)
                $.event.trigger("ajaxComplete", [xhr, s]);

            if (g && ! --$.active) {
                $.event.trigger("ajaxStop");
            }

            if (s.complete)
                s.complete.call(s.context, xhr, status);

            callbackProcessed = true;
            if (s.timeout)
                clearTimeout(timeoutHandle);

            // clean up
            setTimeout(function() {
                if (!s.iframeTarget)
                    $io.remove();
                xhr.responseXML = null;
            }, 100);
        }

        var toXml = $.parseXML || function(s, doc) { // use parseXML if available (jQuery 1.5+)
            if (window.ActiveXObject) {
                doc = new ActiveXObject('Microsoft.XMLDOM');
                doc.async = 'false';
                doc.loadXML(s);
            }
            else {
                doc = (new DOMParser()).parseFromString(s, 'text/xml');
            }
            return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
        };
        var parseJSON = $.parseJSON || function(s) {
            /*jslint evil:true */
            return window['eval']('(' + s + ')');
        };

        var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4

            var ct = xhr.getResponseHeader('content-type') || '',
                xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
                data = xml ? xhr.responseXML : xhr.responseText;

            if (xml && data.documentElement.nodeName === 'parsererror') {
                if ($.error)
                    $.error('parsererror');
            }
            if (s && s.dataFilter) {
                data = s.dataFilter(data, type);
            }
            if (typeof data === 'string') {
                if (type === 'json' || !type && ct.indexOf('json') >= 0) {
                    data = parseJSON(data);
                } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
                    $.globalEval(data);
                }
            }
            return data;
        };
    }
};

/**
 * ajaxForm() provides a mechanism for fully automating form submission.
 *
 * The advantages of using this method instead of ajaxSubmit() are:
 *
 * 1: This method will include coordinates for <input type="image" /> elements (if the element
 *    is used to submit the form).
 * 2. This method will include the submit element's name/value data (for the element that was
 *    used to submit the form).
 * 3. This method binds the submit() method to the form for you.
 *
 * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
 * passes the options argument along after properly binding events for submit elements and
 * the form itself.
 */
$.fn.ajaxForm = function(options) {
    options = options || {};
    options.delegation = options.delegation && $.isFunction($.fn.on);
    
    // in jQuery 1.3+ we can fix mistakes with the ready state
    if (!options.delegation && this.length === 0) {
        var o = { s: this.selector, c: this.context };
        if (!$.isReady && o.s) {
            log('DOM not ready, queuing ajaxForm');
            $(function() {
                $(o.s,o.c).ajaxForm(options);
            });
            return this;
        }
        // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
        log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
        return this;
    }

    if ( options.delegation ) {
        $(document)
            .off('submit.form-plugin', this.selector, doAjaxSubmit)
            .off('click.form-plugin', this.selector, captureSubmittingElement)
            .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
            .on('click.form-plugin', this.selector, options, captureSubmittingElement);
        return this;
    }

    return this.ajaxFormUnbind()
        .bind('submit.form-plugin', options, doAjaxSubmit)
        .bind('click.form-plugin', options, captureSubmittingElement);
};

// private event handlers    
function doAjaxSubmit(e) {
    /*jshint validthis:true */
    var options = e.data;
    if (!e.isDefaultPrevented()) { // if event has been canceled, don't proceed
        e.preventDefault();
        $(this).ajaxSubmit(options);
    }
}
    
function captureSubmittingElement(e) {
    /*jshint validthis:true */
    var target = e.target;
    var $el = $(target);
    if (!($el.is(":submit,input:image"))) {
        // is this a child element of the submit el?  (ex: a span within a button)
        var t = $el.closest(':submit');
        if (t.length === 0) {
            return;
        }
        target = t[0];
    }
    var form = this;
    form.clk = target;
    if (target.type == 'image') {
        if (e.offsetX !== undefined) {
            form.clk_x = e.offsetX;
            form.clk_y = e.offsetY;
        } else if (typeof $.fn.offset == 'function') {
            var offset = $el.offset();
            form.clk_x = e.pageX - offset.left;
            form.clk_y = e.pageY - offset.top;
        } else {
            form.clk_x = e.pageX - target.offsetLeft;
            form.clk_y = e.pageY - target.offsetTop;
        }
    }
    // clear form vars
    setTimeout(function() { form.clk = form.clk_x = form.clk_y = null; }, 100);
}


// ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
$.fn.ajaxFormUnbind = function() {
    return this.unbind('submit.form-plugin click.form-plugin');
};

/**
 * formToArray() gathers form element data into an array of objects that can
 * be passed to any of the following ajax functions: $.get, $.post, or load.
 * Each object in the array has both a 'name' and 'value' property.  An example of
 * an array for a simple login form might be:
 *
 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
 *
 * It is this array that is passed to pre-submit callback functions provided to the
 * ajaxSubmit() and ajaxForm() methods.
 */
$.fn.formToArray = function(semantic, elements) {
    var a = [];
    if (this.length === 0) {
        return a;
    }

    var form = this[0];
    var els = semantic ? form.getElementsByTagName('*') : form.elements;
    if (!els) {
        return a;
    }

    var i,j,n,v,el,max,jmax;
    for(i=0, max=els.length; i < max; i++) {
        el = els[i];
        n = el.name;
        if (!n) {
            continue;
        }

        if (semantic && form.clk && el.type == "image") {
            // handle image inputs on the fly when semantic == true
            if(!el.disabled && form.clk == el) {
                a.push({name: n, value: $(el).val(), type: el.type });
                a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
            }
            continue;
        }

        v = $.fieldValue(el, true);
        if (v && v.constructor == Array) {
            if (elements) 
                elements.push(el);
            for(j=0, jmax=v.length; j < jmax; j++) {
                a.push({name: n, value: v[j]});
            }
        }
        else if (feature.fileapi && el.type == 'file' && !el.disabled) {
            if (elements) 
                elements.push(el);
            var files = el.files;
            if (files.length) {
                for (j=0; j < files.length; j++) {
                    a.push({name: n, value: files[j], type: el.type});
                }
            }
            else {
                // #180
                a.push({ name: n, value: '', type: el.type });
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            if (elements) 
                elements.push(el);
            a.push({name: n, value: v, type: el.type, required: el.required});
        }
    }

    if (!semantic && form.clk) {
        // input type=='image' are not found in elements array! handle it here
        var $input = $(form.clk), input = $input[0];
        n = input.name;
        if (n && !input.disabled && input.type == 'image') {
            a.push({name: n, value: $input.val()});
            a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
        }
    }
    return a;
};

/**
 * Serializes form data into a 'submittable' string. This method will return a string
 * in the format: name1=value1&amp;name2=value2
 */
$.fn.formSerialize = function(semantic) {
    //hand off to jQuery.param for proper encoding
    return $.param(this.formToArray(semantic));
};

/**
 * Serializes all field elements in the jQuery object into a query string.
 * This method will return a string in the format: name1=value1&amp;name2=value2
 */
$.fn.fieldSerialize = function(successful) {
    var a = [];
    this.each(function() {
        var n = this.name;
        if (!n) {
            return;
        }
        var v = $.fieldValue(this, successful);
        if (v && v.constructor == Array) {
            for (var i=0,max=v.length; i < max; i++) {
                a.push({name: n, value: v[i]});
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            a.push({name: this.name, value: v});
        }
    });
    //hand off to jQuery.param for proper encoding
    return $.param(a);
};

/**
 * Returns the value(s) of the element in the matched set.  For example, consider the following form:
 *
 *  <form><fieldset>
 *      <input name="A" type="text" />
 *      <input name="A" type="text" />
 *      <input name="B" type="checkbox" value="B1" />
 *      <input name="B" type="checkbox" value="B2"/>
 *      <input name="C" type="radio" value="C1" />
 *      <input name="C" type="radio" value="C2" />
 *  </fieldset></form>
 *
 *  var v = $(':text').fieldValue();
 *  // if no values are entered into the text inputs
 *  v == ['','']
 *  // if values entered into the text inputs are 'foo' and 'bar'
 *  v == ['foo','bar']
 *
 *  var v = $(':checkbox').fieldValue();
 *  // if neither checkbox is checked
 *  v === undefined
 *  // if both checkboxes are checked
 *  v == ['B1', 'B2']
 *
 *  var v = $(':radio').fieldValue();
 *  // if neither radio is checked
 *  v === undefined
 *  // if first radio is checked
 *  v == ['C1']
 *
 * The successful argument controls whether or not the field element must be 'successful'
 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
 * The default value of the successful argument is true.  If this value is false the value(s)
 * for each element is returned.
 *
 * Note: This method *always* returns an array.  If no valid value can be determined the
 *    array will be empty, otherwise it will contain one or more values.
 */
$.fn.fieldValue = function(successful) {
    for (var val=[], i=0, max=this.length; i < max; i++) {
        var el = this[i];
        var v = $.fieldValue(el, successful);
        if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
            continue;
        }
        if (v.constructor == Array)
            $.merge(val, v);
        else
            val.push(v);
    }
    return val;
};

/**
 * Returns the value of the field element.
 */
$.fieldValue = function(el, successful) {
    var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
    if (successful === undefined) {
        successful = true;
    }

    if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
        (t == 'checkbox' || t == 'radio') && !el.checked ||
        (t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
        tag == 'select' && el.selectedIndex == -1)) {
            return null;
    }

    if (tag == 'select') {
        var index = el.selectedIndex;
        if (index < 0) {
            return null;
        }
        var a = [], ops = el.options;
        var one = (t == 'select-one');
        var max = (one ? index+1 : ops.length);
        for(var i=(one ? index : 0); i < max; i++) {
            var op = ops[i];
            if (op.selected) {
                var v = op.value;
                if (!v) { // extra pain for IE...
                    v = (op.attributes && op.attributes['value'] && !(op.attributes['value'].specified)) ? op.text : op.value;
                }
                if (one) {
                    return v;
                }
                a.push(v);
            }
        }
        return a;
    }
    return $(el).val();
};

/**
 * Clears the form data.  Takes the following actions on the form's input fields:
 *  - input text fields will have their 'value' property set to the empty string
 *  - select elements will have their 'selectedIndex' property set to -1
 *  - checkbox and radio inputs will have their 'checked' property set to false
 *  - inputs of type submit, button, reset, and hidden will *not* be effected
 *  - button elements will *not* be effected
 */
$.fn.clearForm = function(includeHidden) {
    return this.each(function() {
        $('input,select,textarea', this).clearFields(includeHidden);
    });
};

/**
 * Clears the selected form elements.
 */
$.fn.clearFields = $.fn.clearInputs = function(includeHidden) {
    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
    return this.each(function() {
        var t = this.type, tag = this.tagName.toLowerCase();
        if (re.test(t) || tag == 'textarea') {
            this.value = '';
        }
        else if (t == 'checkbox' || t == 'radio') {
            this.checked = false;
        }
        else if (tag == 'select') {
            this.selectedIndex = -1;
        }
        else if (includeHidden) {
            // includeHidden can be the value true, or it can be a selector string
            // indicating a special test; for example:
            //  $('#myForm').clearForm('.special:hidden')
            // the above would clean hidden inputs that have the class of 'special'
            if ( (includeHidden === true && /hidden/.test(t)) ||
                 (typeof includeHidden == 'string' && $(this).is(includeHidden)) )
                this.value = '';
        }
    });
};

/**
 * Resets the form data.  Causes all form elements to be reset to their original value.
 */
$.fn.resetForm = function() {
    return this.each(function() {
        // guard against an input with the name of 'reset'
        // note that IE reports the reset function as an 'object'
        if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
            this.reset();
        }
    });
};

/**
 * Enables or disables any matching elements.
 */
$.fn.enable = function(b) {
    if (b === undefined) {
        b = true;
    }
    return this.each(function() {
        this.disabled = !b;
    });
};

/**
 * Checks/unchecks any matching checkboxes or radio buttons and
 * selects/deselects and matching option elements.
 */
$.fn.selected = function(select) {
    if (select === undefined) {
        select = true;
    }
    return this.each(function() {
        var t = this.type;
        if (t == 'checkbox' || t == 'radio') {
            this.checked = select;
        }
        else if (this.tagName.toLowerCase() == 'option') {
            var $sel = $(this).parent('select');
            if (select && $sel[0] && $sel[0].type == 'select-one') {
                // deselect all other options
                $sel.find('option').selected(false);
            }
            this.selected = select;
        }
    });
};

// expose debug var
$.fn.ajaxSubmit.debug = false;

// helper fn for console logging
function log() {
    if (!$.fn.ajaxSubmit.debug) 
        return;
    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments,'');
    if (window.console && window.console.log) {
        window.console.log(msg);
    }
    else if (window.opera && window.opera.postError) {
        window.opera.postError(msg);
    }
}

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("4kSj")))

/***/ }),

/***/ "E1Jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ModeraFunction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ var ModeraFunction = ({
    name: 'ModeraFunction',
    data: function data() {
        return {
            msg: 'This is Modera Function save!',
            titleName: 'Save Data',
            isGenerateModelMode: false,
            isGenerateViewMode: false,
            isGenerateButton: true,
            isShowSubView: false,
            subAirViewDoom: {},
            tempModel: "",
            drawFlag: 0
        };
    },

    mounted: function mounted() {
        pfAirViewer._clickEventHelper.add(pfAirViewer.sceneClicked, this.generateModel);
        pfAirViewer._clickEventHelper.add(pfAirViewer.sceneClicked, this.createViewer);
        /*pfAirViewer._drawLayerManager = new Cesium.DataManager({
            id : "draw",
            viewer : pfAirViewer,
            layerData : []
        });*/
        this.dragElement(document.getElementById("subViewDoom"));
        this.subAirViewDoom = document.getElementById("subAirViewer");
    },
    methods: {
        generateModel: function generateModel(e) {
            if (this.isGenerateModelMode) {
                var model = pfAirViewer._modelGenerator.generateModel({
                    e: e,
                    test: pfAirViewer
                });
                pfAirViewer._entitySelector._entities.add(model);
                this.drawFlag++;
                var layerName = "00" + this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = model;
                pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");
                //pfAirViewer.entities.add(model);
                //pfAirViewer.flyTo(model);
                //var picked = pfAirViewer.scene.pick(e.position);
                var createTime = new Date();
                var testTime = Cesium.JulianDate.now();
                testTime = Cesium.JulianDate.toDate(testTime);
                testTime = testTime.toString();
                createTime = new Date(testTime);
                this.isGenerateModelMode = false;
                eventBus.$emit('addModelPanel', {
                    name: layerName,
                    time: createTime,
                    type: "Fly Point"
                });
                //this.tempModel = model;
            }
        },
        mergeModel: function mergeModel(options) {
            if (pfAirViewer._drawLayerManager._length) {
                var entityCollection = new Cesium.EntityCollection();
                for (var i in pfAirViewer._drawLayerManager._layerData) {
                    entityCollection.add(pfAirViewer._drawLayerManager._layerData[i].cesiumData);
                }
                var isWithOrientation = true;
                if (Cesium.defined(options) && Cesium.defined(options.isWithOrientation)) {
                    isWithOrientation = options.isWithOrientation;
                }
                var resaultEntity = Cesium.HomelessFunction.mergeEntityCluster({
                    data: entityCollection,
                    isWithOrientation: isWithOrientation
                });
                pfAirViewer.clock.startTime = resaultEntity.availability.start;
                pfAirViewer.clock.stopTime = resaultEntity.availability.stop;
                pfAirViewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;

                //remove fly point
                pfAirViewer._drawLayerManager.removeAll();
                eventBus.$emit('removePanel');

                this.drawFlag++;
                var layerName = "00" + this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = resaultEntity;
                pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");

                eventBus.$emit('addModelPanel', {
                    name: layerName,
                    type: "Fly",
                    startTime: Cesium.JulianDate.toDate(pfAirViewer.clock.startTime),
                    stopTime: Cesium.JulianDate.toDate(pfAirViewer.clock.stopTime)
                });
            }
        },
        renderCameraToCanvas: function renderCameraToCanvas(subCanvas, subCamera, Viewer) {
            console.log(subCanvas);
            console.log(subCamera);
            console.log(Viewer);
        },
        createViewer: function createViewer(e) {
            if (this.isGenerateViewMode) {
                var model = pfAirViewer._modelGenerator.generateModel({
                    e: e,
                    test: pfAirViewer
                });
                pfAirViewer._entitySelector._entities.add(model);
                this.drawFlag++;
                var layerName = "00" + this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = model;
                pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");
                this.isGenerateViewMode = false;
                this.isShowSubView = true;

                eventBus.$emit('addViewPanel', {
                    name: layerName,
                    time: "time",
                    type: "View Point"
                });
                var canvas = document.createElement('canvas');
                this.renderCameraToCanvas(canvas, pfAirViewer.camera, pfAirViewer);
                //var destCtx = canvas.getContext('2d');
                //destCtx.drawImage(pfAirViewer.scene.canvas, 0, 0);
                //canvas = pfAirViewer.scene.canvas;
                //canvas = JSON.parse ( JSON.stringify(pfAirViewer.scene.canvas) );
                //Object.assign(canvas, pfAirViewer.scene.canvas)
                //canvas.width = pfAirViewer.scene.canvas.width;
                //canvas.height = pfAirViewer.scene.canvas.height;
                //var backCtx = backCanvas.getContext('2d');
                this.subAirViewDoom.appendChild(canvas);
            }
        },
        test: function test() {},
        dragElement: function dragElement(elmnt) {
            var pos1 = 0,
                pos2 = 0,
                pos3 = 0,
                pos4 = 0;
            if (document.getElementById(elmnt.id + "header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;
                // set the element's new position:
                elmnt.style.top = elmnt.offsetTop - pos2 + "px";
                elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
            }

            function closeDragElement() {
                /* stop moving when mouse button is released:*/
                document.onmouseup = null;
                document.onmousemove = null;
            }
        },
        close: function close() {
            this.isShowSubView = false;
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2925dbd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModeraFunction.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ModeraFunction container-fluid form-horizontal"},[_c('button',{staticClass:"btn btn-primary col-sm-12 ",class:{ disabled: !_vm.isGenerateButton,on: _vm.isGenerateModelMode },attrs:{"type":"button"},on:{"click":function($event){_vm.isGenerateModelMode=!_vm.isGenerateModelMode}}},[_vm._v("Generate Fly Point")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary col-sm-12",attrs:{"type":"button"},on:{"click":function($event){_vm.mergeModel()}}},[_vm._v("Merge Fly Point")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary col-sm-12",attrs:{"type":"button"},on:{"click":function($event){_vm.mergeModel({isWithOrientation:false})}}},[_vm._v("Merge Fly Point WOO")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowSubView),expression:"isShowSubView"}]},[_c('div',{attrs:{"id":"subViewDoom"}},[_c('div',{staticClass:"title",attrs:{"id":"subViewheader"}},[_c('strong',[_vm._v("SUB VIEW")]),_vm._v(" "),_c('span',{staticClass:"exit",on:{"click":_vm.close}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"SubView",attrs:{"id":"subAirViewer"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ModeraFunction = (esExports);
// CONCATENATED MODULE: ./src/components/ModeraFunction.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ef6a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2925dbd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ModeraFunction,
  components_ModeraFunction,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_ModeraFunction = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ef6a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HCsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L9FR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DrawToolBar.vue
var DrawToolBar = __webpack_require__("uPfo");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6affdbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrawToolBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawBarTool",attrs:{"id":"draw_option"}},[(_vm.isShowPlaceMarkInputDialog)?_c('div',[_c('place-mark-input',{attrs:{"placeMarkData":_vm.transmissionData,"showposition":_vm.isshowposition},on:{"closeDialog":_vm.closeInput,"savePlaceMark":_vm.createPlaceMark}})],1):_vm._e(),_vm._v(" "),(_vm.isShowDataSaveDialog)?_c('div',[_c('data-save',{attrs:{"userData":_vm.userData},on:{"closeDataSave":_vm.closeDataSave}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"drawtoolbar"},[_c('div',{staticClass:"draw_button",attrs:{"id":"arrow"}}),_vm._v(" "),_c('div',{staticClass:"draw_tool",class:{active:_vm.is_clicked_draw},attrs:{"id":"entity","title":"Draw"},on:{"click":_vm.draw_function}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show_draw),expression:"is_show_draw"}],staticClass:"draw_function"},[_c('div',{staticClass:"draw_button",attrs:{"id":"marker"},on:{"click":_vm.prevent_click}}),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"normal_line"},on:{"click":_vm.prevent_click}}),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"normal_polygon"},on:{"click":_vm.prevent_click}}),_vm._v(" "),_c('div',{staticClass:"entity",class:{active:_vm.is_create_entity},attrs:{"title":"Add Properties"},on:{"click":_vm.create_entity}})])]),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"distance"}}),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"setting"}}),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"save"}}),_vm._v(" "),_c('div',{staticClass:"draw_button",attrs:{"id":"remove"}})]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"draw_dlg"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"myModalLabel"}},[_vm._v("Draw Settings")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{attrs:{"id":"line_c"}},[_c('h4',[_c('span',{staticClass:"label label-default"},[_vm._v("Color:")])]),_vm._v(" "),_c('input',{staticClass:"boder-color form-control",attrs:{"type":"text","value":"#00AABB"}})]),_vm._v(" "),_c('div',[_c('h4',[_c('span',{staticClass:"label label-default"},[_vm._v("Width:")])])]),_vm._v(" "),_c('div',[_c('input',{attrs:{"id":"ex6","type":"text","data-slider-min":"1","data-slider-max":"20","data-slider-step":"1","data-slider-value":"2"}}),_vm._v(" "),_c('span',{attrs:{"id":"ex6CurrentSliderValLabel"}},[_vm._v("Current Slider Value: "),_c('span',{attrs:{"id":"ex6SliderVal"}},[_vm._v("2")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("OK")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DrawToolBar = (esExports);
// CONCATENATED MODULE: ./src/components/DrawToolBar.vue
function injectStyle (ssrContext) {
  __webpack_require__("caBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6affdbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DrawToolBar["a" /* default */],
  components_DrawToolBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DrawToolBar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc31e6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("8+0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+Ri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("4kSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_three_jquery_form_js__ = __webpack_require__("D+l2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_three_jquery_form_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_three_jquery_form_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_three_bootstrap_css_bootstrap_min_css__ = __webpack_require__("VxaO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_three_bootstrap_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_three_bootstrap_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_three_bootstrap_css_bootstrap_theme_min_css__ = __webpack_require__("4h7O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_three_bootstrap_css_bootstrap_theme_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_three_bootstrap_css_bootstrap_theme_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_three_bootstrap_js_bootstrap_min__ = __webpack_require__("Bszb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_three_bootstrap_js_bootstrap_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_three_bootstrap_js_bootstrap_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_three_bootstrap_js_bootstrap_select_min_js__ = __webpack_require__("dbHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_three_bootstrap_js_bootstrap_select_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_three_bootstrap_js_bootstrap_select_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_three_bootstrap_css_bootstrap_select_min_css__ = __webpack_require__("h+DM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_three_bootstrap_css_bootstrap_select_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_three_bootstrap_css_bootstrap_select_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_three_colorpick_css_bootstrap_colorpicker_min_css__ = __webpack_require__("UIqP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_three_colorpick_css_bootstrap_colorpicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_three_colorpick_css_bootstrap_colorpicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_three_colorpick_js_bootstrap_colorpicker_min__ = __webpack_require__("xkmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_three_colorpick_js_bootstrap_colorpicker_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_three_colorpick_js_bootstrap_colorpicker_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_three_bootstrap_slider_min_css__ = __webpack_require__("s0Oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_three_bootstrap_slider_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_three_bootstrap_slider_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_three_bootstrap_slider_min__ = __webpack_require__("tiBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_three_bootstrap_slider_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_three_bootstrap_slider_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




// import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min'
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_15_axios___default.a;

global.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('fixedFloat', function (value, num) {
  return value.toFixed(num);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */], $: __WEBPACK_IMPORTED_MODULE_3_jquery___default.a, VueResource: __WEBPACK_IMPORTED_MODULE_14_vue_resource__["a" /* default */] }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "T10h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RightBar.vue
var RightBar = __webpack_require__("gOQ+");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae31743","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rightbar",class:{ on: _vm.isActive }},[_c('div',{staticClass:"right_nav_tools",attrs:{"id":"right_nav_tools"}},[_c('ul',{staticClass:"r_nav_o round_s"},[_c('li',{staticClass:"callRnav btn_t club_li",class:{ active: _vm.displayMode=='PERSONDATA' },attrs:{"data-rnav":"club"},on:{"click":function($event){_vm.toggleRightNav('PERSONDATA')}}},[_c('a',{staticClass:"tip1 r_arrow d_1",attrs:{"title":"Person"}})]),_vm._v(" "),_c('li',{staticClass:"callRnav global_li",class:{ active: _vm.displayMode=='GLOBAlDATA' },attrs:{"data-rnav":"global"},on:{"click":function($event){_vm.toggleRightNav('GLOBAlDATA')}}},[_c('a',{staticClass:"tip1 r_arrow d_2",attrs:{"title":"Layer"}})]),_vm._v(" "),_c('li',{staticClass:"callRnav btn_d",class:{ active: _vm.displayMode=='LEGEND' },attrs:{"data-rnav":"pic"},on:{"click":function($event){_vm.toggleRightNav('LEGEND')}}},[_c('a',{staticClass:"tip1 r_arrow d_3",attrs:{"title":"Function"}})])]),_vm._v(" "),_c('ul',{staticClass:"r_nav_o round_s"},[_c('li',{staticClass:"btn_t",class:{ active: _vm.isDisplayEditor }},[_c('a',{staticClass:"r_arrow d_4",attrs:{"title":"editor"},on:{"click":function($event){_vm.isDisplayEditor = !_vm.isDisplayEditor}}}),_vm._v(" "),_c('draw-tool-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDisplayEditor),expression:"isDisplayEditor"}],attrs:{"userData":_vm.userData}})],1)]),_vm._v(" "),_c('ul',{staticClass:"r_nav_o round_s"},[_c('li',[_c('a',{staticClass:"r_arrow d_5",attrs:{"title":"pointer"},on:{"click":function($event){_vm.resetView()}}})]),_vm._v(" "),_c('li',{staticClass:"btn_d"},[_c('a',{staticClass:"r_arrow d_sceneMode",class:{active:_vm.is_clicked},attrs:{"title":_vm.Scene3D?'3D':'2D'},on:{"click":function($event){_vm.switchSceneMode()}}})]),_vm._v(" "),_c('li',{staticClass:"btn_d"},[_c('a',{staticClass:"r_arrow d_6",attrs:{"title":"help"},on:{"click":function($event){_vm.testFunction()}}})])])]),_vm._v(" "),_c('right-navigation',{attrs:{"displayMode":_vm.displayMode,"userInfo":_vm.userData.userInfo},on:{"closeNav":_vm.closeNav}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_RightBar = (esExports);
// CONCATENATED MODULE: ./src/components/RightBar.vue
function injectStyle (ssrContext) {
  __webpack_require__("CCCt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae31743"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RightBar["a" /* default */],
  components_RightBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_RightBar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UIqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UaOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeftBar.vue
var LeftBar = __webpack_require__("i6l0");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258a8d51","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftbar",class:{ on: _vm.isActive }},[_c('a',{staticClass:"left_nav_btn",class:{ on: _vm.isActive },on:{"click":_vm.toggleLeftNav}}),_vm._v(" "),_c('div',{staticClass:"head"}),_vm._v(" "),_c('div',{staticClass:"h_search",attrs:{"id":"searchModule"}}),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('left-display-panel',{attrs:{"userData":_vm.userData},on:{"switchBar":_vm.switchBar}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LeftBar = (esExports);
// CONCATENATED MODULE: ./src/components/LeftBar.vue
function injectStyle (ssrContext) {
  __webpack_require__("kgpE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-258a8d51"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LeftBar["a" /* default */],
  components_LeftBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LeftBar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBar__ = __webpack_require__("UaOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RightBar__ = __webpack_require__("T10h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DashboardBar__ = __webpack_require__("8eDX");
//
//
//
//
//
//
//
//
//

/* eslint-disable */
global.pfAirViewer = new Cesium.AirViewer('mapServer');
//Cesium.TrustedServers.add("172.18.0.169", 80);
Cesium.HomelessFunction.injectionGoogleMap(Cesium);
//pfAirViewer.extend(Cesium.viewerCesium3DTilesInspectorMixin);
//pfAirViewer.extend(Cesium.viewerCesiumInspectorMixin);
pfAirViewer.clock.shouldAnimate = true;
//console.log(pfAirViewer.clock.shouldAnimate);
pfAirViewer._dataSave._baseUri = "../../";
//pfAirViewer._dataSave._baseUri = "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/";
pfAirViewer._personLayerManager._dataBaseUri = new Cesium.Uri(pfAirViewer._dataSave._baseUri + "data/");

var key = 'XFHlri0oWPBUfT9msrZN~f1oDt5rE6-k-4DB9eKy48A~Ai3GG386TlshTeMjSnDXKSZ9I3f8cIXXXyD9kDsg3YfWzfctHizlAhTPNk2G8LbN';
Cesium.BingMapsApi.defaultKey = key;
Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2NWU0YzY3ZS1hOGYyLTQyM2YtYjcyNy00YTg1ZGUzYWY3NDEiLCJpZCI6MzkxLCJpYXQiOjE1MjUyMzIyOTF9.JhEYpfPMOGcY3ms958xRko1TEqha0S7YE5Ck_7k5pn8';





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Main',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App',
			userData: {
				userInfo: {
					isGuest: 'yes'
				}
			}
		};
	},

	components: {
		NavigationBar: __WEBPACK_IMPORTED_MODULE_0__components_Navigation__["a" /* default */],
		LeftBar: __WEBPACK_IMPORTED_MODULE_1__components_LeftBar__["a" /* default */],
		RightBar: __WEBPACK_IMPORTED_MODULE_2__components_RightBar__["a" /* default */],
		DashboardBar: __WEBPACK_IMPORTED_MODULE_3__components_DashboardBar__["a" /* default */]
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "VxaO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X13v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Main.vue
var Main = __webpack_require__("Uhku");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eab93946","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('navigation-bar',{attrs:{"userData":_vm.userData}}),_vm._v(" "),_c('left-bar',{attrs:{"userData":_vm.userData}}),_vm._v(" "),_c('right-bar',{attrs:{"userData":_vm.userData}}),_vm._v(" "),_c('dashboard-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Main = (esExports);
// CONCATENATED MODULE: ./src/components/Main.vue
function injectStyle (ssrContext) {
  __webpack_require__("Z1Fz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eab93946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Main["a" /* default */],
  components_Main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Main = (Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = __webpack_exports__["a"] = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: src_components_Main
  }]
}));

/***/ }),

/***/ "Z1Fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZiTu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PlaceMarkInput.vue
var PlaceMarkInput = __webpack_require__("0YL1");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce99c294","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaceMarkInput.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlaceMarkInput"},[_c('div',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('span',{staticClass:"exit",on:{"click":_vm.close}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"PlaceMarkInfo"},[_c('div',{staticClass:"gray_border round_s scollbarY"},[_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.name),expression:"placeMarkInfo.name"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"Input PlaceMark Name"},domProps:{"value":(_vm.placeMarkInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo, "name", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.description),expression:"placeMarkInfo.description"}],staticClass:"fill_textarea round_s box_size",attrs:{"placeholder":"Input PlaceMark Description !"},domProps:{"value":(_vm.placeMarkInfo.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo, "description", $event.target.value)}}})]),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('div',{staticStyle:{"float":"left","width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.vedios),expression:"placeMarkInfo.vedios"}],staticClass:"round_s fill_text box_size",attrs:{"placeholder":"Upload | enter a valid pictures | videos ","type":"text"},domProps:{"value":(_vm.placeMarkInfo.vedios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo, "vedios", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btnupload",staticStyle:{"float":"right","width":"19%"}},[_c('span',{staticClass:"round_s fill_btn_load blue_btn"},[_vm._v("Upload")]),_vm._v(" "),_c('form',{staticClass:"uploadbtn",attrs:{"id":"myupload","action":_vm.uploadUri,"method":"post","enctype":"multipart/form-data"}},[_c('input',{attrs:{"id":"balloon_fileupload","name":"mypic","type":"file"}})])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"r_list_position",class:{active:_vm.showposition}},[_c('label',{attrs:{"for":"longitude"}},[_vm._v("longitude")]),_vm._v(" "),_c('span',{staticClass:"span_input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.coordinate.longitude),expression:"placeMarkInfo.coordinate.longitude"}],staticClass:"fill_text box_size round_s",attrs:{"id":"lon","type":"text"},domProps:{"value":(_vm.placeMarkInfo.coordinate.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo.coordinate, "longitude", $event.target.value)}}})]),_vm._v(" "),_c('label',{attrs:{"for":"latitude"}},[_vm._v("latitude")]),_vm._v(" "),_c('span',{staticClass:"span_input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.coordinate.latitude),expression:"placeMarkInfo.coordinate.latitude"}],staticClass:"fill_text box_size round_s",attrs:{"id":"lat","type":"text"},domProps:{"value":(_vm.placeMarkInfo.coordinate.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo.coordinate, "latitude", $event.target.value)}}})]),_vm._v(" "),_c('label',{attrs:{"for":"height"}},[_vm._v("height")]),_vm._v(" "),_c('span',{staticClass:"span_input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.placeMarkInfo.coordinate.height),expression:"placeMarkInfo.coordinate.height"}],staticClass:"fill_text box_size round_s",attrs:{"id":"height","type":"text"},domProps:{"value":(_vm.placeMarkInfo.coordinate.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.placeMarkInfo.coordinate, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"r_d_btn btn_layer cf2"},[_c('span',{staticClass:"l w_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"SAVE"},on:{"click":_vm.createPlaceMark}})]),_vm._v(" "),_c('span',{staticClass:"r w_5"},[_c('input',{staticClass:"round_s fill_btn_r gray_btn_g",attrs:{"type":"button","value":"CANCEL"},on:{"click":_vm.close}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"r_list"},[_c('div',{staticClass:"select box_size round_s select_box",staticStyle:{"width":"100%","margin-left":"auto","margin-right":"auto"}},[_c('p',[_vm._v("Select PlaceMark Type")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"selected",attrs:{"data-value":"default"}},[_vm._v("Select Layer Type")]),_vm._v(" "),_c('li',{attrs:{"data-value":"bus"}},[_vm._v("Bus")]),_vm._v(" "),_c('li',{attrs:{"data-value":"food"}},[_vm._v("Food")]),_vm._v(" "),_c('li',{attrs:{"data-value":"hospital"}},[_vm._v("Hospital")]),_vm._v(" "),_c('li',{attrs:{"data-value":"railway"}},[_vm._v("Railway")]),_vm._v(" "),_c('li',{attrs:{"data-value":"scenic"}},[_vm._v("Scenic")]),_vm._v(" "),_c('li',{attrs:{"data-value":"station"}},[_vm._v("Station")]),_vm._v(" "),_c('li',{attrs:{"data-value":"supermarket"}},[_vm._v("Supermarket")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"r_list"},[_c('div',{staticClass:"customProgress"},[_c('span',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"files"}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_PlaceMarkInput = (esExports);
// CONCATENATED MODULE: ./src/components/PlaceMarkInput.vue
function injectStyle (ssrContext) {
  __webpack_require__("N+Ri")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce99c294"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PlaceMarkInput["a" /* default */],
  components_PlaceMarkInput,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_PlaceMarkInput = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bLrC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserProfile.vue
var UserProfile = __webpack_require__("9Xzz");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5309e1fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userData.userInfo.isGuest == 'no')?_c('div',{staticClass:"UserProfile"},[_c('div',{staticClass:"User_info"},[_c('b',{staticClass:"User_option round_img",on:{"click":function($event){_vm.isShowUserSlave = !_vm.isShowUserSlave}}},[_c('img',{staticStyle:{"width":"40px","height":"40px"},attrs:{"src":__webpack_require__("rLRG"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"User_name"},[_vm._v(_vm._s(this.userData.userInfo.userName))])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowUserSlave),expression:"isShowUserSlave"}],staticClass:"User_club round_s"},[_c('em',{staticClass:"arrow_t_white"}),_vm._v(" "),_c('li',[_c('a',{staticClass:"UserData",on:{"click":function($event){_vm.isShowUserClub=true,_vm.isShowUserSlave=false}}},[_c('span',{staticClass:"o_arrow m_2"}),_vm._v("User Data")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"LoginOut",on:{"click":function($event){_vm.loginOut()}}},[_c('span',{staticClass:"o_arrow m_3"}),_vm._v("Logout")])])])]),_vm._v(" "),(_vm.isShowUserClub)?_c('div',[_c('user-club',{attrs:{"userData":_vm.userData},on:{"closeClub":_vm.closeClub}})],1):_vm._e()]):_c('div',{staticClass:"UserProfile"},[(_vm.isShowLoign)?_c('div',[_c('login',{attrs:{"userData":_vm.userData},on:{"close":_vm.closeLogin}})],1):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:('false'==='true'),expression:"'false'==='true'"}],staticClass:"reg_btn btn_r",on:{"click":_vm.register}},[_vm._v("Register")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_UserProfile = (esExports);
// CONCATENATED MODULE: ./src/components/UserProfile.vue
function injectStyle (ssrContext) {
  __webpack_require__("jExx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5309e1fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UserProfile["a" /* default */],
  components_UserProfile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_UserProfile = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Navigation.vue
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ var Navigation = ({
    name: 'navigation-component',
    props: ['userData'],
    data: function data() {
        return {
            lanange: 'English',
            username: 'wfc\'s user'
        };
    },

    components: {
        UserProfile: src_components_UserProfile
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7fa176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
var Navigation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"lanange"},[_vm._v(_vm._s(_vm.lanange))]),_vm._v(" "),_c('user-profile',{attrs:{"userData":_vm.userData}})],1)}
var Navigation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"alt":"AIRBUS"}})])}]
var Navigation_esExports = { render: Navigation_render, staticRenderFns: Navigation_staticRenderFns }
/* harmony default export */ var components_Navigation = (Navigation_esExports);
// CONCATENATED MODULE: ./src/components/Navigation.vue
function Navigation_injectStyle (ssrContext) {
  __webpack_require__("6eoA")
}
var Navigation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Navigation___vue_template_functional__ = false
/* styles */
var Navigation___vue_styles__ = Navigation_injectStyle
/* scopeId */
var Navigation___vue_scopeId__ = "data-v-6d7fa176"
/* moduleIdentifier (server only) */
var Navigation___vue_module_identifier__ = null
var Navigation_Component = Navigation_normalizeComponent(
  Navigation,
  components_Navigation,
  Navigation___vue_template_functional__,
  Navigation___vue_styles__,
  Navigation___vue_scopeId__,
  Navigation___vue_module_identifier__
)

/* harmony default export */ var src_components_Navigation = __webpack_exports__["a"] = (Navigation_Component.exports);


/***/ }),

/***/ "caBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dbHR":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Bootstrap-select v1.12.4 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
!function(a,b){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("4kSj")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(a){return b(a)}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=b(require("jquery")):b(a.jQuery)}(this,function(a){!function(a){"use strict";function b(b){var c=[{re:/[\xC0-\xC6]/g,ch:"A"},{re:/[\xE0-\xE6]/g,ch:"a"},{re:/[\xC8-\xCB]/g,ch:"E"},{re:/[\xE8-\xEB]/g,ch:"e"},{re:/[\xCC-\xCF]/g,ch:"I"},{re:/[\xEC-\xEF]/g,ch:"i"},{re:/[\xD2-\xD6]/g,ch:"O"},{re:/[\xF2-\xF6]/g,ch:"o"},{re:/[\xD9-\xDC]/g,ch:"U"},{re:/[\xF9-\xFC]/g,ch:"u"},{re:/[\xC7-\xE7]/g,ch:"c"},{re:/[\xD1]/g,ch:"N"},{re:/[\xF1]/g,ch:"n"}];return a.each(c,function(){b=b?b.replace(this.re,this.ch):""}),b}function c(b){var c=arguments,d=b;[].shift.apply(c);var e,f=this.each(function(){var b=a(this);if(b.is("select")){var f=b.data("selectpicker"),g="object"==typeof d&&d;if(f){if(g)for(var h in g)g.hasOwnProperty(h)&&(f.options[h]=g[h])}else{var i=a.extend({},l.DEFAULTS,a.fn.selectpicker.defaults||{},b.data(),g);i.template=a.extend({},l.DEFAULTS.template,a.fn.selectpicker.defaults?a.fn.selectpicker.defaults.template:{},b.data().template,g.template),b.data("selectpicker",f=new l(this,i))}"string"==typeof d&&(e=f[d]instanceof Function?f[d].apply(f,c):f.options[d])}});return"undefined"!=typeof e?e:f}String.prototype.includes||!function(){var a={}.toString,b=function(){try{var a={},b=Object.defineProperty,c=b(a,a,a)&&b}catch(a){}return c}(),c="".indexOf,d=function(b){if(null==this)throw new TypeError;var d=String(this);if(b&&"[object RegExp]"==a.call(b))throw new TypeError;var e=d.length,f=String(b),g=f.length,h=arguments.length>1?arguments[1]:void 0,i=h?Number(h):0;i!=i&&(i=0);var j=Math.min(Math.max(i,0),e);return!(g+j>e)&&c.call(d,f,i)!=-1};b?b(String.prototype,"includes",{value:d,configurable:!0,writable:!0}):String.prototype.includes=d}(),String.prototype.startsWith||!function(){var a=function(){try{var a={},b=Object.defineProperty,c=b(a,a,a)&&b}catch(a){}return c}(),b={}.toString,c=function(a){if(null==this)throw new TypeError;var c=String(this);if(a&&"[object RegExp]"==b.call(a))throw new TypeError;var d=c.length,e=String(a),f=e.length,g=arguments.length>1?arguments[1]:void 0,h=g?Number(g):0;h!=h&&(h=0);var i=Math.min(Math.max(h,0),d);if(f+i>d)return!1;for(var j=-1;++j<f;)if(c.charCodeAt(i+j)!=e.charCodeAt(j))return!1;return!0};a?a(String.prototype,"startsWith",{value:c,configurable:!0,writable:!0}):String.prototype.startsWith=c}(),Object.keys||(Object.keys=function(a,b,c){c=[];for(b in a)c.hasOwnProperty.call(a,b)&&c.push(b);return c});var d={useDefault:!1,_set:a.valHooks.select.set};a.valHooks.select.set=function(b,c){return c&&!d.useDefault&&a(b).data("selected",!0),d._set.apply(this,arguments)};var e=null,f=function(){try{return new Event("change"),!0}catch(a){return!1}}();a.fn.triggerNative=function(a){var b,c=this[0];c.dispatchEvent?(f?b=new Event(a,{bubbles:!0}):(b=document.createEvent("Event"),b.initEvent(a,!0,!1)),c.dispatchEvent(b)):c.fireEvent?(b=document.createEventObject(),b.eventType=a,c.fireEvent("on"+a,b)):this.trigger(a)},a.expr.pseudos.icontains=function(b,c,d){var e=a(b).find("a"),f=(e.data("tokens")||e.text()).toString().toUpperCase();return f.includes(d[3].toUpperCase())},a.expr.pseudos.ibegins=function(b,c,d){var e=a(b).find("a"),f=(e.data("tokens")||e.text()).toString().toUpperCase();return f.startsWith(d[3].toUpperCase())},a.expr.pseudos.aicontains=function(b,c,d){var e=a(b).find("a"),f=(e.data("tokens")||e.data("normalizedText")||e.text()).toString().toUpperCase();return f.includes(d[3].toUpperCase())},a.expr.pseudos.aibegins=function(b,c,d){var e=a(b).find("a"),f=(e.data("tokens")||e.data("normalizedText")||e.text()).toString().toUpperCase();return f.startsWith(d[3].toUpperCase())};var g={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},h={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#x27;":"'","&#x60;":"`"},i=function(a){var b=function(b){return a[b]},c="(?:"+Object.keys(a).join("|")+")",d=RegExp(c),e=RegExp(c,"g");return function(a){return a=null==a?"":""+a,d.test(a)?a.replace(e,b):a}},j=i(g),k=i(h),l=function(b,c){d.useDefault||(a.valHooks.select.set=d._set,d.useDefault=!0),this.$element=a(b),this.$newElement=null,this.$button=null,this.$menu=null,this.$lis=null,this.options=c,null===this.options.title&&(this.options.title=this.$element.attr("title"));var e=this.options.windowPadding;"number"==typeof e&&(this.options.windowPadding=[e,e,e,e]),this.val=l.prototype.val,this.render=l.prototype.render,this.refresh=l.prototype.refresh,this.setStyle=l.prototype.setStyle,this.selectAll=l.prototype.selectAll,this.deselectAll=l.prototype.deselectAll,this.destroy=l.prototype.destroy,this.remove=l.prototype.remove,this.show=l.prototype.show,this.hide=l.prototype.hide,this.init()};l.VERSION="1.12.4",l.DEFAULTS={noneSelectedText:"Nothing selected",noneResultsText:"No results matched {0}",countSelectedText:function(a,b){return 1==a?"{0} item selected":"{0} items selected"},maxOptionsText:function(a,b){return[1==a?"Limit reached ({n} item max)":"Limit reached ({n} items max)",1==b?"Group limit reached ({n} item max)":"Group limit reached ({n} items max)"]},selectAllText:"Select All",deselectAllText:"Deselect All",doneButton:!1,doneButtonText:"Close",multipleSeparator:", ",styleBase:"btn",style:"btn-default",size:"auto",title:null,selectedTextFormat:"values",width:!1,container:!1,hideDisabled:!1,showSubtext:!1,showIcon:!0,showContent:!0,dropupAuto:!0,header:!1,liveSearch:!1,liveSearchPlaceholder:null,liveSearchNormalize:!1,liveSearchStyle:"contains",actionsBox:!1,iconBase:"glyphicon",tickIcon:"glyphicon-ok",showTick:!1,template:{caret:'<span class="caret"></span>'},maxOptions:!1,mobile:!1,selectOnTab:!1,dropdownAlignRight:!1,windowPadding:0},l.prototype={constructor:l,init:function(){var b=this,c=this.$element.attr("id");this.$element.addClass("bs-select-hidden"),this.liObj={},this.multiple=this.$element.prop("multiple"),this.autofocus=this.$element.prop("autofocus"),this.$newElement=this.createView(),this.$element.after(this.$newElement).appendTo(this.$newElement),this.$button=this.$newElement.children("button"),this.$menu=this.$newElement.children(".dropdown-menu"),this.$menuInner=this.$menu.children(".inner"),this.$searchbox=this.$menu.find("input"),this.$element.removeClass("bs-select-hidden"),this.options.dropdownAlignRight===!0&&this.$menu.addClass("dropdown-menu-right"),"undefined"!=typeof c&&(this.$button.attr("data-id",c),a('label[for="'+c+'"]').click(function(a){a.preventDefault(),b.$button.focus()})),this.checkDisabled(),this.clickListener(),this.options.liveSearch&&this.liveSearchListener(),this.render(),this.setStyle(),this.setWidth(),this.options.container&&this.selectPosition(),this.$menu.data("this",this),this.$newElement.data("this",this),this.options.mobile&&this.mobile(),this.$newElement.on({"hide.bs.dropdown":function(a){b.$menuInner.attr("aria-expanded",!1),b.$element.trigger("hide.bs.select",a)},"hidden.bs.dropdown":function(a){b.$element.trigger("hidden.bs.select",a)},"show.bs.dropdown":function(a){b.$menuInner.attr("aria-expanded",!0),b.$element.trigger("show.bs.select",a)},"shown.bs.dropdown":function(a){b.$element.trigger("shown.bs.select",a)}}),b.$element[0].hasAttribute("required")&&this.$element.on("invalid",function(){b.$button.addClass("bs-invalid"),b.$element.on({"focus.bs.select":function(){b.$button.focus(),b.$element.off("focus.bs.select")},"shown.bs.select":function(){b.$element.val(b.$element.val()).off("shown.bs.select")},"rendered.bs.select":function(){this.validity.valid&&b.$button.removeClass("bs-invalid"),b.$element.off("rendered.bs.select")}}),b.$button.on("blur.bs.select",function(){b.$element.focus().blur(),b.$button.off("blur.bs.select")})}),setTimeout(function(){b.$element.trigger("loaded.bs.select")})},createDropdown:function(){var b=this.multiple||this.options.showTick?" show-tick":"",c=this.$element.parent().hasClass("input-group")?" input-group-btn":"",d=this.autofocus?" autofocus":"",e=this.options.header?'<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>'+this.options.header+"</div>":"",f=this.options.liveSearch?'<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"'+(null===this.options.liveSearchPlaceholder?"":' placeholder="'+j(this.options.liveSearchPlaceholder)+'"')+' role="textbox" aria-label="Search"></div>':"",g=this.multiple&&this.options.actionsBox?'<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn btn-default">'+this.options.selectAllText+'</button><button type="button" class="actions-btn bs-deselect-all btn btn-default">'+this.options.deselectAllText+"</button></div></div>":"",h=this.multiple&&this.options.doneButton?'<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm btn-default">'+this.options.doneButtonText+"</button></div></div>":"",i='<div class="btn-group bootstrap-select'+b+c+'"><button type="button" class="'+this.options.styleBase+' dropdown-toggle" data-toggle="dropdown"'+d+' role="button"><span class="filter-option pull-left"></span>&nbsp;<span class="bs-caret">'+this.options.template.caret+'</span></button><div class="dropdown-menu open" role="combobox">'+e+f+g+'<ul class="dropdown-menu inner" role="listbox" aria-expanded="false"></ul>'+h+"</div></div>";return a(i)},createView:function(){var a=this.createDropdown(),b=this.createLi();return a.find("ul")[0].innerHTML=b,a},reloadLi:function(){var a=this.createLi();this.$menuInner[0].innerHTML=a},createLi:function(){var c=this,d=[],e=0,f=document.createElement("option"),g=-1,h=function(a,b,c,d){return"<li"+("undefined"!=typeof c&&""!==c?' class="'+c+'"':"")+("undefined"!=typeof b&&null!==b?' data-original-index="'+b+'"':"")+("undefined"!=typeof d&&null!==d?'data-optgroup="'+d+'"':"")+">"+a+"</li>"},i=function(d,e,f,g){return'<a tabindex="0"'+("undefined"!=typeof e?' class="'+e+'"':"")+(f?' style="'+f+'"':"")+(c.options.liveSearchNormalize?' data-normalized-text="'+b(j(a(d).html()))+'"':"")+("undefined"!=typeof g||null!==g?' data-tokens="'+g+'"':"")+' role="option">'+d+'<span class="'+c.options.iconBase+" "+c.options.tickIcon+' check-mark"></span></a>'};if(this.options.title&&!this.multiple&&(g--,!this.$element.find(".bs-title-option").length)){var k=this.$element[0];f.className="bs-title-option",f.innerHTML=this.options.title,f.value="",k.insertBefore(f,k.firstChild);var l=a(k.options[k.selectedIndex]);void 0===l.attr("selected")&&void 0===this.$element.data("selected")&&(f.selected=!0)}var m=this.$element.find("option");return m.each(function(b){var f=a(this);if(g++,!f.hasClass("bs-title-option")){var k,l=this.className||"",n=j(this.style.cssText),o=f.data("content")?f.data("content"):f.html(),p=f.data("tokens")?f.data("tokens"):null,q="undefined"!=typeof f.data("subtext")?'<small class="text-muted">'+f.data("subtext")+"</small>":"",r="undefined"!=typeof f.data("icon")?'<span class="'+c.options.iconBase+" "+f.data("icon")+'"></span> ':"",s=f.parent(),t="OPTGROUP"===s[0].tagName,u=t&&s[0].disabled,v=this.disabled||u;if(""!==r&&v&&(r="<span>"+r+"</span>"),c.options.hideDisabled&&(v&&!t||u))return k=f.data("prevHiddenIndex"),f.next().data("prevHiddenIndex",void 0!==k?k:b),void g--;if(f.data("content")||(o=r+'<span class="text">'+o+q+"</span>"),t&&f.data("divider")!==!0){if(c.options.hideDisabled&&v){if(void 0===s.data("allOptionsDisabled")){var w=s.children();s.data("allOptionsDisabled",w.filter(":disabled").length===w.length)}if(s.data("allOptionsDisabled"))return void g--}var x=" "+s[0].className||"";if(0===f.index()){e+=1;var y=s[0].label,z="undefined"!=typeof s.data("subtext")?'<small class="text-muted">'+s.data("subtext")+"</small>":"",A=s.data("icon")?'<span class="'+c.options.iconBase+" "+s.data("icon")+'"></span> ':"";y=A+'<span class="text">'+j(y)+z+"</span>",0!==b&&d.length>0&&(g++,d.push(h("",null,"divider",e+"div"))),g++,d.push(h(y,null,"dropdown-header"+x,e))}if(c.options.hideDisabled&&v)return void g--;d.push(h(i(o,"opt "+l+x,n,p),b,"",e))}else if(f.data("divider")===!0)d.push(h("",b,"divider"));else if(f.data("hidden")===!0)k=f.data("prevHiddenIndex"),f.next().data("prevHiddenIndex",void 0!==k?k:b),d.push(h(i(o,l,n,p),b,"hidden is-hidden"));else{var B=this.previousElementSibling&&"OPTGROUP"===this.previousElementSibling.tagName;if(!B&&c.options.hideDisabled&&(k=f.data("prevHiddenIndex"),void 0!==k)){var C=m.eq(k)[0].previousElementSibling;C&&"OPTGROUP"===C.tagName&&!C.disabled&&(B=!0)}B&&(g++,d.push(h("",null,"divider",e+"div"))),d.push(h(i(o,l,n,p),b))}c.liObj[b]=g}}),this.multiple||0!==this.$element.find("option:selected").length||this.options.title||this.$element.find("option").eq(0).prop("selected",!0).attr("selected","selected"),d.join("")},findLis:function(){return null==this.$lis&&(this.$lis=this.$menu.find("li")),this.$lis},render:function(b){var c,d=this,e=this.$element.find("option");b!==!1&&e.each(function(a){var b=d.findLis().eq(d.liObj[a]);d.setDisabled(a,this.disabled||"OPTGROUP"===this.parentNode.tagName&&this.parentNode.disabled,b),d.setSelected(a,this.selected,b)}),this.togglePlaceholder(),this.tabIndex();var f=e.map(function(){if(this.selected){if(d.options.hideDisabled&&(this.disabled||"OPTGROUP"===this.parentNode.tagName&&this.parentNode.disabled))return;var b,c=a(this),e=c.data("icon")&&d.options.showIcon?'<i class="'+d.options.iconBase+" "+c.data("icon")+'"></i> ':"";return b=d.options.showSubtext&&c.data("subtext")&&!d.multiple?' <small class="text-muted">'+c.data("subtext")+"</small>":"","undefined"!=typeof c.attr("title")?c.attr("title"):c.data("content")&&d.options.showContent?c.data("content").toString():e+c.html()+b}}).toArray(),g=this.multiple?f.join(this.options.multipleSeparator):f[0];if(this.multiple&&this.options.selectedTextFormat.indexOf("count")>-1){var h=this.options.selectedTextFormat.split(">");if(h.length>1&&f.length>h[1]||1==h.length&&f.length>=2){c=this.options.hideDisabled?", [disabled]":"";var i=e.not('[data-divider="true"], [data-hidden="true"]'+c).length,j="function"==typeof this.options.countSelectedText?this.options.countSelectedText(f.length,i):this.options.countSelectedText;g=j.replace("{0}",f.length.toString()).replace("{1}",i.toString())}}void 0==this.options.title&&(this.options.title=this.$element.attr("title")),"static"==this.options.selectedTextFormat&&(g=this.options.title),g||(g="undefined"!=typeof this.options.title?this.options.title:this.options.noneSelectedText),this.$button.attr("title",k(a.trim(g.replace(/<[^>]*>?/g,"")))),this.$button.children(".filter-option").html(g),this.$element.trigger("rendered.bs.select")},setStyle:function(a,b){this.$element.attr("class")&&this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi,""));var c=a?a:this.options.style;"add"==b?this.$button.addClass(c):"remove"==b?this.$button.removeClass(c):(this.$button.removeClass(this.options.style),this.$button.addClass(c))},liHeight:function(b){if(b||this.options.size!==!1&&!this.sizeInfo){var c=document.createElement("div"),d=document.createElement("div"),e=document.createElement("ul"),f=document.createElement("li"),g=document.createElement("li"),h=document.createElement("a"),i=document.createElement("span"),j=this.options.header&&this.$menu.find(".popover-title").length>0?this.$menu.find(".popover-title")[0].cloneNode(!0):null,k=this.options.liveSearch?document.createElement("div"):null,l=this.options.actionsBox&&this.multiple&&this.$menu.find(".bs-actionsbox").length>0?this.$menu.find(".bs-actionsbox")[0].cloneNode(!0):null,m=this.options.doneButton&&this.multiple&&this.$menu.find(".bs-donebutton").length>0?this.$menu.find(".bs-donebutton")[0].cloneNode(!0):null;if(i.className="text",c.className=this.$menu[0].parentNode.className+" open",d.className="dropdown-menu open",e.className="dropdown-menu inner",f.className="divider",i.appendChild(document.createTextNode("Inner text")),h.appendChild(i),g.appendChild(h),e.appendChild(g),e.appendChild(f),j&&d.appendChild(j),k){var n=document.createElement("input");k.className="bs-searchbox",n.className="form-control",k.appendChild(n),d.appendChild(k)}l&&d.appendChild(l),d.appendChild(e),m&&d.appendChild(m),c.appendChild(d),document.body.appendChild(c);var o=h.offsetHeight,p=j?j.offsetHeight:0,q=k?k.offsetHeight:0,r=l?l.offsetHeight:0,s=m?m.offsetHeight:0,t=a(f).outerHeight(!0),u="function"==typeof getComputedStyle&&getComputedStyle(d),v=u?null:a(d),w={vert:parseInt(u?u.paddingTop:v.css("paddingTop"))+parseInt(u?u.paddingBottom:v.css("paddingBottom"))+parseInt(u?u.borderTopWidth:v.css("borderTopWidth"))+parseInt(u?u.borderBottomWidth:v.css("borderBottomWidth")),horiz:parseInt(u?u.paddingLeft:v.css("paddingLeft"))+parseInt(u?u.paddingRight:v.css("paddingRight"))+parseInt(u?u.borderLeftWidth:v.css("borderLeftWidth"))+parseInt(u?u.borderRightWidth:v.css("borderRightWidth"))},x={vert:w.vert+parseInt(u?u.marginTop:v.css("marginTop"))+parseInt(u?u.marginBottom:v.css("marginBottom"))+2,horiz:w.horiz+parseInt(u?u.marginLeft:v.css("marginLeft"))+parseInt(u?u.marginRight:v.css("marginRight"))+2};document.body.removeChild(c),this.sizeInfo={liHeight:o,headerHeight:p,searchHeight:q,actionsHeight:r,doneButtonHeight:s,dividerHeight:t,menuPadding:w,menuExtras:x}}},setSize:function(){if(this.findLis(),this.liHeight(),this.options.header&&this.$menu.css("padding-top",0),this.options.size!==!1){var b,c,d,e,f,g,h,i,j=this,k=this.$menu,l=this.$menuInner,m=a(window),n=this.$newElement[0].offsetHeight,o=this.$newElement[0].offsetWidth,p=this.sizeInfo.liHeight,q=this.sizeInfo.headerHeight,r=this.sizeInfo.searchHeight,s=this.sizeInfo.actionsHeight,t=this.sizeInfo.doneButtonHeight,u=this.sizeInfo.dividerHeight,v=this.sizeInfo.menuPadding,w=this.sizeInfo.menuExtras,x=this.options.hideDisabled?".disabled":"",y=function(){var b,c=j.$newElement.offset(),d=a(j.options.container);j.options.container&&!d.is("body")?(b=d.offset(),b.top+=parseInt(d.css("borderTopWidth")),b.left+=parseInt(d.css("borderLeftWidth"))):b={top:0,left:0};var e=j.options.windowPadding;f=c.top-b.top-m.scrollTop(),g=m.height()-f-n-b.top-e[2],h=c.left-b.left-m.scrollLeft(),i=m.width()-h-o-b.left-e[1],f-=e[0],h-=e[3]};if(y(),"auto"===this.options.size){var z=function(){var m,n=function(b,c){return function(d){return c?d.classList?d.classList.contains(b):a(d).hasClass(b):!(d.classList?d.classList.contains(b):a(d).hasClass(b))}},u=j.$menuInner[0].getElementsByTagName("li"),x=Array.prototype.filter?Array.prototype.filter.call(u,n("hidden",!1)):j.$lis.not(".hidden"),z=Array.prototype.filter?Array.prototype.filter.call(x,n("dropdown-header",!0)):x.filter(".dropdown-header");y(),b=g-w.vert,c=i-w.horiz,j.options.container?(k.data("height")||k.data("height",k.height()),d=k.data("height"),k.data("width")||k.data("width",k.width()),e=k.data("width")):(d=k.height(),e=k.width()),j.options.dropupAuto&&j.$newElement.toggleClass("dropup",f>g&&b-w.vert<d),j.$newElement.hasClass("dropup")&&(b=f-w.vert),"auto"===j.options.dropdownAlignRight&&k.toggleClass("dropdown-menu-right",h>i&&c-w.horiz<e-o),m=x.length+z.length>3?3*p+w.vert-2:0,k.css({"max-height":b+"px",overflow:"hidden","min-height":m+q+r+s+t+"px"}),l.css({"max-height":b-q-r-s-t-v.vert+"px","overflow-y":"auto","min-height":Math.max(m-v.vert,0)+"px"})};z(),this.$searchbox.off("input.getSize propertychange.getSize").on("input.getSize propertychange.getSize",z),m.off("resize.getSize scroll.getSize").on("resize.getSize scroll.getSize",z)}else if(this.options.size&&"auto"!=this.options.size&&this.$lis.not(x).length>this.options.size){var A=this.$lis.not(".divider").not(x).children().slice(0,this.options.size).last().parent().index(),B=this.$lis.slice(0,A+1).filter(".divider").length;b=p*this.options.size+B*u+v.vert,j.options.container?(k.data("height")||k.data("height",k.height()),d=k.data("height")):d=k.height(),j.options.dropupAuto&&this.$newElement.toggleClass("dropup",f>g&&b-w.vert<d),k.css({"max-height":b+q+r+s+t+"px",overflow:"hidden","min-height":""}),l.css({"max-height":b-v.vert+"px","overflow-y":"auto","min-height":""})}}},setWidth:function(){if("auto"===this.options.width){this.$menu.css("min-width","0");var a=this.$menu.parent().clone().appendTo("body"),b=this.options.container?this.$newElement.clone().appendTo("body"):a,c=a.children(".dropdown-menu").outerWidth(),d=b.css("width","auto").children("button").outerWidth();a.remove(),b.remove(),this.$newElement.css("width",Math.max(c,d)+"px")}else"fit"===this.options.width?(this.$menu.css("min-width",""),this.$newElement.css("width","").addClass("fit-width")):this.options.width?(this.$menu.css("min-width",""),this.$newElement.css("width",this.options.width)):(this.$menu.css("min-width",""),this.$newElement.css("width",""));this.$newElement.hasClass("fit-width")&&"fit"!==this.options.width&&this.$newElement.removeClass("fit-width")},selectPosition:function(){this.$bsContainer=a('<div class="bs-container" />');var b,c,d,e=this,f=a(this.options.container),g=function(a){e.$bsContainer.addClass(a.attr("class").replace(/form-control|fit-width/gi,"")).toggleClass("dropup",a.hasClass("dropup")),b=a.offset(),f.is("body")?c={top:0,left:0}:(c=f.offset(),c.top+=parseInt(f.css("borderTopWidth"))-f.scrollTop(),c.left+=parseInt(f.css("borderLeftWidth"))-f.scrollLeft()),d=a.hasClass("dropup")?0:a[0].offsetHeight,e.$bsContainer.css({top:b.top-c.top+d,left:b.left-c.left,width:a[0].offsetWidth})};this.$button.on("click",function(){var b=a(this);e.isDisabled()||(g(e.$newElement),e.$bsContainer.appendTo(e.options.container).toggleClass("open",!b.hasClass("open")).append(e.$menu))}),a(window).on("resize scroll",function(){g(e.$newElement)}),this.$element.on("hide.bs.select",function(){e.$menu.data("height",e.$menu.height()),e.$bsContainer.detach()})},setSelected:function(a,b,c){c||(this.togglePlaceholder(),c=this.findLis().eq(this.liObj[a])),c.toggleClass("selected",b).find("a").attr("aria-selected",b)},setDisabled:function(a,b,c){c||(c=this.findLis().eq(this.liObj[a])),b?c.addClass("disabled").children("a").attr("href","#").attr("tabindex",-1).attr("aria-disabled",!0):c.removeClass("disabled").children("a").removeAttr("href").attr("tabindex",0).attr("aria-disabled",!1)},isDisabled:function(){return this.$element[0].disabled},checkDisabled:function(){var a=this;this.isDisabled()?(this.$newElement.addClass("disabled"),this.$button.addClass("disabled").attr("tabindex",-1).attr("aria-disabled",!0)):(this.$button.hasClass("disabled")&&(this.$newElement.removeClass("disabled"),this.$button.removeClass("disabled").attr("aria-disabled",!1)),this.$button.attr("tabindex")!=-1||this.$element.data("tabindex")||this.$button.removeAttr("tabindex")),this.$button.click(function(){return!a.isDisabled()})},togglePlaceholder:function(){var a=this.$element.val();this.$button.toggleClass("bs-placeholder",null===a||""===a||a.constructor===Array&&0===a.length)},tabIndex:function(){this.$element.data("tabindex")!==this.$element.attr("tabindex")&&this.$element.attr("tabindex")!==-98&&"-98"!==this.$element.attr("tabindex")&&(this.$element.data("tabindex",this.$element.attr("tabindex")),this.$button.attr("tabindex",this.$element.data("tabindex"))),this.$element.attr("tabindex",-98)},clickListener:function(){var b=this,c=a(document);c.data("spaceSelect",!1),this.$button.on("keyup",function(a){/(32)/.test(a.keyCode.toString(10))&&c.data("spaceSelect")&&(a.preventDefault(),c.data("spaceSelect",!1))}),this.$button.on("click",function(){b.setSize()}),this.$element.on("shown.bs.select",function(){if(b.options.liveSearch||b.multiple){if(!b.multiple){var a=b.liObj[b.$element[0].selectedIndex];if("number"!=typeof a||b.options.size===!1)return;var c=b.$lis.eq(a)[0].offsetTop-b.$menuInner[0].offsetTop;c=c-b.$menuInner[0].offsetHeight/2+b.sizeInfo.liHeight/2,b.$menuInner[0].scrollTop=c}}else b.$menuInner.find(".selected a").focus()}),this.$menuInner.on("click","li a",function(c){var d=a(this),f=d.parent().data("originalIndex"),g=b.$element.val(),h=b.$element.prop("selectedIndex"),i=!0;if(b.multiple&&1!==b.options.maxOptions&&c.stopPropagation(),c.preventDefault(),!b.isDisabled()&&!d.parent().hasClass("disabled")){var j=b.$element.find("option"),k=j.eq(f),l=k.prop("selected"),m=k.parent("optgroup"),n=b.options.maxOptions,o=m.data("maxOptions")||!1;if(b.multiple){if(k.prop("selected",!l),b.setSelected(f,!l),d.blur(),n!==!1||o!==!1){var p=n<j.filter(":selected").length,q=o<m.find("option:selected").length;if(n&&p||o&&q)if(n&&1==n)j.prop("selected",!1),k.prop("selected",!0),b.$menuInner.find(".selected").removeClass("selected"),b.setSelected(f,!0);else if(o&&1==o){m.find("option:selected").prop("selected",!1),k.prop("selected",!0);var r=d.parent().data("optgroup");b.$menuInner.find('[data-optgroup="'+r+'"]').removeClass("selected"),b.setSelected(f,!0)}else{var s="string"==typeof b.options.maxOptionsText?[b.options.maxOptionsText,b.options.maxOptionsText]:b.options.maxOptionsText,t="function"==typeof s?s(n,o):s,u=t[0].replace("{n}",n),v=t[1].replace("{n}",o),w=a('<div class="notify"></div>');t[2]&&(u=u.replace("{var}",t[2][n>1?0:1]),v=v.replace("{var}",t[2][o>1?0:1])),k.prop("selected",!1),b.$menu.append(w),n&&p&&(w.append(a("<div>"+u+"</div>")),i=!1,b.$element.trigger("maxReached.bs.select")),o&&q&&(w.append(a("<div>"+v+"</div>")),i=!1,b.$element.trigger("maxReachedGrp.bs.select")),setTimeout(function(){b.setSelected(f,!1)},10),w.delay(750).fadeOut(300,function(){a(this).remove()})}}}else j.prop("selected",!1),k.prop("selected",!0),b.$menuInner.find(".selected").removeClass("selected").find("a").attr("aria-selected",!1),b.setSelected(f,!0);!b.multiple||b.multiple&&1===b.options.maxOptions?b.$button.focus():b.options.liveSearch&&b.$searchbox.focus(),i&&(g!=b.$element.val()&&b.multiple||h!=b.$element.prop("selectedIndex")&&!b.multiple)&&(e=[f,k.prop("selected"),l],b.$element.triggerNative("change"))}}),this.$menu.on("click","li.disabled a, .popover-title, .popover-title :not(.close)",function(c){c.currentTarget==this&&(c.preventDefault(),c.stopPropagation(),b.options.liveSearch&&!a(c.target).hasClass("close")?b.$searchbox.focus():b.$button.focus())}),this.$menuInner.on("click",".divider, .dropdown-header",function(a){a.preventDefault(),a.stopPropagation(),b.options.liveSearch?b.$searchbox.focus():b.$button.focus()}),this.$menu.on("click",".popover-title .close",function(){b.$button.click()}),this.$searchbox.on("click",function(a){a.stopPropagation()}),this.$menu.on("click",".actions-btn",function(c){b.options.liveSearch?b.$searchbox.focus():b.$button.focus(),c.preventDefault(),c.stopPropagation(),a(this).hasClass("bs-select-all")?b.selectAll():b.deselectAll()}),this.$element.change(function(){b.render(!1),b.$element.trigger("changed.bs.select",e),e=null})},liveSearchListener:function(){var c=this,d=a('<li class="no-results"></li>');this.$button.on("click.dropdown.data-api",function(){c.$menuInner.find(".active").removeClass("active"),c.$searchbox.val()&&(c.$searchbox.val(""),c.$lis.not(".is-hidden").removeClass("hidden"),d.parent().length&&d.remove()),c.multiple||c.$menuInner.find(".selected").addClass("active"),setTimeout(function(){c.$searchbox.focus()},10)}),this.$searchbox.on("click.dropdown.data-api focus.dropdown.data-api touchend.dropdown.data-api",function(a){a.stopPropagation()}),this.$searchbox.on("input propertychange",function(){if(c.$lis.not(".is-hidden").removeClass("hidden"),c.$lis.filter(".active").removeClass("active"),d.remove(),c.$searchbox.val()){var e,f=c.$lis.not(".is-hidden, .divider, .dropdown-header");if(e=c.options.liveSearchNormalize?f.not(":a"+c._searchStyle()+'("'+b(c.$searchbox.val())+'")'):f.not(":"+c._searchStyle()+'("'+c.$searchbox.val()+'")'),e.length===f.length)d.html(c.options.noneResultsText.replace("{0}",'"'+j(c.$searchbox.val())+'"')),c.$menuInner.append(d),c.$lis.addClass("hidden");else{e.addClass("hidden");var g,h=c.$lis.not(".hidden");h.each(function(b){var c=a(this);c.hasClass("divider")?void 0===g?c.addClass("hidden"):(g&&g.addClass("hidden"),g=c):c.hasClass("dropdown-header")&&h.eq(b+1).data("optgroup")!==c.data("optgroup")?c.addClass("hidden"):g=null}),g&&g.addClass("hidden"),f.not(".hidden").first().addClass("active"),c.$menuInner.scrollTop(0)}}})},_searchStyle:function(){var a={begins:"ibegins",startsWith:"ibegins"};return a[this.options.liveSearchStyle]||"icontains"},val:function(a){return"undefined"!=typeof a?(this.$element.val(a),this.render(),this.$element):this.$element.val()},changeAll:function(b){if(this.multiple){"undefined"==typeof b&&(b=!0),this.findLis();var c=this.$element.find("option"),d=this.$lis.not(".divider, .dropdown-header, .disabled, .hidden"),e=d.length,f=[];if(b){if(d.filter(".selected").length===d.length)return}else if(0===d.filter(".selected").length)return;d.toggleClass("selected",b);for(var g=0;g<e;g++){var h=d[g].getAttribute("data-original-index");f[f.length]=c.eq(h)[0]}a(f).prop("selected",b),this.render(!1),this.togglePlaceholder(),this.$element.triggerNative("change")}},selectAll:function(){return this.changeAll(!0)},deselectAll:function(){return this.changeAll(!1)},toggle:function(a){a=a||window.event,a&&a.stopPropagation(),this.$button.trigger("click")},keydown:function(b){var c,d,e,f,g=a(this),h=g.is("input")?g.parent().parent():g.parent(),i=h.data("this"),j=":not(.disabled, .hidden, .dropdown-header, .divider)",k={32:" ",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9"};if(f=i.$newElement.hasClass("open"),!f&&(b.keyCode>=48&&b.keyCode<=57||b.keyCode>=96&&b.keyCode<=105||b.keyCode>=65&&b.keyCode<=90))return i.options.container?i.$button.trigger("click"):(i.setSize(),i.$menu.parent().addClass("open"),f=!0),void i.$searchbox.focus();if(i.options.liveSearch&&/(^9$|27)/.test(b.keyCode.toString(10))&&f&&(b.preventDefault(),b.stopPropagation(),i.$menuInner.click(),i.$button.focus()),/(38|40)/.test(b.keyCode.toString(10))){if(c=i.$lis.filter(j),!c.length)return;d=i.options.liveSearch?c.index(c.filter(".active")):c.index(c.find("a").filter(":focus").parent()),e=i.$menuInner.data("prevIndex"),38==b.keyCode?(!i.options.liveSearch&&d!=e||d==-1||d--,d<0&&(d+=c.length)):40==b.keyCode&&((i.options.liveSearch||d==e)&&d++,d%=c.length),i.$menuInner.data("prevIndex",d),i.options.liveSearch?(b.preventDefault(),g.hasClass("dropdown-toggle")||(c.removeClass("active").eq(d).addClass("active").children("a").focus(),g.focus())):c.eq(d).children("a").focus()}else if(!g.is("input")){var l,m,n=[];c=i.$lis.filter(j),c.each(function(c){a.trim(a(this).children("a").text().toLowerCase()).substring(0,1)==k[b.keyCode]&&n.push(c)}),l=a(document).data("keycount"),l++,a(document).data("keycount",l),m=a.trim(a(":focus").text().toLowerCase()).substring(0,1),m!=k[b.keyCode]?(l=1,a(document).data("keycount",l)):l>=n.length&&(a(document).data("keycount",0),l>n.length&&(l=1)),c.eq(n[l-1]).children("a").focus()}if((/(13|32)/.test(b.keyCode.toString(10))||/(^9$)/.test(b.keyCode.toString(10))&&i.options.selectOnTab)&&f){if(/(32)/.test(b.keyCode.toString(10))||b.preventDefault(),i.options.liveSearch)/(32)/.test(b.keyCode.toString(10))||(i.$menuInner.find(".active a").click(),g.focus());else{var o=a(":focus");o.click(),o.focus(),b.preventDefault(),a(document).data("spaceSelect",!0)}a(document).data("keycount",0)}(/(^9$|27)/.test(b.keyCode.toString(10))&&f&&(i.multiple||i.options.liveSearch)||/(27)/.test(b.keyCode.toString(10))&&!f)&&(i.$menu.parent().removeClass("open"),i.options.container&&i.$newElement.removeClass("open"),i.$button.focus())},mobile:function(){this.$element.addClass("mobile-device")},refresh:function(){this.$lis=null,this.liObj={},this.reloadLi(),this.render(),this.checkDisabled(),this.liHeight(!0),this.setStyle(),
this.setWidth(),this.$lis&&this.$searchbox.trigger("propertychange"),this.$element.trigger("refreshed.bs.select")},hide:function(){this.$newElement.hide()},show:function(){this.$newElement.show()},remove:function(){this.$newElement.remove(),this.$element.remove()},destroy:function(){this.$newElement.before(this.$element).remove(),this.$bsContainer?this.$bsContainer.remove():this.$menu.remove(),this.$element.off(".bs.select").removeData("selectpicker").removeClass("bs-select-hidden selectpicker")}};var m=a.fn.selectpicker;a.fn.selectpicker=c,a.fn.selectpicker.Constructor=l,a.fn.selectpicker.noConflict=function(){return a.fn.selectpicker=m,this},a(document).data("keycount",0).on("keydown.bs.select",'.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="listbox"], .bs-searchbox input',l.prototype.keydown).on("focusin.modal",'.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="listbox"], .bs-searchbox input',function(a){a.stopPropagation()}),a(window).on("load.bs.select.data-api",function(){a(".selectpicker").each(function(){var b=a(this);c.call(b,b.data())})})}(a)});
//# sourceMappingURL=bootstrap-select.js.map

/***/ }),

/***/ "eVkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModeraFunction__ = __webpack_require__("E1Jw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

$(".UserLayer_group").siblings().slideToggle();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RightBar',
    props: {
        displayMode: {
            default: ''
        },
        userInfo: {
            default: ''
        }
    },
    watch: {
        'userInfo.isGuest': {
            handler: function handler(val, oldval) {
                // if(val = 'yes')
                {
                    this.allPersonLayerStatus = {};
                }
            },
            deep: true
        }
    },
    data: function data() {
        return {
            msg: 'This is RightNavigation1!',
            // displayMode: "PERSONDATA",
            isActive: false,
            allGlobeLayers: {},
            allGlobeLayerStatus: {},
            allPersonLayerStatus: {},
            isShowAirPackageList: true,
            isShow3DtilesList: false,
            isShowGeoJsonList: false,
            isShowCZMLList: false,
            isShowPlaceMarkList: false,
            isShowFlyList: false,
            imageLayerFlag: 0,
            imageLayerValuableCount: 1
        };
    },

    /*watch: {
        layerData: {
            handler:function(val,oldval){
                pfAirViewer._personLayerManager.initializeData(val);
            },  
            deep:true
        }
    },*/
    mounted: function mounted() {
        this.$axios.get("./static/globeLayer.json").then(this.updateGlobeInfo, this.errorHandle);
    },
    methods: {
        closeDisplay: function closeDisplay() {
            this.$emit('closeNav', '');
        },
        setPersonLayerStatus: function setPersonLayerStatus(layer, value) {
            if (!this.allPersonLayerStatus[layer.name]) {
                if (layer.type === "fly") {
                    for (var i in this.allPersonLayerStatus) {
                        if (this.allPersonLayerStatus[i].type === "fly") {
                            this.allPersonLayerStatus[i].status = "hide";
                        }
                    }
                }
                this.$set(this.allPersonLayerStatus, layer.name, {
                    status: "show",
                    type: layer.type
                });
            } else {
                if (this.allPersonLayerStatus[layer.name].status === "hide") {
                    if (layer.type === "fly") {
                        for (var i in this.allPersonLayerStatus) {
                            if (this.allPersonLayerStatus[i].type === "fly") {
                                this.allPersonLayerStatus[i].status = "hide";
                            }
                        }
                    }
                    this.allPersonLayerStatus[layer.name].status = "show";
                } else {
                    this.allPersonLayerStatus[layer.name].status = "hide";
                }
            }
            pfAirViewer._personLayerManager.processDataStatus(layer.name);
        },
        updateGlobeInfo: function updateGlobeInfo(globeInfo) {
            var layers = pfAirViewer.scene.imageryLayers;
            this.allGlobeLayers = globeInfo.data;
            //console.log(this.allGlobeLayers);
            for (var i in this.allGlobeLayers) {
                if (this.allGlobeLayers[i].category === "WMTS_IMAGE") {
                    var imageLayers = this.allGlobeLayers[i].layers;
                    imageLayers.sort(function (aValue, bValue) {
                        aValue.indexOverlay = Cesium.defaultValue(aValue.indexOverlay, 1);
                        bValue.indexOverlay = Cesium.defaultValue(bValue.indexOverlay, 1);
                        return parseInt(aValue.indexOverlay) - parseInt(bValue.indexOverlay);
                    });
                    for (var j in imageLayers) {
                        var imageProvider = new Cesium[imageLayers[j].cesiumData.dataType](imageLayers[j].cesiumData.options);
                        if (!Cesium.defined(imageLayers[j].cesiumData.layerOptions)) {
                            imageLayers[j].cesiumData.layerOptions = {};
                        }
                        var imageLayer = new Cesium.ImageryLayer(imageProvider, imageLayers[j].cesiumData.layerOptions);
                        layers.add(imageLayer);
                        imageLayer.defaultAlpha = imageLayers[j].cesiumData.defaultAlpha;
                        imageLayer.show = imageLayers[j].cesiumData.isShow === "true" ? true : false;
                        imageLayers[j].indexOverLay = layers.length - 1;
                        //console.log(layers);
                    }
                } else if (this.allGlobeLayers[i].category === "WMTS_TERRAIN") {
                    var terrainLayers = this.allGlobeLayers[i].layers;
                    for (var j in terrainLayers) {
                        if (terrainLayers[j].cesiumData.isShow === "true") {
                            pfAirViewer.terrainProvider = new Cesium[terrainLayers[j].cesiumData.dataType](terrainLayers[j].cesiumData.options);
                        }
                    }
                }
                //this.allGlobeLayers[i].layers;
            }
        },
        setGlobeLayerStatus: function setGlobeLayerStatus(layerIndex, categoryIndex) {
            //debugger;
            var globeLayerJson = this.allGlobeLayers[categoryIndex].layers[layerIndex];
            var layerCategory = this.allGlobeLayers[categoryIndex].category;
            if (layerCategory === "WMTS_IMAGE") {
                if (globeLayerJson.cesiumData.isShow === "true") {
                    pfAirViewer.scene.imageryLayers.get(globeLayerJson.indexOverLay).show = false;
                    globeLayerJson.cesiumData.isShow = "false";
                } else {
                    pfAirViewer.scene.imageryLayers.get(globeLayerJson.indexOverLay).show = true;
                    globeLayerJson.cesiumData.isShow = "true";
                }
            } else if (layerCategory === "WMTS_TERRAIN") {
                if (globeLayerJson.cesiumData.isShow === "true") {
                    //pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                    pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                    globeLayerJson.cesiumData.isShow = "false";
                } else {
                    pfAirViewer.terrainProvider = new Cesium[globeLayerJson.cesiumData.dataType](globeLayerJson.cesiumData.options);
                    globeLayerJson.cesiumData.isShow = "true";
                }
            }
            console.log(globeLayerJson);
            console.log(this.allGlobeLayers);
            /*if(!this.allGlobeLayerStatus[globeLayerJson.id]) // loading
            {
                // this.$set(this.allGlobeLayerStatus,layerName,"show");
                if(globeLayerJson.type === "WMTS_IMAGE")
                {
                    this.imageLayerFlag++;
                    this.$set(this.allGlobeLayerStatus,globeLayerJson.id,{
                        status: "new",
                        index: this.imageLayerFlag
                    });
                }
                else{
                    this.$set(this.allGlobeLayerStatus,globeLayerJson.id,{
                        status: "new",
                        index: -1
                    });
                }
            }else{
                if(this.allGlobeLayerStatus[globeLayerJson.id].status === "hide")
                {
                    this.allGlobeLayerStatus[globeLayerJson.id].status = "show";
                }else{
                    this.allGlobeLayerStatus[globeLayerJson.id].status = "hide";
                }
            }
            this.setRealGolbeLayerStatus(globeLayerJson, this.allGlobeLayerStatus[globeLayerJson.id].status);*/
        },
        setRealGolbeLayerStatus: function setRealGolbeLayerStatus(layerJson, layerStatus) {
            var layers = pfAirViewer.scene.imageryLayers;
            if (layerStatus === "new") {
                if (Cesium[layerJson.cesiumData.dataType]) {
                    if (layerJson.type === "WMTS_TERRAIN") //terrain
                        {
                            pfAirViewer.terrainProvider = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                        } else if (layerJson.type === "WMTS_IMAGE") {
                        //layers.removeAll();
                        this.imageLayerValuableCount++;
                        var imageLayer = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                        imageLayer.defaultAlpha = layerJson.cesiumData.defaultAlpha;
                        layers.addImageryProvider(imageLayer);
                        //layers.get(0).show = false;
                    }
                }
            } else if (layerStatus === "show") {
                if (layerJson.type === "WMTS_TERRAIN") //terrain
                    {
                        pfAirViewer.terrainProvider = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                    } else if (layerJson.type === "WMTS_IMAGE") {
                    this.imageLayerValuableCount++;
                    layers.get(this.allGlobeLayerStatus[layerJson.id].index).show = true;
                    layers.get(0).show = false;
                }
            } else if (layerStatus === "hide") {
                if (layerJson.type === "WMTS_TERRAIN") //terrain
                    {
                        pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                    } else if (layerJson.type === "WMTS_IMAGE") {
                    this.imageLayerValuableCount--;
                    layers.get(this.allGlobeLayerStatus[layerJson.id].index).show = false;
                    if (this.imageLayerValuableCount === 1) {
                        layers.get(0).show = true;
                    }
                }
            } else {
                console.log("LayerStatus error!");
            }
        },
        errorHandle: function errorHandle(info) {
            console.log(info);
        }
    },
    components: {
        ModeraFunction: __WEBPACK_IMPORTED_MODULE_0__components_ModeraFunction__["a" /* default */]
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "gOQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RightNavigation__ = __webpack_require__("9sTt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DrawToolBar__ = __webpack_require__("L9FR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RightBar',
    props: {
        userData: {
            default: ''
        }
    },
    data: function data() {
        return {
            msg: 'This is right tool bar!',
            isActive: true,
            displayMode: 'PERSONDATA',
            isDisplayEditor: false,
            Scene3D: true,
            is_clicked: false
        };
    },

    mounted: function mounted() {
        pfAirViewer._drawLayerManager = new Cesium.DataManager({
            id: "draw",
            viewer: pfAirViewer,
            layerData: []
        });
        // this.createDrawTool("draw_option");
        // var toolBar = pfAirViewer.createDrawTool("draw_option");
    },
    methods: {
        toggleRightNav: function toggleRightNav(mode) {
            if (mode === this.displayMode) {
                this.isActive = !this.isActive;
                this.displayMode = '';
            } else {
                this.isActive = true;
                this.displayMode = mode;
            }
        },
        closeNav: function closeNav() {
            this.displayMode = '';
            this.isActive = false;
        },
        resetView: function resetView() {
            pfAirViewer.cesiumWidget.scene.camera.flyHome();
        },
        switchSceneMode: function switchSceneMode() {
            this.Scene3D = !this.Scene3D;
            this.is_clicked = !this.is_clicked;
            if (this.Scene3D) {
                pfAirViewer.cesiumWidget.scene.morphTo3D(2);
                //pfAirViewer.cesiumWidget.scene.mapMode2D = Cesium.MapMode2D.INFINITE_SCROLL;
            } else {
                pfAirViewer.cesiumWidget.scene.morphTo2D(2);
                //pfAirViewer.cesiumWidget.scene.mapMode2D = undefined;
            }
        },
        testFunction: function testFunction() {
            /*var surface = Cesium.Cartesian3.fromDegrees(5.38369, 43.28601, 24.15);
            var offset = Cesium.Cartesian3.fromDegrees(5.38382, 43.28577, 79.10);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            var wfcValue = Cesium.Matrix4.fromTranslation(translation);
            
            var height = 55;
            var tileset = pfAirViewer._personLayerManager.getLayerData("test002").cesiumData;
            var cartographic = Cesium.Cartographic.fromCartesian(tileset.boundingSphere.center);
            var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
            var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, height);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            //tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            tileset.modelMatrix = wfcValue;
            */
            $.ajax({
                type: "GET",
                url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
                dataType: "json",
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                // username:"11",
                // password:"aaaaa",
                headers: { "Authorization": "Basic " + btoa("wfc:airbus"), "Accept": "application/json, text/plain, */*"
                    //username: "wfc",
                    //password: "airbus"
                } }).done(function (info) {
                console.log("ok");
                console.log(info);
            }).fail(function (info) {
                console.log("not ok");
                console.log(info);
            });

            /*
            var xhr = new XMLHttpRequest();
            xhr.open(
                "GET",
                "http://wfc:airbus@172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/httpAuth",
                true
            );
            //xhr.setRequestHeader('Authorization', "Basic "+btoa("123:123"));
            //Authorization: "Basic "+btoa("123:123")
            xhr.withCredentials = true;
            xhr.send();
            */
        },
        aFunction: function aFunction() {
            $.ajax({
                type: "GET",
                url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
                dataType: 'json',
                async: true,
                xhrFields: {
                    withCredentials: true
                    // username: "some_username_that_doesn't_exist",
                    // password: "any_stupid_password"
                } }).done(function () {
                //alert('Error!')
            }).fail(function () {
                //window.location = "/";
            });
        }
    },
    components: {
        RightNavigation: __WEBPACK_IMPORTED_MODULE_0__components_RightNavigation__["a" /* default */],
        DrawToolBar: __WEBPACK_IMPORTED_MODULE_1__components_DrawToolBar__["a" /* default */]
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "gu9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserClub.vue
var UserClub = __webpack_require__("AjEo");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-912d9d38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserClub.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserClub"},[_c('div',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('span',{staticClass:"exit",on:{"click":_vm.close}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"clubInfo"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"btn_d tab_box cf2 tab_box_w"},[_c('div',{staticClass:"l_7",staticStyle:{"height":"98%"}},[_c('div',{staticClass:"list_box blue_link blue_text data_box scollbarY border_d"},[_c('ul',{staticClass:"line_list",attrs:{"id":"lineSel_layer"}},_vm._l((_vm.userData.userInfo.layerData),function(item,index){return _c('li',{key:index,class:{ active: _vm.allLayerStatus[item.name] }},[(item.type!=='!AirPackage')?_c('div',[_c('span',{staticClass:"r"},[_c('span',{staticClass:"sel_box_r",on:{"click":function($event){_vm.toggleLayerStatus(item.name)}}},[_c('label',{attrs:{"for":"a_p001"}})])]),_vm._v(" "),_c('div',{staticClass:"r_cell t_l round_s_b"},[_c('div',{staticClass:"td_1 l box_size hide1"},[_c('span',{staticClass:"s_arrow",class:{ e_3: item.type==='AirPackage', e_2: item.type==='3dtile',e_1: item.type==='czml', e_5: item.type==='fly' }}),_vm._v(_vm._s(item.name)+"\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"td_4 l box_size hide1"},[_vm._v(_vm._s(item.updated_at))])])]):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"l_d_btn btn_layer cf2"},[_c('span',{staticClass:"l box_size w_2_5"},[_c('input',{staticClass:"round_s fill_btn_r red_btn",attrs:{"type":"button","value":"DELETE"},on:{"click":function($event){_vm.removeLayers()}}})]),_vm._v(" "),_c('span',{staticClass:"r box_size w_2_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"Create Demo"},on:{"click":function($event){_vm.switchCreateDemoPlane()}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowCreateLayer),expression:"isShowCreateLayer"}],staticClass:"right_data_box",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"gray_border round_s scollbarY"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layerInfoTemp.name),expression:"layerInfoTemp.name"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"Input Layer Name"},domProps:{"value":(_vm.layerInfoTemp.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.layerInfoTemp, "name", $event.target.value)}}})]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.layerInfoTemp.type === '3dtile'),expression:"layerInfoTemp.type === '3dtile'"}],staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layerInfoTemp.address),expression:"layerInfoTemp.address"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"Input Layer Address"},domProps:{"value":(_vm.layerInfoTemp.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.layerInfoTemp, "address", $event.target.value)}}})]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"r_d_btn btn_layer cf2"},[_c('span',{staticClass:"l w_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"SAVE"},on:{"click":function($event){_vm.cleateNewLayer()}}})]),_vm._v(" "),_c('span',{staticClass:"r w_5"},[_c('input',{staticClass:"round_s fill_btn_r gray_btn_g",attrs:{"type":"button","value":"CANCEL"},on:{"click":function($event){_vm.isShowCreateLayer=!_vm.isShowCreateLayer}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowCreateDemoPackage),expression:"isShowCreateDemoPackage"}],staticClass:"right_data_box",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"gray_border round_s scollbarY"},[_vm._m(3),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demoPackageInfo.name),expression:"demoPackageInfo.name"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"Input Demo Name"},domProps:{"value":(_vm.demoPackageInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demoPackageInfo, "name", $event.target.value)}}})]),_vm._v(" "),_vm._l((_vm.demoPackageInfo.dataList),function(item,index){return _c('ul',{key:index,staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demoPackageInfo.dataList[index]),expression:"demoPackageInfo.dataList[index]"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.demoPackageInfo.dataList[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demoPackageInfo.dataList, index, $event.target.value)}}})])})],2),_vm._v(" "),_c('div',{staticClass:"r_d_btn btn_layer cf2"},[_c('span',{staticClass:"l w_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"SAVE"},on:{"click":function($event){_vm.cleateDemoPackage()}}})]),_vm._v(" "),_c('span',{staticClass:"r w_5"},[_c('input',{staticClass:"round_s fill_btn_r gray_btn_g",attrs:{"type":"button","value":"CANCEL"},on:{"click":function($event){_vm.isShowCreateDemoPackage=!_vm.isShowCreateDemoPackage}}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"tab_nav tab_club_w"},[_c('dd',[_c('a',{staticClass:"btn_t tab_light"},[_vm._v("Layer Data Set")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"th_line_w btn_t"},[_c('span',{staticClass:"o_arrow m_1"}),_c('a',[_vm._v("New Layer Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"r_list"},[_c('div',{staticClass:"select box_size round_s select_box",staticStyle:{"width":"100%","margin-left":"auto","margin-right":"auto"},attrs:{"id":"newLayerType"}},[_c('p',[_vm._v("Select Layer Type")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"selected",attrs:{"data-value":""}},[_vm._v("Select Layer Type")]),_vm._v(" "),_c('li',{attrs:{"data-value":"3dtile"}},[_vm._v("3DTiles")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"th_line_w btn_t"},[_c('span',{staticClass:"o_arrow m_1"}),_c('a',[_vm._v("New Demo Package")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_UserClub = (esExports);
// CONCATENATED MODULE: ./src/components/UserClub.vue
function injectStyle (ssrContext) {
  __webpack_require__("bLrC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-912d9d38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UserClub["a" /* default */],
  components_UserClub,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_UserClub = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h+DM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hz3J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i6l0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LeftDisplayPanel__ = __webpack_require__("CW6L");
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LeftBar',
    props: {
        userData: {
            default: ''
        }
    },
    data: function data() {
        return {
            msg: 'This is left tool bar!',
            isActive: false
        };
    },

    mounted: function mounted() {
        pfAirViewer.createGeocoder('searchModule');
        $('.cesium-geocoder-input-wide').css("width", "280px");
        $('.cesium-geocoder-input').css("width", "290px");
        $('.cesium-geocoder-input').css("background-color", "rgba(243, 243, 243, 1)");
        $('.cesium-geocoder-input').css("color", "rgba(7, 8, 12, 1)");
        $('.cesium-geocoder-searchButton').css("background-color", "rgba(18, 40, 95, 1)");
    },
    methods: {
        toggleLeftNav: function toggleLeftNav(event) {
            this.isActive = !this.isActive;
        },
        switchBar: function switchBar(stateBool) {
            this.isActive = stateBool;
        }
    },
    components: {
        LeftDisplayPanel: __WEBPACK_IMPORTED_MODULE_0__components_LeftDisplayPanel__["a" /* default */]
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "iIrE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DrawToolBar',
    props: {
        userData: {
            default: ''
        },
        saveData: {
            default: function _default() {
                return {
                    name: undefined,
                    type: undefined,
                    sourceId: undefined
                };
            }
        }
    },
    data: function data() {
        return {
            msg: 'This is Data save!',
            titleName: 'Save Data',
            displaySelectedType: 'Select Layer Type',
            layerName: "",
            layerType: "",
            isWithOrientationo: true
        };
    },

    mounted: function mounted() {
        var that = this;
        $('.select > p').on('click', function (e) {
            $(this).parent('.select').toggleClass('open');
            e.stopPropagation();
        });
        $('.select > ul li').on('click', function (e) {
            var _this = $(this);
            $(this).parent().siblings('p').text(_this.attr('data-value'));
            that.saveData.type = _this.attr('data-value');
            _this.addClass('selected').siblings().removeClass('selected');
            $('.select').removeClass('open');
            e.stopPropagation();
        });
        if (this.saveData && this.saveData.type) {
            this.layerType = this.saveData.type;
            this.displaySelectedType = this.saveData.type;
        } else {
            this.displaySelectedType = "Select Layer Type";
        }
    },
    methods: {
        saveDataToUser: function saveDataToUser() {
            var saveData = [];
            if (!Cesium.defined(this.saveData.sourceId)) {
                for (var i in pfAirViewer._drawDataList._primitives) {
                    saveData.push(pfAirViewer._drawDataList._primitives[i]);
                }
                //saveData = pfAirViewer._drawDataList._primitives;
                for (var i in pfAirViewer._drawLayerManager._layerData) {
                    saveData.push(pfAirViewer._drawLayerManager._layerData[i].cesiumData);
                }
                //pfAirViewer._drawLayerManager._layerData
            } else {
                saveData = pfAirViewer._drawLayerManager._layerData[this.saveData.sourceId].cesiumData;
            }
            if (!this.checkInfo(this.saveData.name, this.saveData.type, saveData)) {
                return;
            }
            this.dataToUser(this.saveData.name, this.saveData.type, saveData);
        },
        dataToUser: function dataToUser(layerName, layerType, layerData) {
            var that = this;
            pfAirViewer._dataSave.saveData({
                name: layerName,
                type: layerType,
                data: layerData
            }).then(function (responseData) {
                if (responseData.status === "ok") //save ok
                    {
                        responseData.data.status = "no";
                        that.userData.userInfo.layerData.push(responseData.data);
                        pfAirViewer._personLayerManager.addLayerData(responseData.data.name, responseData.data);
                        //pfAirViewer._callBack.on_Draw_remove();
                        that.close(true);
                    } else if (responseData.status === "error") {
                    //Hints are abnormal
                    alert(responseData.errorInfo);
                } else {
                    alert("Looks like something is abnormal.");
                }
            });
        },
        checkInfo: function checkInfo(name, type, data) {
            if (!name || name == "") {
                alert("Name can not empty!");
                return false;
            } else if (!type || type == "") {
                alert("Data type not empty!");
                return false;
            } else if (!data) {
                alert("Can not found data!");
                return false;
            }
            return true;
        },
        close: function close(info) {
            this.$emit('closeDataSave', info);
        }
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "jExx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kgpE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DrawToolBar',
    props: {
        userData: {
            default: ''
        }
    },
    data: function data() {
        return {
            msg: 'This is Loign!',
            titleName: 'User Login',
            userName: "",
            userPassword: ""
        };
    },

    mounted: function mounted() {},
    methods: {
        login: function login() {
            /*this.$axios.post(
              "http://172.18.0.169/PFNeoWebViewer_BackEnd/public/login",{
                  email: this.userName,
                  password: this.userPassword
            }).then(this.updateUserInfo,this.errorHandle);*/
            $.post({
                url: pfAirViewer._dataSave._baseUri + '/login',
                data: {
                    email: this.userName,
                    password: this.userPassword
                },
                success: this.updateUserInfo,
                dataType: "json"
            });
        },
        updateUserInfo: function updateUserInfo(userInfo) {
            this.userData.userInfo = userInfo;
            this.close();
        },
        errorHandle: function errorHandle(info) {
            console.log(info);
        },
        close: function close() {
            this.$emit('close', '');
        }
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "rLRG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "s0Oi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tiBH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! =======================================================
                      VERSION  9.7.3              
========================================================= */
var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},windowIsDefined="object"===("undefined"==typeof window?"undefined":_typeof(window));!function(a){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("4kSj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("object"===("undefined"==typeof module?"undefined":_typeof(module))&&module.exports){var b;try{b=require("jquery")}catch(c){b=null}module.exports=a(b)}else window&&(window.Slider=a(window.jQuery))}(function(a){var b="slider",c="bootstrapSlider";windowIsDefined&&!window.console&&(window.console={}),windowIsDefined&&!window.console.log&&(window.console.log=function(){}),windowIsDefined&&!window.console.warn&&(window.console.warn=function(){});var d;return function(a){function b(){}function c(a){function c(b){b.prototype.option||(b.prototype.option=function(b){a.isPlainObject(b)&&(this.options=a.extend(!0,this.options,b))})}function e(b,c){a.fn[b]=function(e){if("string"==typeof e){for(var g=d.call(arguments,1),h=0,i=this.length;i>h;h++){var j=this[h],k=a.data(j,b);if(k)if(a.isFunction(k[e])&&"_"!==e.charAt(0)){var l=k[e].apply(k,g);if(void 0!==l&&l!==k)return l}else f("no such method '"+e+"' for "+b+" instance");else f("cannot call methods on "+b+" prior to initialization; attempted to call '"+e+"'")}return this}var m=this.map(function(){var d=a.data(this,b);return d?(d.option(e),d._init()):(d=new c(this,e),a.data(this,b,d)),a(this)});return!m||m.length>1?m:m[0]}}if(a){var f="undefined"==typeof console?b:function(a){console.error(a)};return a.bridget=function(a,b){c(b),e(a,b)},a.bridget}}var d=Array.prototype.slice;c(a)}(a),function(a){function e(b,c){function d(a,b){var c="data-slider-"+b.replace(/_/g,"-"),d=a.getAttribute(c);try{return JSON.parse(d)}catch(e){return d}}this._state={value:null,enabled:null,offset:null,size:null,percentage:null,inDrag:!1,over:!1},this.ticksCallbackMap={},this.handleCallbackMap={},"string"==typeof b?this.element=document.querySelector(b):b instanceof HTMLElement&&(this.element=b),c=c?c:{};for(var e=Object.keys(this.defaultOptions),f=0;f<e.length;f++){var h=e[f],i=c[h];i="undefined"!=typeof i?i:d(this.element,h),i=null!==i?i:this.defaultOptions[h],this.options||(this.options={}),this.options[h]=i}"auto"===this.options.rtl&&(this.options.rtl="rtl"===window.getComputedStyle(this.element).direction),"vertical"!==this.options.orientation||"top"!==this.options.tooltip_position&&"bottom"!==this.options.tooltip_position?"horizontal"!==this.options.orientation||"left"!==this.options.tooltip_position&&"right"!==this.options.tooltip_position||(this.options.tooltip_position="top"):this.options.rtl?this.options.tooltip_position="left":this.options.tooltip_position="right";var j,k,l,m,n,o=this.element.style.width,p=!1,q=this.element.parentNode;if(this.sliderElem)p=!0;else{this.sliderElem=document.createElement("div"),this.sliderElem.className="slider";var r=document.createElement("div");if(r.className="slider-track",k=document.createElement("div"),k.className="slider-track-low",j=document.createElement("div"),j.className="slider-selection",l=document.createElement("div"),l.className="slider-track-high",m=document.createElement("div"),m.className="slider-handle min-slider-handle",m.setAttribute("role","slider"),m.setAttribute("aria-valuemin",this.options.min),m.setAttribute("aria-valuemax",this.options.max),n=document.createElement("div"),n.className="slider-handle max-slider-handle",n.setAttribute("role","slider"),n.setAttribute("aria-valuemin",this.options.min),n.setAttribute("aria-valuemax",this.options.max),r.appendChild(k),r.appendChild(j),r.appendChild(l),this.rangeHighlightElements=[],Array.isArray(this.options.rangeHighlights)&&this.options.rangeHighlights.length>0)for(var s=0;s<this.options.rangeHighlights.length;s++){var t=document.createElement("div");t.className="slider-rangeHighlight slider-selection",this.rangeHighlightElements.push(t),r.appendChild(t)}var u=Array.isArray(this.options.labelledby);if(u&&this.options.labelledby[0]&&m.setAttribute("aria-labelledby",this.options.labelledby[0]),u&&this.options.labelledby[1]&&n.setAttribute("aria-labelledby",this.options.labelledby[1]),!u&&this.options.labelledby&&(m.setAttribute("aria-labelledby",this.options.labelledby),n.setAttribute("aria-labelledby",this.options.labelledby)),this.ticks=[],Array.isArray(this.options.ticks)&&this.options.ticks.length>0){for(this.ticksContainer=document.createElement("div"),this.ticksContainer.className="slider-tick-container",f=0;f<this.options.ticks.length;f++){var v=document.createElement("div");if(v.className="slider-tick",this.options.ticks_tooltip){var w=this._addTickListener(),x=w.addMouseEnter(this,v,f),y=w.addMouseLeave(this,v);this.ticksCallbackMap[f]={mouseEnter:x,mouseLeave:y}}this.ticks.push(v),this.ticksContainer.appendChild(v)}j.className+=" tick-slider-selection"}if(this.tickLabels=[],Array.isArray(this.options.ticks_labels)&&this.options.ticks_labels.length>0)for(this.tickLabelContainer=document.createElement("div"),this.tickLabelContainer.className="slider-tick-label-container",f=0;f<this.options.ticks_labels.length;f++){var z=document.createElement("div"),A=0===this.options.ticks_positions.length,B=this.options.reversed&&A?this.options.ticks_labels.length-(f+1):f;z.className="slider-tick-label",z.innerHTML=this.options.ticks_labels[B],this.tickLabels.push(z),this.tickLabelContainer.appendChild(z)}var C=function(a){var b=document.createElement("div");b.className="tooltip-arrow";var c=document.createElement("div");c.className="tooltip-inner",a.appendChild(b),a.appendChild(c)},D=document.createElement("div");D.className="tooltip tooltip-main",D.setAttribute("role","presentation"),C(D);var E=document.createElement("div");E.className="tooltip tooltip-min",E.setAttribute("role","presentation"),C(E);var F=document.createElement("div");F.className="tooltip tooltip-max",F.setAttribute("role","presentation"),C(F),this.sliderElem.appendChild(r),this.sliderElem.appendChild(D),this.sliderElem.appendChild(E),this.sliderElem.appendChild(F),this.tickLabelContainer&&this.sliderElem.appendChild(this.tickLabelContainer),this.ticksContainer&&this.sliderElem.appendChild(this.ticksContainer),this.sliderElem.appendChild(m),this.sliderElem.appendChild(n),q.insertBefore(this.sliderElem,this.element),this.element.style.display="none"}if(a&&(this.$element=a(this.element),this.$sliderElem=a(this.sliderElem)),this.eventToCallbackMap={},this.sliderElem.id=this.options.id,this.touchCapable="ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch,this.touchX=0,this.touchY=0,this.tooltip=this.sliderElem.querySelector(".tooltip-main"),this.tooltipInner=this.tooltip.querySelector(".tooltip-inner"),this.tooltip_min=this.sliderElem.querySelector(".tooltip-min"),this.tooltipInner_min=this.tooltip_min.querySelector(".tooltip-inner"),this.tooltip_max=this.sliderElem.querySelector(".tooltip-max"),this.tooltipInner_max=this.tooltip_max.querySelector(".tooltip-inner"),g[this.options.scale]&&(this.options.scale=g[this.options.scale]),p===!0&&(this._removeClass(this.sliderElem,"slider-horizontal"),this._removeClass(this.sliderElem,"slider-vertical"),this._removeClass(this.sliderElem,"slider-rtl"),this._removeClass(this.tooltip,"hide"),this._removeClass(this.tooltip_min,"hide"),this._removeClass(this.tooltip_max,"hide"),["left","right","top","width","height"].forEach(function(a){this._removeProperty(this.trackLow,a),this._removeProperty(this.trackSelection,a),this._removeProperty(this.trackHigh,a)},this),[this.handle1,this.handle2].forEach(function(a){this._removeProperty(a,"left"),this._removeProperty(a,"right"),this._removeProperty(a,"top")},this),[this.tooltip,this.tooltip_min,this.tooltip_max].forEach(function(a){this._removeProperty(a,"left"),this._removeProperty(a,"right"),this._removeProperty(a,"top"),this._removeProperty(a,"margin-left"),this._removeProperty(a,"margin-right"),this._removeProperty(a,"margin-top"),this._removeClass(a,"right"),this._removeClass(a,"left"),this._removeClass(a,"top")},this)),"vertical"===this.options.orientation?(this._addClass(this.sliderElem,"slider-vertical"),this.stylePos="top",this.mousePos="pageY",this.sizePos="offsetHeight"):(this._addClass(this.sliderElem,"slider-horizontal"),this.sliderElem.style.width=o,this.options.orientation="horizontal",this.options.rtl?this.stylePos="right":this.stylePos="left",this.mousePos="pageX",this.sizePos="offsetWidth"),this.options.rtl&&this._addClass(this.sliderElem,"slider-rtl"),this._setTooltipPosition(),Array.isArray(this.options.ticks)&&this.options.ticks.length>0&&(this.options.max=Math.max.apply(Math,this.options.ticks),this.options.min=Math.min.apply(Math,this.options.ticks)),Array.isArray(this.options.value)?(this.options.range=!0,this._state.value=this.options.value):this.options.range?this._state.value=[this.options.value,this.options.max]:this._state.value=this.options.value,this.trackLow=k||this.trackLow,this.trackSelection=j||this.trackSelection,this.trackHigh=l||this.trackHigh,"none"===this.options.selection?(this._addClass(this.trackLow,"hide"),this._addClass(this.trackSelection,"hide"),this._addClass(this.trackHigh,"hide")):("after"===this.options.selection||"before"===this.options.selection)&&(this._removeClass(this.trackLow,"hide"),this._removeClass(this.trackSelection,"hide"),this._removeClass(this.trackHigh,"hide")),this.handle1=m||this.handle1,this.handle2=n||this.handle2,p===!0)for(this._removeClass(this.handle1,"round triangle"),this._removeClass(this.handle2,"round triangle hide"),f=0;f<this.ticks.length;f++)this._removeClass(this.ticks[f],"round triangle hide");var G=["round","triangle","custom"],H=-1!==G.indexOf(this.options.handle);if(H)for(this._addClass(this.handle1,this.options.handle),this._addClass(this.handle2,this.options.handle),f=0;f<this.ticks.length;f++)this._addClass(this.ticks[f],this.options.handle);if(this._state.offset=this._offset(this.sliderElem),this._state.size=this.sliderElem[this.sizePos],this.setValue(this._state.value),this.handle1Keydown=this._keydown.bind(this,0),this.handle1.addEventListener("keydown",this.handle1Keydown,!1),this.handle2Keydown=this._keydown.bind(this,1),this.handle2.addEventListener("keydown",this.handle2Keydown,!1),this.mousedown=this._mousedown.bind(this),this.touchstart=this._touchstart.bind(this),this.touchmove=this._touchmove.bind(this),this.touchCapable){var I=!1;try{var J=Object.defineProperty({},"passive",{get:function(){I=!0}});window.addEventListener("test",null,J)}catch(K){}var L=I?{passive:!0}:!1;this.sliderElem.addEventListener("touchstart",this.touchstart,L),this.sliderElem.addEventListener("touchmove",this.touchmove,L)}if(this.sliderElem.addEventListener("mousedown",this.mousedown,!1),this.resize=this._resize.bind(this),window.addEventListener("resize",this.resize,!1),"hide"===this.options.tooltip)this._addClass(this.tooltip,"hide"),this._addClass(this.tooltip_min,"hide"),this._addClass(this.tooltip_max,"hide");else if("always"===this.options.tooltip)this._showTooltip(),this._alwaysShowTooltip=!0;else{if(this.showTooltip=this._showTooltip.bind(this),this.hideTooltip=this._hideTooltip.bind(this),this.options.ticks_tooltip){var M=this._addTickListener(),N=M.addMouseEnter(this,this.handle1),O=M.addMouseLeave(this,this.handle1);this.handleCallbackMap.handle1={mouseEnter:N,mouseLeave:O},N=M.addMouseEnter(this,this.handle2),O=M.addMouseLeave(this,this.handle2),this.handleCallbackMap.handle2={mouseEnter:N,mouseLeave:O}}else this.sliderElem.addEventListener("mouseenter",this.showTooltip,!1),this.sliderElem.addEventListener("mouseleave",this.hideTooltip,!1);this.handle1.addEventListener("focus",this.showTooltip,!1),this.handle1.addEventListener("blur",this.hideTooltip,!1),this.handle2.addEventListener("focus",this.showTooltip,!1),this.handle2.addEventListener("blur",this.hideTooltip,!1)}this.options.enabled?this.enable():this.disable()}var f={formatInvalidInputErrorMsg:function(a){return"Invalid input value '"+a+"' passed in"},callingContextNotSliderInstance:"Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"},g={linear:{toValue:function(a){var b=a/100*(this.options.max-this.options.min),c=!0;if(this.options.ticks_positions.length>0){for(var d,e,f,g=0,h=1;h<this.options.ticks_positions.length;h++)if(a<=this.options.ticks_positions[h]){d=this.options.ticks[h-1],f=this.options.ticks_positions[h-1],e=this.options.ticks[h],g=this.options.ticks_positions[h];break}var i=(a-f)/(g-f);b=d+i*(e-d),c=!1}var j=c?this.options.min:0,k=j+Math.round(b/this.options.step)*this.options.step;return k<this.options.min?this.options.min:k>this.options.max?this.options.max:k},toPercentage:function(a){if(this.options.max===this.options.min)return 0;if(this.options.ticks_positions.length>0){for(var b,c,d,e=0,f=0;f<this.options.ticks.length;f++)if(a<=this.options.ticks[f]){b=f>0?this.options.ticks[f-1]:0,d=f>0?this.options.ticks_positions[f-1]:0,c=this.options.ticks[f],e=this.options.ticks_positions[f];break}if(f>0){var g=(a-b)/(c-b);return d+g*(e-d)}}return 100*(a-this.options.min)/(this.options.max-this.options.min)}},logarithmic:{toValue:function(a){var b=0===this.options.min?0:Math.log(this.options.min),c=Math.log(this.options.max),d=Math.exp(b+(c-b)*a/100);return d=this.options.min+Math.round((d-this.options.min)/this.options.step)*this.options.step,d<this.options.min?this.options.min:d>this.options.max?this.options.max:d},toPercentage:function(a){if(this.options.max===this.options.min)return 0;var b=Math.log(this.options.max),c=0===this.options.min?0:Math.log(this.options.min),d=0===a?0:Math.log(a);return 100*(d-c)/(b-c)}}};if(d=function(a,b){return e.call(this,a,b),this},d.prototype={_init:function(){},constructor:d,defaultOptions:{id:"",min:0,max:10,step:1,precision:0,orientation:"horizontal",value:5,range:!1,selection:"before",tooltip:"show",tooltip_split:!1,handle:"round",reversed:!1,rtl:"auto",enabled:!0,formatter:function(a){return Array.isArray(a)?a[0]+" : "+a[1]:a},natural_arrow_keys:!1,ticks:[],ticks_positions:[],ticks_labels:[],ticks_snap_bounds:0,ticks_tooltip:!1,scale:"linear",focus:!1,tooltip_position:null,labelledby:null,rangeHighlights:[]},getElement:function(){return this.sliderElem},getValue:function(){return this.options.range?this._state.value:this._state.value[0]},setValue:function(a,b,c){a||(a=0);var d=this.getValue();this._state.value=this._validateInputValue(a);var e=this._applyPrecision.bind(this);this.options.range?(this._state.value[0]=e(this._state.value[0]),this._state.value[1]=e(this._state.value[1]),this._state.value[0]=Math.max(this.options.min,Math.min(this.options.max,this._state.value[0])),this._state.value[1]=Math.max(this.options.min,Math.min(this.options.max,this._state.value[1]))):(this._state.value=e(this._state.value),this._state.value=[Math.max(this.options.min,Math.min(this.options.max,this._state.value))],this._addClass(this.handle2,"hide"),"after"===this.options.selection?this._state.value[1]=this.options.max:this._state.value[1]=this.options.min),this.options.max>this.options.min?this._state.percentage=[this._toPercentage(this._state.value[0]),this._toPercentage(this._state.value[1]),100*this.options.step/(this.options.max-this.options.min)]:this._state.percentage=[0,0,100],this._layout();var f=this.options.range?this._state.value:this._state.value[0];return this._setDataVal(f),b===!0&&this._trigger("slide",f),d!==f&&c===!0&&this._trigger("change",{oldValue:d,newValue:f}),this},destroy:function(){this._removeSliderEventHandlers(),this.sliderElem.parentNode.removeChild(this.sliderElem),this.element.style.display="",this._cleanUpEventCallbacksMap(),this.element.removeAttribute("data"),a&&(this._unbindJQueryEventHandlers(),this.$element.removeData("slider"))},disable:function(){return this._state.enabled=!1,this.handle1.removeAttribute("tabindex"),this.handle2.removeAttribute("tabindex"),this._addClass(this.sliderElem,"slider-disabled"),this._trigger("slideDisabled"),this},enable:function(){return this._state.enabled=!0,this.handle1.setAttribute("tabindex",0),this.handle2.setAttribute("tabindex",0),this._removeClass(this.sliderElem,"slider-disabled"),this._trigger("slideEnabled"),this},toggle:function(){return this._state.enabled?this.disable():this.enable(),this},isEnabled:function(){return this._state.enabled},on:function(a,b){return this._bindNonQueryEventHandler(a,b),this},off:function(b,c){a?(this.$element.off(b,c),this.$sliderElem.off(b,c)):this._unbindNonQueryEventHandler(b,c)},getAttribute:function(a){return a?this.options[a]:this.options},setAttribute:function(a,b){return this.options[a]=b,this},refresh:function(){return this._removeSliderEventHandlers(),e.call(this,this.element,this.options),a&&a.data(this.element,"slider",this),this},relayout:function(){return this._resize(),this._layout(),this},_removeSliderEventHandlers:function(){if(this.handle1.removeEventListener("keydown",this.handle1Keydown,!1),this.handle2.removeEventListener("keydown",this.handle2Keydown,!1),this.options.ticks_tooltip){for(var a=this.ticksContainer.getElementsByClassName("slider-tick"),b=0;b<a.length;b++)a[b].removeEventListener("mouseenter",this.ticksCallbackMap[b].mouseEnter,!1),a[b].removeEventListener("mouseleave",this.ticksCallbackMap[b].mouseLeave,!1);this.handle1.removeEventListener("mouseenter",this.handleCallbackMap.handle1.mouseEnter,!1),this.handle2.removeEventListener("mouseenter",this.handleCallbackMap.handle2.mouseEnter,!1),this.handle1.removeEventListener("mouseleave",this.handleCallbackMap.handle1.mouseLeave,!1),this.handle2.removeEventListener("mouseleave",this.handleCallbackMap.handle2.mouseLeave,!1)}this.handleCallbackMap=null,this.ticksCallbackMap=null,this.showTooltip&&(this.handle1.removeEventListener("focus",this.showTooltip,!1),this.handle2.removeEventListener("focus",this.showTooltip,!1)),this.hideTooltip&&(this.handle1.removeEventListener("blur",this.hideTooltip,!1),this.handle2.removeEventListener("blur",this.hideTooltip,!1)),this.showTooltip&&this.sliderElem.removeEventListener("mouseenter",this.showTooltip,!1),this.hideTooltip&&this.sliderElem.removeEventListener("mouseleave",this.hideTooltip,!1),this.sliderElem.removeEventListener("touchstart",this.touchstart,!1),this.sliderElem.removeEventListener("touchmove",this.touchmove,!1),this.sliderElem.removeEventListener("mousedown",this.mousedown,!1),window.removeEventListener("resize",this.resize,!1)},_bindNonQueryEventHandler:function(a,b){void 0===this.eventToCallbackMap[a]&&(this.eventToCallbackMap[a]=[]),this.eventToCallbackMap[a].push(b)},_unbindNonQueryEventHandler:function(a,b){var c=this.eventToCallbackMap[a];if(void 0!==c)for(var d=0;d<c.length;d++)if(c[d]===b){c.splice(d,1);break}},_cleanUpEventCallbacksMap:function(){for(var a=Object.keys(this.eventToCallbackMap),b=0;b<a.length;b++){var c=a[b];delete this.eventToCallbackMap[c]}},_showTooltip:function(){this.options.tooltip_split===!1?(this._addClass(this.tooltip,"in"),this.tooltip_min.style.display="none",this.tooltip_max.style.display="none"):(this._addClass(this.tooltip_min,"in"),this._addClass(this.tooltip_max,"in"),this.tooltip.style.display="none"),this._state.over=!0},_hideTooltip:function(){this._state.inDrag===!1&&this.alwaysShowTooltip!==!0&&(this._removeClass(this.tooltip,"in"),this._removeClass(this.tooltip_min,"in"),this._removeClass(this.tooltip_max,"in")),this._state.over=!1},_setToolTipOnMouseOver:function(a){function b(a,b){return b?[100-a.percentage[0],this.options.range?100-a.percentage[1]:a.percentage[1]]:[a.percentage[0],a.percentage[1]]}var c=this.options.formatter(a?a.value[0]:this._state.value[0]),d=a?b(a,this.options.reversed):b(this._state,this.options.reversed);this._setText(this.tooltipInner,c),this.tooltip.style[this.stylePos]=d[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px")},_addTickListener:function(){return{addMouseEnter:function(a,b,c){var d=function(){var b=a._state,d=c>=0?c:this.attributes["aria-valuenow"].value,e=parseInt(d,10);b.value[0]=e,b.percentage[0]=a.options.ticks_positions[e],a._setToolTipOnMouseOver(b),a._showTooltip()};return b.addEventListener("mouseenter",d,!1),d},addMouseLeave:function(a,b){var c=function(){a._hideTooltip()};return b.addEventListener("mouseleave",c,!1),c}}},_layout:function(){var a;if(a=this.options.reversed?[100-this._state.percentage[0],this.options.range?100-this._state.percentage[1]:this._state.percentage[1]]:[this._state.percentage[0],this._state.percentage[1]],this.handle1.style[this.stylePos]=a[0]+"%",this.handle1.setAttribute("aria-valuenow",this._state.value[0]),isNaN(this.options.formatter(this._state.value[0]))&&this.handle1.setAttribute("aria-valuetext",this.options.formatter(this._state.value[0])),this.handle2.style[this.stylePos]=a[1]+"%",this.handle2.setAttribute("aria-valuenow",this._state.value[1]),isNaN(this.options.formatter(this._state.value[1]))&&this.handle2.setAttribute("aria-valuetext",this.options.formatter(this._state.value[1])),this.rangeHighlightElements.length>0&&Array.isArray(this.options.rangeHighlights)&&this.options.rangeHighlights.length>0)for(var b=0;b<this.options.rangeHighlights.length;b++){var c=this._toPercentage(this.options.rangeHighlights[b].start),d=this._toPercentage(this.options.rangeHighlights[b].end);if(this.options.reversed){var e=100-d;d=100-c,c=e}var f=this._createHighlightRange(c,d);f?"vertical"===this.options.orientation?(this.rangeHighlightElements[b].style.top=f.start+"%",this.rangeHighlightElements[b].style.height=f.size+"%"):(this.options.rtl?this.rangeHighlightElements[b].style.right=f.start+"%":this.rangeHighlightElements[b].style.left=f.start+"%",this.rangeHighlightElements[b].style.width=f.size+"%"):this.rangeHighlightElements[b].style.display="none"}if(Array.isArray(this.options.ticks)&&this.options.ticks.length>0){var g,h="vertical"===this.options.orientation?"height":"width";g="vertical"===this.options.orientation?"marginTop":this.options.rtl?"marginRight":"marginLeft";var i=this._state.size/(this.options.ticks.length-1);if(this.tickLabelContainer){var j=0;if(0===this.options.ticks_positions.length)"vertical"!==this.options.orientation&&(this.tickLabelContainer.style[g]=-i/2+"px"),j=this.tickLabelContainer.offsetHeight;else for(k=0;k<this.tickLabelContainer.childNodes.length;k++)this.tickLabelContainer.childNodes[k].offsetHeight>j&&(j=this.tickLabelContainer.childNodes[k].offsetHeight);"horizontal"===this.options.orientation&&(this.sliderElem.style.marginBottom=j+"px")}for(var k=0;k<this.options.ticks.length;k++){var l=this.options.ticks_positions[k]||this._toPercentage(this.options.ticks[k]);this.options.reversed&&(l=100-l),this.ticks[k].style[this.stylePos]=l+"%",this._removeClass(this.ticks[k],"in-selection"),this.options.range?l>=a[0]&&l<=a[1]&&this._addClass(this.ticks[k],"in-selection"):"after"===this.options.selection&&l>=a[0]?this._addClass(this.ticks[k],"in-selection"):"before"===this.options.selection&&l<=a[0]&&this._addClass(this.ticks[k],"in-selection"),this.tickLabels[k]&&(this.tickLabels[k].style[h]=i+"px","vertical"!==this.options.orientation&&void 0!==this.options.ticks_positions[k]?(this.tickLabels[k].style.position="absolute",this.tickLabels[k].style[this.stylePos]=l+"%",this.tickLabels[k].style[g]=-i/2+"px"):"vertical"===this.options.orientation&&(this.options.rtl?this.tickLabels[k].style.marginRight=this.sliderElem.offsetWidth+"px":this.tickLabels[k].style.marginLeft=this.sliderElem.offsetWidth+"px",this.tickLabelContainer.style[g]=this.sliderElem.offsetWidth/2*-1+"px"))}}var m;if(this.options.range){m=this.options.formatter(this._state.value),this._setText(this.tooltipInner,m),this.tooltip.style[this.stylePos]=(a[1]+a[0])/2+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px");var n=this.options.formatter(this._state.value[0]);this._setText(this.tooltipInner_min,n);var o=this.options.formatter(this._state.value[1]);this._setText(this.tooltipInner_max,o),this.tooltip_min.style[this.stylePos]=a[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip_min,"margin-"+this.stylePos,-this.tooltip_min.offsetHeight/2+"px"):this._css(this.tooltip_min,"margin-"+this.stylePos,-this.tooltip_min.offsetWidth/2+"px"),this.tooltip_max.style[this.stylePos]=a[1]+"%","vertical"===this.options.orientation?this._css(this.tooltip_max,"margin-"+this.stylePos,-this.tooltip_max.offsetHeight/2+"px"):this._css(this.tooltip_max,"margin-"+this.stylePos,-this.tooltip_max.offsetWidth/2+"px")}else m=this.options.formatter(this._state.value[0]),this._setText(this.tooltipInner,m),this.tooltip.style[this.stylePos]=a[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px");if("vertical"===this.options.orientation)this.trackLow.style.top="0",this.trackLow.style.height=Math.min(a[0],a[1])+"%",this.trackSelection.style.top=Math.min(a[0],a[1])+"%",this.trackSelection.style.height=Math.abs(a[0]-a[1])+"%",this.trackHigh.style.bottom="0",this.trackHigh.style.height=100-Math.min(a[0],a[1])-Math.abs(a[0]-a[1])+"%";else{"right"===this.stylePos?this.trackLow.style.right="0":this.trackLow.style.left="0",this.trackLow.style.width=Math.min(a[0],a[1])+"%","right"===this.stylePos?this.trackSelection.style.right=Math.min(a[0],a[1])+"%":this.trackSelection.style.left=Math.min(a[0],a[1])+"%",this.trackSelection.style.width=Math.abs(a[0]-a[1])+"%","right"===this.stylePos?this.trackHigh.style.left="0":this.trackHigh.style.right="0",this.trackHigh.style.width=100-Math.min(a[0],a[1])-Math.abs(a[0]-a[1])+"%";var p=this.tooltip_min.getBoundingClientRect(),q=this.tooltip_max.getBoundingClientRect();"bottom"===this.options.tooltip_position?p.right>q.left?(this._removeClass(this.tooltip_max,"bottom"),this._addClass(this.tooltip_max,"top"),this.tooltip_max.style.top="",this.tooltip_max.style.bottom="22px"):(this._removeClass(this.tooltip_max,"top"),this._addClass(this.tooltip_max,"bottom"),this.tooltip_max.style.top=this.tooltip_min.style.top,this.tooltip_max.style.bottom=""):p.right>q.left?(this._removeClass(this.tooltip_max,"top"),this._addClass(this.tooltip_max,"bottom"),this.tooltip_max.style.top="18px"):(this._removeClass(this.tooltip_max,"bottom"),this._addClass(this.tooltip_max,"top"),this.tooltip_max.style.top=this.tooltip_min.style.top)}},_createHighlightRange:function(a,b){return this._isHighlightRange(a,b)?a>b?{start:b,size:a-b}:{start:a,size:b-a}:null},_isHighlightRange:function(a,b){return a>=0&&100>=a&&b>=0&&100>=b?!0:!1},_resize:function(a){this._state.offset=this._offset(this.sliderElem),this._state.size=this.sliderElem[this.sizePos],this._layout()},_removeProperty:function(a,b){a.style.removeProperty?a.style.removeProperty(b):a.style.removeAttribute(b)},_mousedown:function(a){if(!this._state.enabled)return!1;this._state.offset=this._offset(this.sliderElem),this._state.size=this.sliderElem[this.sizePos];var b=this._getPercentage(a);if(this.options.range){var c=Math.abs(this._state.percentage[0]-b),d=Math.abs(this._state.percentage[1]-b);this._state.dragged=d>c?0:1,this._adjustPercentageForRangeSliders(b)}else this._state.dragged=0;this._state.percentage[this._state.dragged]=b,this._layout(),this.touchCapable&&(document.removeEventListener("touchmove",this.mousemove,!1),document.removeEventListener("touchend",this.mouseup,!1)),this.mousemove&&document.removeEventListener("mousemove",this.mousemove,!1),this.mouseup&&document.removeEventListener("mouseup",this.mouseup,!1),this.mousemove=this._mousemove.bind(this),this.mouseup=this._mouseup.bind(this),this.touchCapable&&(document.addEventListener("touchmove",this.mousemove,!1),document.addEventListener("touchend",this.mouseup,!1)),document.addEventListener("mousemove",this.mousemove,!1),document.addEventListener("mouseup",this.mouseup,!1),this._state.inDrag=!0;var e=this._calculateValue();return this._trigger("slideStart",e),this._setDataVal(e),this.setValue(e,!1,!0),a.returnValue=!1,this.options.focus&&this._triggerFocusOnHandle(this._state.dragged),!0},_touchstart:function(a){if(void 0===a.changedTouches)return void this._mousedown(a);var b=a.changedTouches[0];this.touchX=b.pageX,this.touchY=b.pageY},_triggerFocusOnHandle:function(a){0===a&&this.handle1.focus(),1===a&&this.handle2.focus()},_keydown:function(a,b){if(!this._state.enabled)return!1;var c;switch(b.keyCode){case 37:case 40:c=-1;break;case 39:case 38:c=1}if(c){if(this.options.natural_arrow_keys){var d="vertical"===this.options.orientation&&!this.options.reversed,e="horizontal"===this.options.orientation&&this.options.reversed;(d||e)&&(c=-c)}var f=this._state.value[a]+c*this.options.step,g=f/this.options.max*100;if(this._state.keyCtrl=a,this.options.range){this._adjustPercentageForRangeSliders(g);var h=this._state.keyCtrl?this._state.value[0]:f,i=this._state.keyCtrl?f:this._state.value[1];f=[h,i]}return this._trigger("slideStart",f),this._setDataVal(f),this.setValue(f,!0,!0),this._setDataVal(f),this._trigger("slideStop",f),this._layout(),this._pauseEvent(b),delete this._state.keyCtrl,!1}},_pauseEvent:function(a){a.stopPropagation&&a.stopPropagation(),a.preventDefault&&a.preventDefault(),a.cancelBubble=!0,a.returnValue=!1},_mousemove:function(a){if(!this._state.enabled)return!1;var b=this._getPercentage(a);this._adjustPercentageForRangeSliders(b),this._state.percentage[this._state.dragged]=b,this._layout();var c=this._calculateValue(!0);return this.setValue(c,!0,!0),!1},_touchmove:function(a){if(void 0!==a.changedTouches){var b=a.changedTouches[0],c=b.pageX-this.touchX,d=b.pageY-this.touchY;this._state.inDrag||("vertical"===this.options.orientation&&5>=c&&c>=-5&&(d>=15||-15>=d)?this._mousedown(a):5>=d&&d>=-5&&(c>=15||-15>=c)&&this._mousedown(a))}},_adjustPercentageForRangeSliders:function(a){if(this.options.range){var b=this._getNumDigitsAfterDecimalPlace(a);b=b?b-1:0;var c=this._applyToFixedAndParseFloat(a,b);0===this._state.dragged&&this._applyToFixedAndParseFloat(this._state.percentage[1],b)<c?(this._state.percentage[0]=this._state.percentage[1],this._state.dragged=1):1===this._state.dragged&&this._applyToFixedAndParseFloat(this._state.percentage[0],b)>c?(this._state.percentage[1]=this._state.percentage[0],this._state.dragged=0):0===this._state.keyCtrl&&this._state.value[1]/this.options.max*100<a?(this._state.percentage[0]=this._state.percentage[1],this._state.keyCtrl=1,this.handle2.focus()):1===this._state.keyCtrl&&this._state.value[0]/this.options.max*100>a&&(this._state.percentage[1]=this._state.percentage[0],this._state.keyCtrl=0,this.handle1.focus())}},_mouseup:function(){if(!this._state.enabled)return!1;this.touchCapable&&(document.removeEventListener("touchmove",this.mousemove,!1),document.removeEventListener("touchend",this.mouseup,!1)),document.removeEventListener("mousemove",this.mousemove,!1),document.removeEventListener("mouseup",this.mouseup,!1),this._state.inDrag=!1,this._state.over===!1&&this._hideTooltip();var a=this._calculateValue(!0);return this._layout(),this._setDataVal(a),this._trigger("slideStop",a),!1},_calculateValue:function(a){var b;if(this.options.range?(b=[this.options.min,this.options.max],0!==this._state.percentage[0]&&(b[0]=this._toValue(this._state.percentage[0]),b[0]=this._applyPrecision(b[0])),100!==this._state.percentage[1]&&(b[1]=this._toValue(this._state.percentage[1]),b[1]=this._applyPrecision(b[1]))):(b=this._toValue(this._state.percentage[0]),b=parseFloat(b),b=this._applyPrecision(b)),a){for(var c=[b,1/0],d=0;d<this.options.ticks.length;d++){
var e=Math.abs(this.options.ticks[d]-b);e<=c[1]&&(c=[this.options.ticks[d],e])}if(c[1]<=this.options.ticks_snap_bounds)return c[0]}return b},_applyPrecision:function(a){var b=this.options.precision||this._getNumDigitsAfterDecimalPlace(this.options.step);return this._applyToFixedAndParseFloat(a,b)},_getNumDigitsAfterDecimalPlace:function(a){var b=(""+a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);return b?Math.max(0,(b[1]?b[1].length:0)-(b[2]?+b[2]:0)):0},_applyToFixedAndParseFloat:function(a,b){var c=a.toFixed(b);return parseFloat(c)},_getPercentage:function(a){!this.touchCapable||"touchstart"!==a.type&&"touchmove"!==a.type||(a=a.touches[0]);var b=a[this.mousePos],c=this._state.offset[this.stylePos],d=b-c;"right"===this.stylePos&&(d=-d);var e=d/this._state.size*100;return e=Math.round(e/this._state.percentage[2])*this._state.percentage[2],this.options.reversed&&(e=100-e),Math.max(0,Math.min(100,e))},_validateInputValue:function(a){if(isNaN(+a)){if(Array.isArray(a))return this._validateArray(a),a;throw new Error(f.formatInvalidInputErrorMsg(a))}return+a},_validateArray:function(a){for(var b=0;b<a.length;b++){var c=a[b];if("number"!=typeof c)throw new Error(f.formatInvalidInputErrorMsg(c))}},_setDataVal:function(a){this.element.setAttribute("data-value",a),this.element.setAttribute("value",a),this.element.value=a},_trigger:function(b,c){c=c||0===c?c:void 0;var d=this.eventToCallbackMap[b];if(d&&d.length)for(var e=0;e<d.length;e++){var f=d[e];f(c)}a&&this._triggerJQueryEvent(b,c)},_triggerJQueryEvent:function(a,b){var c={type:a,value:b};this.$element.trigger(c),this.$sliderElem.trigger(c)},_unbindJQueryEventHandlers:function(){this.$element.off(),this.$sliderElem.off()},_setText:function(a,b){"undefined"!=typeof a.textContent?a.textContent=b:"undefined"!=typeof a.innerText&&(a.innerText=b)},_removeClass:function(a,b){for(var c=b.split(" "),d=a.className,e=0;e<c.length;e++){var f=c[e],g=new RegExp("(?:\\s|^)"+f+"(?:\\s|$)");d=d.replace(g," ")}a.className=d.trim()},_addClass:function(a,b){for(var c=b.split(" "),d=a.className,e=0;e<c.length;e++){var f=c[e],g=new RegExp("(?:\\s|^)"+f+"(?:\\s|$)"),h=g.test(d);h||(d+=" "+f)}a.className=d.trim()},_offsetLeft:function(a){return a.getBoundingClientRect().left},_offsetRight:function(a){return a.getBoundingClientRect().right},_offsetTop:function(a){for(var b=a.offsetTop;(a=a.offsetParent)&&!isNaN(a.offsetTop);)b+=a.offsetTop,"BODY"!==a.tagName&&(b-=a.scrollTop);return b},_offset:function(a){return{left:this._offsetLeft(a),right:this._offsetRight(a),top:this._offsetTop(a)}},_css:function(b,c,d){if(a)a.style(b,c,d);else{var e=c.replace(/^-ms-/,"ms-").replace(/-([\da-z])/gi,function(a,b){return b.toUpperCase()});b.style[e]=d}},_toValue:function(a){return this.options.scale.toValue.apply(this,[a])},_toPercentage:function(a){return this.options.scale.toPercentage.apply(this,[a])},_setTooltipPosition:function(){var a=[this.tooltip,this.tooltip_min,this.tooltip_max];if("vertical"===this.options.orientation){var b;b=this.options.tooltip_position?this.options.tooltip_position:this.options.rtl?"left":"right";var c="left"===b?"right":"left";a.forEach(function(a){this._addClass(a,b),a.style[c]="100%"}.bind(this))}else"bottom"===this.options.tooltip_position?a.forEach(function(a){this._addClass(a,"bottom"),a.style.top="22px"}.bind(this)):a.forEach(function(a){this._addClass(a,"top"),a.style.top=-this.tooltip.outerHeight-14+"px"}.bind(this))}},a&&a.fn){var h=void 0;a.fn.slider?(windowIsDefined&&window.console.warn("bootstrap-slider.js - WARNING: $.fn.slider namespace is already bound. Use the $.fn.bootstrapSlider namespace instead."),h=c):(a.bridget(b,d),h=b),a.bridget(c,d),a(function(){a("input[data-provide=slider]")[h]()})}}(a),d});

/***/ }),

/***/ "uNFy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PlaceMarkInput__ = __webpack_require__("ZiTu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataSave__ = __webpack_require__("3hyP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DrawToolBar',
    props: {
        userData: {
            default: ''
        }
    },
    data: function data() {
        return {
            msg: 'This is Draw Tool Bar!',
            isShowDataSaveDialog: false,
            isShowPlaceMarkInputDialog: false,
            isshowposition: true,
            transmissionData: {},
            drawFlag: 0,
            drawDataName: "draw_",
            coordinate: {
                lon: "-1.8402538",
                lat: "-0.4820130",
                h: "-4269.87"
            },
            is_create_entity: false,
            is_show_measure: false,
            is_show_draw: false,
            is_clicked_draw: false,
            is_clicked_measure: false,
            geometry_type: ''
        };
    },

    mounted: function mounted() {
        //add listener
        this.createDrawTool("draw_option");
        $('.boder-color').colorpicker({
            format: 'rgb'
        });

        $('.boder-color').colorpicker().on("changeColor", function (ev) {
            var middle = ev.color.toRGB();
            var linecolor = [];
            linecolor[0] = middle.r / 255;
            linecolor[1] = middle.g / 255;
            linecolor[2] = middle.b / 255;
            pfAirViewer._drawtool.color = linecolor;
        });

        $("#ex6").slider();
        $("#ex6").on("slide", function (slideEvt) {
            $("#ex6SliderVal").text(slideEvt.value);
            pfAirViewer._drawtool.linewidth = slideEvt.value;
        });
        $("#draw_dlg .btn").click(function () {
            $('#draw_dlg').modal('hide');
        });
    },
    methods: {

        prevent_click: function prevent_click(event) {
            event.cancelBubble = true;
        },
        draw_function: function draw_function() {

            if (this.is_clicked_measure) {
                this.is_clicked_measure = false;
                this.is_show_measure = false;
            }

            this.is_show_draw = !this.is_show_draw;
            this.is_clicked_draw = !this.is_clicked_draw;
        },

        measure_function: function measure_function() {

            if (this.is_clicked_draw) {
                this.is_clicked_draw = false;
                this.is_show_draw = false;
            }

            this.is_show_measure = !this.is_show_measure;
            this.is_clicked_measure = !this.is_clicked_measure;
        },

        create_entity: function create_entity() {
            event.cancelBubble = true;
            this.is_create_entity = !this.is_create_entity;

            if (this.is_create_entity) {
                //$('#entity').css('display','none');
                //$('#measure').css('display','none');
                pfAirViewer._drawtool.convert2entity = true;
            } else {
                //$('#entity').css('display','block');
                //$('#measure').css('display','block');
                pfAirViewer._drawtool.convert2entity = false;
            }
        },
        createDrawTool: function createDrawTool(doomId) {
            var div_array = $("div").children(".draw_button");
            var toolBar = pfAirViewer.createDrawTool(doomId, div_array);
            toolBar.addListener('markerCreated', this.placeMarkCreated);
            toolBar.addListener('measure_distance', pfAirViewer._callBack.on_Measure.bind(pfAirViewer._callBack));
            //toolBar.addListener('measure_area', pfAirViewer._callBack.on_MeasureArea.bind(pfAirViewer._callBack));
            //toolBar.addListener('polylineCreated', pfAirViewer._callBack.on_Draw_Line.bind());
            toolBar.addListener('polylineCreated', this.createPolyline);
            toolBar.addListener('polygonCreated', this.createPolygon);
            toolBar.addListener('settingDraw', this.drawSetting);
            toolBar.addListener('saveData', this.saveData);
            toolBar.addListener('remove', this.removeData);
            toolBar.addListener('convert_entity_from_primitive', this.convert_entity_from_primitive);
        },
        createPolyline: function createPolyline(event) {
            pfAirViewer._callBack.on_Draw_Line(event);
            var layerName = this.drawDataName + this.drawFlag;
            this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'primitive';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._drawDataList.get(pfAirViewer._drawDataList.length - 1);
            pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");
            eventBus.$emit('addModelPanel', {
                name: layerName,
                type: "Draw_P_Data"
            });
        },
        createPolygon: function createPolygon(event) {
            pfAirViewer._callBack.on_Draw_Polygon(event);
            var layerName = this.drawDataName + this.drawFlag;
            this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'primitive';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._drawDataList.get(pfAirViewer._drawDataList.length - 1);
            pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");
            eventBus.$emit('addModelPanel', {
                name: layerName,
                type: "Draw_P_Data",
                polygonArea: undefined
            });
        },
        convert_entity_from_primitive: function convert_entity_from_primitive(event) {
            //debugger;
            pfAirViewer._callBack.change_primitive(event);
            this.geometry_type = event.type;
            this.isShowPlaceMarkInputDialog = true;
            this.isshowposition = false;
        },
        placeMarkCreated: function placeMarkCreated(event) {
            pfAirViewer._callBack.on_Draw_Placemark(event);
            this.isShowPlaceMarkInputDialog = true;
            this.isshowposition = true;
            this.transmissionData.position = event.position;
            this.geometry_type = undefined;
        },
        createPlaceMark: function createPlaceMark(placeMark) {
            //wfc start
            var pmDecJson = {};
            pmDecJson.name = placeMark.name;
            pmDecJson.type = placeMark.type;
            pmDecJson.text = placeMark.description;
            pmDecJson.vedios = placeMark.vedios;

            //pfAirViewer._tempPlacemarksEntity.description = pmDecJson;
            //end
            if (this.geometry_type == 'line') {
                pfAirViewer._current_entity.description = pmDecJson;
            } else if (this.geometry_type == 'polygon') {
                pfAirViewer._current_entity.description = pmDecJson;
                if (pfAirViewer._current_entity.polygon.material.color instanceof Cesium.ConstantProperty) {
                    var color = pfAirViewer._current_entity.polygon.material.color.getValue();
                    color.alpha = 0.6;
                    pfAirViewer._current_entity.polygon.material.color.setValue(color);
                }
            } else {
                // create a single placemark
                pfAirViewer._current_entity.description = pmDecJson;
                pfAirViewer._current_entity.position = placeMark.coordinate;
            }
            Cesium.Resource.fetchImage(pfAirViewer._dataSave._placeMarkImage[pmDecJson.type]).then(function (image) {
                pfAirViewer._current_entity.billboard.image.setValue(image);
            }).otherwise(function (error) {
                //an error occurred
            });

            var layerName = this.drawDataName + this.drawFlag;
            this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'entity';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._current_entity;
            pfAirViewer._drawLayerManager.addLayerData(layerName, drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName, "show");
            eventBus.$emit('addModelPanel', {
                name: layerName,
                type: "Draw_E_Data"
            });

            this.isShowPlaceMarkInputDialog = false;
        },
        closeInput: function closeInput() {
            //close placemark input attribute dialog
            //remove entity & restore primitive
            if (pfAirViewer._current_entity.polygon) {

                var polygon = new Cesium.AirDrawPolygon({
                    positions: pfAirViewer._current_entity.polygon.hierarchy.valueOf().positions,
                    //width: pfAirViewer._drawtool.linewidth,
                    geodesic: false
                });
                //pfAirViewer.scene.primitives.add(polygon);
                pfAirViewer.drawList.add(polygon);
                polygon.setEditable();
            } else if (pfAirViewer._current_entity.polyline) {

                var line = new Cesium.AirDrawPolyline({
                    positions: pfAirViewer._current_entity.polyline.positions.valueOf(),
                    width: pfAirViewer._drawtool.linewidth,
                    geodesic: false
                });
                //pfAirViewer.scene.primitives.add(line);
                pfAirViewer.drawList.add(line);
                line.setEditable();
            } else {
                //pfAirViewer.drawList.pop();
                //other
            }

            this.isShowPlaceMarkInputDialog = false;
            pfAirViewer.entities.remove(pfAirViewer._current_entity);
            //pfAirViewer._drawPlacemarks.pop();
        },
        closeDataSave: function closeDataSave() {
            this.isShowDataSaveDialog = false;
        },
        drawSetting: function drawSetting() {
            $('#draw_dlg').modal();
            $('#draw_dlg').appendTo('body');
        },
        saveData: function saveData() {
            if (this.userData.userInfo.isGuest === "no") {
                this.isShowDataSaveDialog = true;
            }
        },
        removeData: function removeData() {
            pfAirViewer._callBack.on_Draw_remove();
            //eventBus.$emit('removePanel');
            //debugger;
        }
    },
    components: {
        PlaceMarkInput: __WEBPACK_IMPORTED_MODULE_0__components_PlaceMarkInput__["a" /* default */],
        DataSave: __WEBPACK_IMPORTED_MODULE_1__components_DataSave__["a" /* default */]
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
var Login = __webpack_require__("nKb+");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a6fb3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login"},[_c('div',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('span',{staticClass:"exit",on:{"click":function($event){_vm.close()}}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"DataInfo"},[_c('div',{staticClass:"gray_border round_s scollbarY"},[_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"User Name"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})]),_vm._v(" "),_c('ul',{staticClass:"r_list"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userPassword),expression:"userPassword"}],staticClass:"fill_text box_size round_s",attrs:{"type":"text","placeholder":"User PassWord"},domProps:{"value":(_vm.userPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userPassword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"r_d_btn btn_layer cf2"},[_c('span',{staticClass:"l w_5"},[_c('input',{staticClass:"round_s fill_btn_r blue_btn_b",attrs:{"type":"button","value":"LOGIN"},on:{"click":_vm.login}})]),_vm._v(" "),_c('span',{staticClass:"r w_5"},[_c('input',{staticClass:"round_s fill_btn_r gray_btn_g",attrs:{"type":"button","value":"CANCEL"},on:{"click":_vm.close}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Login = (esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__("X13v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19a6fb3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Login["a" /* default */],
  components_Login,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Login = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xkmt":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Bootstrap Colorpicker v2.5.1
 * https://itsjavi.com/bootstrap-colorpicker/
 */
!function(a,b){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("4kSj")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(a){return b(a)}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("jquery")):jQuery&&!jQuery.fn.colorpicker&&b(jQuery)}(this,function(a){"use strict";var b=function(c,d,e,f,g){this.fallbackValue=e?e&&"undefined"!=typeof e.h?e:this.value={h:0,s:0,b:0,a:1}:null,this.fallbackFormat=f?f:"rgba",this.hexNumberSignPrefix=g===!0,this.value=this.fallbackValue,this.origFormat=null,this.predefinedColors=d?d:{},this.colors=a.extend({},b.webColors,this.predefinedColors),c&&("undefined"!=typeof c.h?this.value=c:this.setColor(String(c))),this.value||(this.value={h:0,s:0,b:0,a:1})};b.webColors={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32",transparent:"transparent"},b.prototype={constructor:b,colors:{},predefinedColors:{},getValue:function(){return this.value},setValue:function(a){this.value=a},_sanitizeNumber:function(a){return"number"==typeof a?a:isNaN(a)||null===a||""===a||void 0===a?1:""===a?0:"undefined"!=typeof a.toLowerCase?(a.match(/^\./)&&(a="0"+a),Math.ceil(100*parseFloat(a))/100):1},isTransparent:function(a){return!(!a||!("string"==typeof a||a instanceof String))&&(a=a.toLowerCase().trim(),"transparent"===a||a.match(/#?00000000/)||a.match(/(rgba|hsla)\(0,0,0,0?\.?0\)/))},rgbaIsTransparent:function(a){return 0===a.r&&0===a.g&&0===a.b&&0===a.a},setColor:function(a){if(a=a.toLowerCase().trim()){if(this.isTransparent(a))return this.value={h:0,s:0,b:0,a:0},!0;var b=this.parse(a);b?(this.value=this.value={h:b.h,s:b.s,b:b.b,a:b.a},this.origFormat||(this.origFormat=b.format)):this.fallbackValue&&(this.value=this.fallbackValue)}return!1},setHue:function(a){this.value.h=1-a},setSaturation:function(a){this.value.s=a},setBrightness:function(a){this.value.b=1-a},setAlpha:function(a){this.value.a=Math.round(parseInt(100*(1-a),10)/100*100)/100},toRGB:function(a,b,c,d){0===arguments.length&&(a=this.value.h,b=this.value.s,c=this.value.b,d=this.value.a),a*=360;var e,f,g,h,i;return a=a%360/60,i=c*b,h=i*(1-Math.abs(a%2-1)),e=f=g=c-i,a=~~a,e+=[i,h,0,0,h,i][a],f+=[h,i,i,h,0,0][a],g+=[0,0,h,i,i,h][a],{r:Math.round(255*e),g:Math.round(255*f),b:Math.round(255*g),a:d}},toHex:function(a,b,c,d){0===arguments.length&&(a=this.value.h,b=this.value.s,c=this.value.b,d=this.value.a);var e=this.toRGB(a,b,c,d);if(this.rgbaIsTransparent(e))return"transparent";var f=(this.hexNumberSignPrefix?"#":"")+((1<<24)+(parseInt(e.r)<<16)+(parseInt(e.g)<<8)+parseInt(e.b)).toString(16).slice(1);return f},toHSL:function(a,b,c,d){0===arguments.length&&(a=this.value.h,b=this.value.s,c=this.value.b,d=this.value.a);var e=a,f=(2-b)*c,g=b*c;return g/=f>0&&f<=1?f:2-f,f/=2,g>1&&(g=1),{h:isNaN(e)?0:e,s:isNaN(g)?0:g,l:isNaN(f)?0:f,a:isNaN(d)?0:d}},toAlias:function(a,b,c,d){var e,f=0===arguments.length?this.toHex():this.toHex(a,b,c,d),g="alias"===this.origFormat?f:this.toString(this.origFormat,!1);for(var h in this.colors)if(e=this.colors[h].toLowerCase().trim(),e===f||e===g)return h;return!1},RGBtoHSB:function(a,b,c,d){a/=255,b/=255,c/=255;var e,f,g,h;return g=Math.max(a,b,c),h=g-Math.min(a,b,c),e=0===h?null:g===a?(b-c)/h:g===b?(c-a)/h+2:(a-b)/h+4,e=(e+360)%6*60/360,f=0===h?0:h/g,{h:this._sanitizeNumber(e),s:f,b:g,a:this._sanitizeNumber(d)}},HueToRGB:function(a,b,c){return c<0?c+=1:c>1&&(c-=1),6*c<1?a+(b-a)*c*6:2*c<1?b:3*c<2?a+(b-a)*(2/3-c)*6:a},HSLtoRGB:function(a,b,c,d){b<0&&(b=0);var e;e=c<=.5?c*(1+b):c+b-c*b;var f=2*c-e,g=a+1/3,h=a,i=a-1/3,j=Math.round(255*this.HueToRGB(f,e,g)),k=Math.round(255*this.HueToRGB(f,e,h)),l=Math.round(255*this.HueToRGB(f,e,i));return[j,k,l,this._sanitizeNumber(d)]},parse:function(b){if(0===arguments.length)return!1;var c,d,e=this,f=!1,g="undefined"!=typeof this.colors[b];return g&&(b=this.colors[b].toLowerCase().trim()),a.each(this.stringParsers,function(a,h){var i=h.re.exec(b);return c=i&&h.parse.apply(e,[i]),!c||(f={},d=g?"alias":h.format?h.format:e.getValidFallbackFormat(),f=d.match(/hsla?/)?e.RGBtoHSB.apply(e,e.HSLtoRGB.apply(e,c)):e.RGBtoHSB.apply(e,c),f instanceof Object&&(f.format=d),!1)}),f},getValidFallbackFormat:function(){var a=["rgba","rgb","hex","hsla","hsl"];return this.origFormat&&a.indexOf(this.origFormat)!==-1?this.origFormat:this.fallbackFormat&&a.indexOf(this.fallbackFormat)!==-1?this.fallbackFormat:"rgba"},toString:function(a,c){a=a||this.origFormat||this.fallbackFormat,c=c||!1;var d=!1;switch(a){case"rgb":return d=this.toRGB(),this.rgbaIsTransparent(d)?"transparent":"rgb("+d.r+","+d.g+","+d.b+")";case"rgba":return d=this.toRGB(),"rgba("+d.r+","+d.g+","+d.b+","+d.a+")";case"hsl":return d=this.toHSL(),"hsl("+Math.round(360*d.h)+","+Math.round(100*d.s)+"%,"+Math.round(100*d.l)+"%)";case"hsla":return d=this.toHSL(),"hsla("+Math.round(360*d.h)+","+Math.round(100*d.s)+"%,"+Math.round(100*d.l)+"%,"+d.a+")";case"hex":return this.toHex();case"alias":return d=this.toAlias(),d===!1?this.toString(this.getValidFallbackFormat()):c&&!(d in b.webColors)&&d in this.predefinedColors?this.predefinedColors[d]:d;default:return d}},stringParsers:[{re:/rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,format:"rgb",parse:function(a){return[a[1],a[2],a[3],1]}},{re:/rgb\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,format:"rgb",parse:function(a){return[2.55*a[1],2.55*a[2],2.55*a[3],1]}},{re:/rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,format:"rgba",parse:function(a){return[a[1],a[2],a[3],a[4]]}},{re:/rgba\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,format:"rgba",parse:function(a){return[2.55*a[1],2.55*a[2],2.55*a[3],a[4]]}},{re:/hsl\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,format:"hsl",parse:function(a){return[a[1]/360,a[2]/100,a[3]/100,a[4]]}},{re:/hsla\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,format:"hsla",parse:function(a){return[a[1]/360,a[2]/100,a[3]/100,a[4]]}},{re:/#?([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,format:"hex",parse:function(a){return[parseInt(a[1],16),parseInt(a[2],16),parseInt(a[3],16),1]}},{re:/#?([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,format:"hex",parse:function(a){return[parseInt(a[1]+a[1],16),parseInt(a[2]+a[2],16),parseInt(a[3]+a[3],16),1]}}],colorNameToHex:function(a){return"undefined"!=typeof this.colors[a.toLowerCase()]&&this.colors[a.toLowerCase()]}};var c={horizontal:!1,inline:!1,color:!1,format:!1,input:"input",container:!1,component:".add-on, .input-group-addon",fallbackColor:!1,fallbackFormat:"hex",hexNumberSignPrefix:!0,sliders:{saturation:{maxLeft:100,maxTop:100,callLeft:"setSaturation",callTop:"setBrightness"},hue:{maxLeft:0,maxTop:100,callLeft:!1,callTop:"setHue"},alpha:{maxLeft:0,maxTop:100,callLeft:!1,callTop:"setAlpha"}},slidersHorz:{saturation:{maxLeft:100,maxTop:100,callLeft:"setSaturation",callTop:"setBrightness"},hue:{maxLeft:100,maxTop:0,callLeft:"setHue",callTop:!1},alpha:{maxLeft:100,maxTop:0,callLeft:"setAlpha",callTop:!1}},template:'<div class="colorpicker dropdown-menu"><div class="colorpicker-saturation"><i><b></b></i></div><div class="colorpicker-hue"><i></i></div><div class="colorpicker-alpha"><i></i></div><div class="colorpicker-color"><div /></div><div class="colorpicker-selectors"></div></div>',align:"right",customClass:null,colorSelectors:null},d=function(b,d){this.element=a(b).addClass("colorpicker-element"),this.options=a.extend(!0,{},c,this.element.data(),d),this.component=this.options.component,this.component=this.component!==!1&&this.element.find(this.component),this.component&&0===this.component.length&&(this.component=!1),this.container=this.options.container===!0?this.element:this.options.container,this.container=this.container!==!1&&a(this.container),this.input=this.element.is("input")?this.element:!!this.options.input&&this.element.find(this.options.input),this.input&&0===this.input.length&&(this.input=!1),this.color=this.createColor(this.options.color!==!1?this.options.color:this.getValue()),this.format=this.options.format!==!1?this.options.format:this.color.origFormat,this.options.color!==!1&&(this.updateInput(this.color),this.updateData(this.color));var e=this.picker=a(this.options.template);if(this.options.customClass&&e.addClass(this.options.customClass),this.options.inline?e.addClass("colorpicker-inline colorpicker-visible"):e.addClass("colorpicker-hidden"),this.options.horizontal&&e.addClass("colorpicker-horizontal"),["rgba","hsla","alias"].indexOf(this.format)===-1&&this.options.format!==!1&&"transparent"!==this.getValue()||e.addClass("colorpicker-with-alpha"),"right"===this.options.align&&e.addClass("colorpicker-right"),this.options.inline===!0&&e.addClass("colorpicker-no-arrow"),this.options.colorSelectors){var f=this,g=f.picker.find(".colorpicker-selectors");g.length>0&&(a.each(this.options.colorSelectors,function(b,c){var d=a("<i />").addClass("colorpicker-selectors-color").css("background-color",c).data("class",b).data("alias",b);d.on("mousedown.colorpicker touchstart.colorpicker",function(b){b.preventDefault(),f.setValue("alias"===f.format?a(this).data("alias"):a(this).css("background-color"))}),g.append(d)}),g.show().addClass("colorpicker-visible"))}e.on("mousedown.colorpicker touchstart.colorpicker",a.proxy(function(a){a.target===a.currentTarget&&a.preventDefault()},this)),e.find(".colorpicker-saturation, .colorpicker-hue, .colorpicker-alpha").on("mousedown.colorpicker touchstart.colorpicker",a.proxy(this.mousedown,this)),e.appendTo(this.container?this.container:a("body")),this.input!==!1&&(this.input.on({"keyup.colorpicker":a.proxy(this.keyup,this)}),this.input.on({"change.colorpicker":a.proxy(this.change,this)}),this.component===!1&&this.element.on({"focus.colorpicker":a.proxy(this.show,this)}),this.options.inline===!1&&this.element.on({"focusout.colorpicker":a.proxy(this.hide,this)})),this.component!==!1&&this.component.on({"click.colorpicker":a.proxy(this.show,this)}),this.input===!1&&this.component===!1&&this.element.on({"click.colorpicker":a.proxy(this.show,this)}),this.input!==!1&&this.component!==!1&&"color"===this.input.attr("type")&&this.input.on({"click.colorpicker":a.proxy(this.show,this),"focus.colorpicker":a.proxy(this.show,this)}),this.update(),a(a.proxy(function(){this.element.trigger("create")},this))};d.Color=b,d.prototype={constructor:d,destroy:function(){this.picker.remove(),this.element.removeData("colorpicker","color").off(".colorpicker"),this.input!==!1&&this.input.off(".colorpicker"),this.component!==!1&&this.component.off(".colorpicker"),this.element.removeClass("colorpicker-element"),this.element.trigger({type:"destroy"})},reposition:function(){if(this.options.inline!==!1||this.options.container)return!1;var a=this.container&&this.container[0]!==window.document.body?"position":"offset",b=this.component||this.element,c=b[a]();"right"===this.options.align&&(c.left-=this.picker.outerWidth()-b.outerWidth()),this.picker.css({top:c.top+b.outerHeight(),left:c.left})},show:function(b){this.isDisabled()||(this.picker.addClass("colorpicker-visible").removeClass("colorpicker-hidden"),this.reposition(),a(window).on("resize.colorpicker",a.proxy(this.reposition,this)),!b||this.hasInput()&&"color"!==this.input.attr("type")||b.stopPropagation&&b.preventDefault&&(b.stopPropagation(),b.preventDefault()),!this.component&&this.input||this.options.inline!==!1||a(window.document).on({"mousedown.colorpicker":a.proxy(this.hide,this)}),this.element.trigger({type:"showPicker",color:this.color}))},hide:function(b){return("undefined"==typeof b||!b.target||!(a(b.currentTarget).parents(".colorpicker").length>0||a(b.target).parents(".colorpicker").length>0))&&(this.picker.addClass("colorpicker-hidden").removeClass("colorpicker-visible"),a(window).off("resize.colorpicker",this.reposition),a(window.document).off({"mousedown.colorpicker":this.hide}),this.update(),void this.element.trigger({type:"hidePicker",color:this.color}))},updateData:function(a){return a=a||this.color.toString(this.format,!1),this.element.data("color",a),a},updateInput:function(a){return a=a||this.color.toString(this.format,!1),this.input!==!1&&(this.input.prop("value",a),this.input.trigger("change")),a},updatePicker:function(a){"undefined"!=typeof a&&(this.color=this.createColor(a));var b=this.options.horizontal===!1?this.options.sliders:this.options.slidersHorz,c=this.picker.find("i");if(0!==c.length)return this.options.horizontal===!1?(b=this.options.sliders,c.eq(1).css("top",b.hue.maxTop*(1-this.color.value.h)).end().eq(2).css("top",b.alpha.maxTop*(1-this.color.value.a))):(b=this.options.slidersHorz,c.eq(1).css("left",b.hue.maxLeft*(1-this.color.value.h)).end().eq(2).css("left",b.alpha.maxLeft*(1-this.color.value.a))),c.eq(0).css({top:b.saturation.maxTop-this.color.value.b*b.saturation.maxTop,left:this.color.value.s*b.saturation.maxLeft}),this.picker.find(".colorpicker-saturation").css("backgroundColor",(this.options.hexNumberSignPrefix?"":"#")+this.color.toHex(this.color.value.h,1,1,1)),this.picker.find(".colorpicker-alpha").css("backgroundColor",(this.options.hexNumberSignPrefix?"":"#")+this.color.toHex()),this.picker.find(".colorpicker-color, .colorpicker-color div").css("backgroundColor",this.color.toString(this.format,!0)),a},updateComponent:function(a){var b;if(b="undefined"!=typeof a?this.createColor(a):this.color,this.component!==!1){var c=this.component.find("i").eq(0);c.length>0?c.css({backgroundColor:b.toString(this.format,!0)}):this.component.css({backgroundColor:b.toString(this.format,!0)})}return b.toString(this.format,!1)},update:function(a){var b;return this.getValue(!1)===!1&&a!==!0||(b=this.updateComponent(),this.updateInput(b),this.updateData(b),this.updatePicker()),b},setValue:function(a){this.color=this.createColor(a),this.update(!0),this.element.trigger({type:"changeColor",color:this.color,value:a})},createColor:function(a){return new b(a?a:null,this.options.colorSelectors,this.options.fallbackColor?this.options.fallbackColor:this.color,this.options.fallbackFormat,this.options.hexNumberSignPrefix)},getValue:function(a){a="undefined"==typeof a?this.options.fallbackColor:a;var b;return b=this.hasInput()?this.input.val():this.element.data("color"),void 0!==b&&""!==b&&null!==b||(b=a),b},hasInput:function(){return this.input!==!1},isDisabled:function(){return!!this.hasInput()&&this.input.prop("disabled")===!0},disable:function(){return!!this.hasInput()&&(this.input.prop("disabled",!0),this.element.trigger({type:"disable",color:this.color,value:this.getValue()}),!0)},enable:function(){return!!this.hasInput()&&(this.input.prop("disabled",!1),this.element.trigger({type:"enable",color:this.color,value:this.getValue()}),!0)},currentSlider:null,mousePointer:{left:0,top:0},mousedown:function(b){!b.pageX&&!b.pageY&&b.originalEvent&&b.originalEvent.touches&&(b.pageX=b.originalEvent.touches[0].pageX,b.pageY=b.originalEvent.touches[0].pageY),b.stopPropagation(),b.preventDefault();var c=a(b.target),d=c.closest("div"),e=this.options.horizontal?this.options.slidersHorz:this.options.sliders;if(!d.is(".colorpicker")){if(d.is(".colorpicker-saturation"))this.currentSlider=a.extend({},e.saturation);else if(d.is(".colorpicker-hue"))this.currentSlider=a.extend({},e.hue);else{if(!d.is(".colorpicker-alpha"))return!1;this.currentSlider=a.extend({},e.alpha)}var f=d.offset();this.currentSlider.guide=d.find("i")[0].style,this.currentSlider.left=b.pageX-f.left,this.currentSlider.top=b.pageY-f.top,this.mousePointer={left:b.pageX,top:b.pageY},a(window.document).on({"mousemove.colorpicker":a.proxy(this.mousemove,this),"touchmove.colorpicker":a.proxy(this.mousemove,this),"mouseup.colorpicker":a.proxy(this.mouseup,this),"touchend.colorpicker":a.proxy(this.mouseup,this)}).trigger("mousemove")}return!1},mousemove:function(a){!a.pageX&&!a.pageY&&a.originalEvent&&a.originalEvent.touches&&(a.pageX=a.originalEvent.touches[0].pageX,a.pageY=a.originalEvent.touches[0].pageY),a.stopPropagation(),a.preventDefault();var b=Math.max(0,Math.min(this.currentSlider.maxLeft,this.currentSlider.left+((a.pageX||this.mousePointer.left)-this.mousePointer.left))),c=Math.max(0,Math.min(this.currentSlider.maxTop,this.currentSlider.top+((a.pageY||this.mousePointer.top)-this.mousePointer.top)));return this.currentSlider.guide.left=b+"px",this.currentSlider.guide.top=c+"px",this.currentSlider.callLeft&&this.color[this.currentSlider.callLeft].call(this.color,b/this.currentSlider.maxLeft),this.currentSlider.callTop&&this.color[this.currentSlider.callTop].call(this.color,c/this.currentSlider.maxTop),this.options.format!==!1||"setAlpha"!==this.currentSlider.callTop&&"setAlpha"!==this.currentSlider.callLeft||(1!==this.color.value.a?(this.format="rgba",this.color.origFormat="rgba"):(this.format="hex",this.color.origFormat="hex")),this.update(!0),this.element.trigger({type:"changeColor",color:this.color}),!1},mouseup:function(b){return b.stopPropagation(),b.preventDefault(),a(window.document).off({"mousemove.colorpicker":this.mousemove,"touchmove.colorpicker":this.mousemove,"mouseup.colorpicker":this.mouseup,"touchend.colorpicker":this.mouseup}),!1},change:function(a){this.keyup(a)},keyup:function(a){38===a.keyCode?(this.color.value.a<1&&(this.color.value.a=Math.round(100*(this.color.value.a+.01))/100),this.update(!0)):40===a.keyCode?(this.color.value.a>0&&(this.color.value.a=Math.round(100*(this.color.value.a-.01))/100),this.update(!0)):(this.color=this.createColor(this.input.val()),this.color.origFormat&&this.options.format===!1&&(this.format=this.color.origFormat),this.getValue(!1)!==!1&&(this.updateData(),this.updateComponent(),this.updatePicker())),this.element.trigger({type:"changeColor",color:this.color,value:this.input.val()})}},a.colorpicker=d,a.fn.colorpicker=function(b){var c=Array.prototype.slice.call(arguments,1),e=1===this.length,f=null,g=this.each(function(){var e=a(this),g=e.data("colorpicker"),h="object"==typeof b?b:{};g||(g=new d(this,h),e.data("colorpicker",g)),"string"==typeof b?a.isFunction(g[b])?f=g[b].apply(g,c):(c.length&&(g[b]=c[0]),f=g[b]):f=e});return e?f:g},a.fn.colorpicker.constructor=d});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.11433993b9b2b3a3c54c.js